export const nigeria = [
  {
    d: "m 291.01165,491.65874 0.6,0.77 4.83,-0.89 2.71,0.27 2.05,1.34 0.33,1.46 0,0 0.07,4.36 -0.55,2.86 0.05,0.73 0.94,1.03 14.09,0.86 1.24,1.86 0.22,2.19 0.7,1.04 3.21,2.33 1.34,0.21 0,0 1.08,1.29 -0.59,3.72 0.15,3.78 1.37,4.63 0.73,1.68 1.71,2 0.76,2.55 -0.6,1.21 -3.42,-0.76 0,0 -2.69,-2.61 -2.54,-0.84 -2.76,-2.14 -0.58,-2.11 -1.19,-1.47 -3.4,-0.91 -2.42,0.14 -0.28,0.91 0.53,3.51 -1.84,5.1 0.32,0.45 2.23,-0.16 -0.7,2.44 -0.73,0.9 -6.08,-0.16 -1.1,0.98 -0.07,0.75 1.07,1.94 -1.21,5.81 -0.03,2.4 0.66,2.49 -1.17,2.89 -2.52,1.94 0.09,0.77 -0.47,0.64 0.22,1.47 0.59,0.67 0.02,1.17 -0.67,1.62 1.79,3.37 0.13,1.85 0,0 -2.36,-1.79 -2.94,-1.41 -1.8,0.43 -3.28,-1.22 -2.79,0.12 -1.11,0.64 -3.13,0.58 -1.8,-0.27 -1.45,-1.41 -0.59,-1.1 0.16,-1.1 1.37,-3.7 3.42,-4.33 2.39,-4.19 -0.05,-2.78 -0.66,-1.72 -0.54,-0.05 0,0 3.09,-10.25 2.1,-3.87 1.82,-1.68 1.18,-3.04 0.89,-0.9 0.43,-2.01 -0.36,-3.45 0.28,-2.05 -1.51,-2.44 1.23,-0.77 -0.38,-8.47 -0.47,-1.35 -1.04,-1.45 -5.34,-1.78 -2.01,-1.69 0,0 1.27,-2.22 1.36,-1.3 z",
    title: "Abia",
    id: "NG-AB",
    state: "Abia",
  },
  {
    d: "m 682.64165,187.16874 -0.13,1.83 -0.82,1.76 -1.02,1.57 -1.1,0.83 -1.77,2.9 -1.36,4.89 -2.66,2.45 -0.48,1.1 -0.61,3.01 0.72,3.61 0.77,1.06 0,1.7 -1.61,1.66 -0.26,4.61 -0.97,1.67 0.13,3.45 -0.78,1.94 -2.05,2.57 -0.26,3.02 -1.61,1.04 -1.44,2.61 -5.87,1.16 -4.18,5.88 0.15,0.98 1.54,1.62 0.04,0.64 -1.15,2.74 -1.85,1.39 -0.03,1.77 0.69,1.6 2.69,1.33 1.01,1.59 -2.16,3.09 -0.13,2.25 -0.54,1.29 0.27,1.11 -1.08,1.47 0.33,0.78 -0.22,1.41 0.43,0.63 -0.74,2.2 -1.02,1.64 -0.97,-0.13 -1.7,1.32 -8.01,0.82 -2.75,2.16 -1.62,0.29 -3.76,3.39 -3.76,1.98 0.09,1.34 2.37,0.27 0.49,0.42 0.09,7.48 -0.73,0.69 -0.83,4.41 0.84,2.07 -1.16,4.03 0.3,1.32 -2.81,4.8 -2.64,2.3 -0.01,1 0.71,0.99 -0.82,2.05 1.27,3.92 -1.13,1.85 -1.09,0.38 -1.67,-0.23 -1.46,0.54 -0.57,1.1 -0.16,2.73 -0.98,0.74 -0.99,1.85 -2.18,0.19 -3.4,2.76 -0.83,0.12 -5.88,-1.64 -0.66,0.66 -0.24,1.71 -1.18,1.16 -0.81,3.05 -1.77,2.34 -2.33,0.14 -1.12,0.89 -2.47,-0.28 -1.85,1.21 -1.91,0.33 -0.72,0.82 -0.68,4.04 1.44,5.22 0.58,5.77 -0.06,1.04 -0.77,0.56 -2.43,4.51 0.62,2.51 0.22,3.73 -4.13,6.35 -3.49,3.09 -1.76,3.01 -0.48,2 -1.12,1.47 -0.41,3.45 -1.11,1.56 0.69,6.14 0.65,1.8 -2.93,1.48 -1.96,0.27 -2.75,3.14 0,0 -1.22,-0.88 0.05,-1.56 -1.94,-4.62 -0.38,-3.54 -0.74,-1.73 0.58,-5.49 -1.04,-2.02 -2.15,-2.6 -4.32,-3.84 -2.5,-3.15 -1.52,-1.12 -1.42,-0.43 -1.64,0.38 -2.83,4.01 -2.72,1.99 -2.71,-2.45 -2.91,-4.7 -2.52,-6.73 0.82,-1.58 4.14,-4.78 3.8,-3.22 5.08,-5.48 8.63,-11.52 6.12,-5.22 0.44,-2.08 -0.38,-5.78 5.99,-11.44 1,-3.62 -0.26,-1.81 -2.02,-3.84 -4.14,-1.47 -2.66,-2.94 -0.34,-3.84 0.46,-2.17 -5.26,-9.82 -2.08,-1.29 -4.65,-1.08 -1.46,-1.92 -5.45,-10.18 0,0 6.2,-0.91 3.37,-1.43 9.4,-5.66 5.75,-4 1.1,-2.33 -0.52,-3.7 0.68,-10.23 0,0 6.34,0.97 2.7,-0.19 4.57,-1.32 1.74,-1.07 1.7,-1.9 3.73,-5.55 6.2,-7.06 2.51,-0.87 6.29,-0.49 5.9,-2.22 2.44,-2.62 0.82,-2.66 3.32,-0.14 2.35,-1.14 2.22,-3.7 2.1,-2.16 2.51,-1.47 8.52,0.79 2.87,1.03 2.58,1.55 2.84,3.11 2.43,1.15 2.38,1.02 4.39,-0.01 1.14,-1.22 1.48,-7.76 2.71,-5.68 1.22,-3.64 0.88,-4.1 0.28,-8.01 3.09,-0.43 0.62,0.74 3.75,1.14 3.86,-0.29 5.62,-1.74 0,0 z",
    title: "Adamawa",
    id: "NG-AD",
    state: "Adamawa",
  },
  {
    class: "active-state",
    d: "m 302.91165,585.31874 0,0.01 0,0 -0.02,-0.02 0,0 0.02,0.01 z m 7.57,-0.7 0.97,0.5 0.92,-0.19 0.88,-0.14 0.33,0.28 -3.58,0.75 -0.49,-0.59 0.97,-0.61 z m 40.31,-7.56 0.88,2.09 -0.76,0.82 -1.07,0.22 -0.22,-1.24 0.56,-0.1 0.35,-0.9 0.26,-0.89 z m -51.56,-11.07 -0.12,-1.85 -1.79,-3.36 0.67,-1.63 -0.02,-1.17 -0.59,-0.67 -0.22,-1.47 0.47,-0.65 -0.09,-0.77 2.52,-1.94 1.18,-2.89 -0.66,-2.49 0.02,-2.41 1.21,-5.81 -1.07,-1.94 0.07,-0.75 1.1,-0.98 6.09,0.16 0.73,-0.9 0.7,-2.44 -2.23,0.16 -0.32,-0.45 1.84,-5.1 -0.53,-3.51 0.29,-0.91 2.42,-0.14 3.4,0.91 1.19,1.47 0.58,2.11 2.75,2.14 2.54,0.84 2.69,2.61 0,0 -0.85,0.1 -1.15,2.45 0.66,1.79 0.84,0.31 0.78,1.94 4.77,-0.56 4.96,2.68 0.4,2.1 -0.61,6.1 1.63,5.13 3.41,4.91 3.19,2.8 3.77,4.33 3.67,2.81 0.59,1.01 0,0 -0.43,2.16 0.79,0.44 0.03,2.5 -0.5,0.45 -0.41,-0.67 -0.07,0.58 1.19,1.17 -0.6,1.8 -0.74,0.19 0.1,1.03 -1.03,1.15 0.24,0.17 -1.05,2.38 -5.23,-0.63 -5.74,-0.07 -10.71,0.55 -12.05,1.68 -0.52,-0.46 -1.82,0.36 -0.93,-0.48 -0.88,0.36 -0.95,-0.09 -0.02,0.03 0.5,0.81 0.27,0.43 -3.32,1.32 -0.98,-1.7 -1.17,-0.65 -0.86,-0.19 -0.96,-1.06 0.38,-0.91 -0.09,-0.12 -0.53,0.5 -0.5,-0.38 0,0 -0.61,-1.17 0.04,-0.64 0.51,-0.32 -0.58,-4.55 0.96,-4.27 -0.63,-2.3 -1.98,-3.47 z",
    title: "Akwa Ibom",
    id: "NG-AK",
    state: "Akwa Ibom",
  },
  {
    class: "active-state",
    d: "m 262.67165,444.90874 0.44,0.4 0.09,3.62 3.83,-0.13 2.44,1.41 2.05,0.08 3.73,1.7 0.36,0.79 -1.25,3.45 -0.75,1.08 -1.69,1.14 -1.85,2.48 0.24,0.96 -0.62,0.83 -0.43,2.35 0.39,0.54 3.85,1.16 1.42,1.8 1.34,3.64 1.31,1.85 -0.3,0.96 -0.82,0.29 0.41,1.37 -0.5,1.62 0.72,0.74 1.89,-1.13 0.61,0.13 0.59,2.58 1.33,0.63 -0.35,2.15 1.88,3.79 0.18,1.51 0.76,0.98 2.39,1.4 1.66,-0.96 1.08,0.09 1.12,0.74 -0.04,0.54 0.83,0.17 0,0 -4.4,2.31 -1.36,1.3 -1.27,2.22 0,0 -5.32,1.42 -5.38,-1.25 -6.31,1.16 -1.78,1.04 -0.93,3.55 -2.37,4.61 -2.68,0.27 -4.51,-1.92 -1.62,0.8 -3,3.83 -2.09,0.83 0,0 -2.4,-0.21 -1.11,-1.28 0,0 1.01,-1.17 1.92,-3.9 0.34,-2.64 1.77,-4.69 2.5,-4.55 0.38,-6.01 1.28,-3.65 -1.23,-3.77 -1.48,-7.29 0.08,-1.37 -1.13,-1.13 -2.13,-9.57 0,0 -0.07,-0.29 0,0 1.67,-0.77 3.59,0.66 1.43,-0.89 1.84,-2.51 0.06,-2.73 1.24,-4.12 2.24,-2.31 1.54,-0.86 z",
    title: "Anambra",
    id: "NG-AN",
    state: "Anambra",
  },
  {
    d: "m 491.94165,87.518745 7.74,6.19 1.14,2.93 0.77,7.079995 -0.19,1.81 3.16,4.66 0.21,6.74 0.33,2.7 0.95,2.71 0.2,3.87 8.35,20.91 -0.23,4.92 -1.05,2.72 -0.99,6.78 1.63,1.53 3.04,0.37 0,0 -0.8,0.24 -2.71,3.76 -6.04,3.28 -2.57,3.7 -2.01,1.75 -1.49,0.76 -3.91,0.88 -1.44,1.36 -1.38,2.03 -0.97,4.94 -2.61,7.43 -3.61,5.07 -0.2,1.38 7.38,2.99 1.14,1.71 0.87,7.15 0.88,1.15 7.2,2.62 2.08,4.94 -0.48,8.63 0.4,2.86 -0.83,1.76 -3.9,0.63 -1.99,0.92 -1.31,1.91 0.33,1.62 4.29,4.38 2.5,1.41 9.15,7.09 1.23,3.79 0.61,6.19 2.58,5.28 1.69,2.12 -0.13,0.95 -0.58,0.16 0,0 -3.99,-0.03 -6.44,-1.09 -10.59,4.85 -5.85,-0.78 -4.59,2.65 0,0 -6.36,-3.43 -6.18,-4.04 -11.07,-4.74 -9.26,-4.93 -2.57,-0.51 -7.6,-3.95 -3.03,1.78 -0.3,1.44 3.17,4.06 0.27,1.74 -0.5,1.67 -4.76,1.3 -2.89,5.21 -4.39,1.41 -10.04,0.59 -5.47,-1.48 -4.8,-0.27 -1.51,-0.53 -1.56,-1.34 -1.65,-4.07 -0.9,-1.16 -0.79,-0.71 -3.92,-1.42 -0.6,-0.85 0.09,-1.69 2.38,-4.47 0.23,-1.17 -0.26,-5.94 -0.97,-3.13 -1.8,-1.92 -1.06,-0.21 -10.97,2.19 0.04,-12.38 -0.78,-4.8 -2.61,-4.16 -2.78,-0.88 -3.18,-0.08 -1.53,0.49 0,0 -2.53,-2.71 -2.79,-1.75 -0.27,-0.73 2.35,-4.2 0.53,-3.96 0,0 0.99,-0.56 2.59,-4.09 1.33,-3.85 -0.08,-2 -0.77,-1.67 -3.86,-4.33 -0.45,-1.99 -0.4,-6.89 0.45,-3.5 1.6,-4.57 1.02,-0.43 2.7,0.16 2.04,-0.51 2.74,-3.21 2.65,-4.11 4.74,-4.17 0.67,-1.1 2.48,-1.57 1.69,-0.3 1.14,1.07 1.14,0.09 5.52,-2.17 0,0 1,-0.19 6,1.1 7.43,2.41 3.35,-1.46 2.3,0.73 1.78,3.67 3.13,0.21 7.7,-0.48 3.57,-0.91 1.14,0.3 2.67,4.9 0.54,2.15 -0.83,7.85 0.81,2.05 1.35,1.36 5.7,1.19 5.6,-1.39 1.56,0.17 1.86,1.36 2.46,0.62 1.86,-0.57 -1.11,-3.43 0.04,-1.8 1.53,-1.91 2.53,-1.36 4.04,-0.99 1.44,-0.78 1.85,-1.39 1.1,-2.72 -1.04,-1.46 -8.87,-0.56 -5.72,-1.27 -6.39,-0.77 -2.99,-1.85 -5.3,-7.42 -1.05,-2.5 -0.47,-2.57 -3.84,0.94 -1.18,-1.11 -0.55,-1.74 2.51,-5 -0.52,-4.32 -1.46,-4.42 -1.81,-0.5 -2.75,0.27 -2.12,1.03 -2.61,0.04 -1.35,-0.63 0.49,-4.26 3.22,-4.54 6.16,-0.46 5.47,-3.04 10.94,-3.73 6.23,-2.51 1.19,-0.94 -0.03,-2.25 -0.57,-1.88 6.71,-20.589995 4.54,-1.95 3.48,-0.55 0.99,0.82 0.83,1.64 0.12,1.39 z",
    title: "Bauchi",
    id: "NG-BA",
    state: "Bauchi",
  },
  {
    d: "m 309.66165,367.75874 9.13,2.48 8.51,1.25 8.71,3.55 4.92,2.82 5.25,0.99 1.07,-0.14 3.32,2.8 5.33,2.23 1.14,-1.1 0.09,-1.36 -4.7,-11.64 -0.08,-2.52 1.02,-2.86 1.24,-1.41 3.95,-2.2 1.38,-0.28 2.59,-0.18 2.68,0.44 10.09,3.72 6.86,1.55 4.88,0.41 3.96,-0.22 0.01,-0.7 11.79,8.93 0,0 -3.79,5.97 1.9,0.57 6.12,-2.63 7.47,-0.95 8.18,0.48 7.48,1.77 5.14,4.9 4.44,5.65 8.37,7.57 -0.14,0.65 1.17,1.36 -0.26,1.04 0.56,1.78 -0.59,3.23 -2.38,5.89 0.29,5.92 -0.92,1.43 -3.09,1.94 -3.44,3.25 -3.31,6.16 -2.11,11.5 0.61,0.73 -0.33,1.08 -0.03,8.76 -1.9,8.19 0,0 -0.72,0.3 -2.12,-0.73 -0.78,1.42 0.1,2 -2.82,1.74 -1.79,0.22 -2.78,-0.44 0,0 -0.65,-1.55 -4.88,-6.63 -5.53,-5.73 -1.49,-0.72 -3.09,-0.22 -9.57,2.24 -4.38,-0.44 -1.21,-0.89 0.66,-4.77 -0.56,-1.64 -8.64,-5.38 -5.43,-1.69 -2.11,-0.07 -2.31,0.59 -2.11,0.67 -1.52,1.2 0.77,4.5 -3.14,1.92 -3.13,0.83 -3.84,-0.14 -2.06,-0.67 -1.92,0.45 -1.36,1.75 -2.36,1.96 -2.99,0.49 0,0 -1.7,-2.27 -0.84,-4.26 -1.76,-1.3 -1.02,2.31 -3.41,0.37 -1.77,2.88 -1.92,0.93 -2.95,-0.25 -3.45,0.4 -1.25,8.23 -0.99,2.05 -1.41,0.59 -1.78,-0.74 -4.01,-3.68 -0.65,-1.54 0.17,-0.91 0,0 2.28,-6.42 -0.9,-5.62 -1.42,-2.14 -1.52,-1.15 -2.81,-0.35 -2.21,2.11 -2.1,0.73 -2.92,-1.52 -3.58,-2.76 -2.89,-3.35 -2.74,-6.51 0.13,-0.53 0,0 0.41,-0.5 0.84,0.58 3.37,3.29 0.82,-0.1 1.35,1.05 1.76,0 0.34,-4.42 0.96,-1.44 6.44,-3.12 3.3,-3.11 1.94,-5.83 0.42,-3.93 0.47,-1.29 1.23,-1.21 0.36,-1.81 -1.48,-0.47 -3.31,0.32 -1.27,-1.05 -1.24,-5.53 -0.57,-6.81 -0.01,-6.9 -0.73,-1.85 -2.7,-2.61 -1.88,-3.22 -0.54,-5.87 z",
    title: "Benue",
    id: "NG-BE",
    state: "Benue",
  },
  {
    d: "m 662.15165,11.078745 0.7,5.65 -0.83,3 3.49,6.26 -0.2,2.52 -0.46,0.49 0.28,-2.17 -1.04,1.33 -0.22,1.92 2.38,2.55 2.46,0.61 -0.65,0.67 0.28,0.54 0.78,0.19 4.46,7.53 2.83,3.08 1.05,0.22 1.72,0.96 1.63,1.2 3.87,0.75 0.26,0.86 -0.58,-0.01 -0.56,1.1 -0.2,-1.04 -0.66,0.58 -0.74,-0.04 1.44,1.6 0.27,1.76 3.88,-1.16 2.31,-2.61 2.47,-2.02 1.6,-0.67 -1.08,1.76 0.15,0.45 0.65,-0.19 0.57,2.34 -0.33,0.22 -0.67,-1.38 -0.85,0.48 -0.57,1.23 -2.02,0.57 0.67,1.88 -1.19,1.13 -1.86,3.73 0.41,0.77 1.37,-0.45 -0.07,2.44 -0.58,1.15 0.85,0.04 -0.34,1.36 -1.15,1.54 0.4,0.57 1.57,-0.43 0.29,0.55 -2.63,1.39 1.97,0.5 -0.15,0.89 1.2,0.05 -0.75,0.85 -1.32,0.33 0.12,0.42 1.24,-0.23 0.12,0.6 -0.48,0.44 -0.23,-0.37 -1.01,0.23 0.24,0.75 0.74,-0.12 -0.85,1.67 1.51,0.21 0.22,1.34 -0.57,0.74 0.26,1.25 0.97,0.22 0.53,1.21 -0.24,1.15 1.95,0.55 0.34,1.46 0.61,0.52 1.61,-0.95 0.46,0.2 0.71,1.91 1.22,0.71 0.31,1.08 2.16,0.77 -0.03,1.1 0.67,1 -0.37,1.19 0.71,0.64 1.11,0.55 1.41,-0.5 2,0.26 -0.27,1.04 0.83,0.06 0.39,-0.69 1.81,-0.07 1.47,-0.81 2.46,-0.08 0.17,1.22 1.07,0.09 -0.12,0.91 -1.25,0.32 0.22,0.53 -0.38,0.64 0.95,0.28 2.25,2.61 3.42,-0.53 1.03,-0.05 0.43,0.81 1.72,-0.87 2.93,0.87 3.5,-0.35 0.68,0.31 0.85,0.12 1.61,0.34 0.79,1.2 1.27,0.34 0.34,0.87 -0.67,0.02 0.08,1.119995 2.17,1.01 0.7,1.37 -0.72,1.39 2.99,0.77 0.76,1.5 -0.54,0.46 1.13,0.54 0.78,0.12 0.12,-0.49 0.97,-0.08 0.51,-0.51 1.33,2.51 -1.37,1.29 -0.32,1.8 -0.74,0.87 0.68,2 -1.72,1.16 -0.06,1.57 2.2,3.78 -1.21,1.74 0.23,1.35 -2.32,2.77 0.01,1.5 0.29,3.79 -0.7,1.23 -2.81,2.15 -0.06,0.55 1.26,1.72 2.01,1.13 2.16,2.18 0.44,2.16 -0.62,4.68 -1.26,0.93 -6.36,2.57 -3.88,0.9 -1.7,3.09 -8.09,3.17 -3.28,2.07 -1.93,2.65 -4.46,1.94 -2.32,0.04 -2.72,-2.37 -2.52,-0.44 -1.07,-0.83 -1.07,0.16 -0.61,0.76 -0.58,2.32 -2.08,2.36 -0.78,2.68 -0.72,1.05 -1.46,0.96 0.24,1.49 -0.65,0.21 -1.08,1.68 -2.32,2.04 -1.21,2.91 -3.24,1.61 -2.42,0.54 -0.77,0.75 -0.19,1.74 0,0 -5.62,1.74 -3.86,0.29 -3.75,-1.14 -0.62,-0.74 -3.09,0.43 -0.28,8.01 -0.88,4.1 -1.22,3.64 -2.71,5.68 -1.48,7.76 -1.14,1.22 -4.39,0.01 -2.38,-1.02 -2.43,-1.15 -2.84,-3.11 -2.58,-1.55 -2.87,-1.03 -8.52,-0.79 -2.51,1.47 -2.1,2.16 -2.22,3.7 -2.35,1.14 -3.32,0.14 -0.82,2.66 -2.44,2.62 -5.9,2.22 -6.29,0.49 -2.51,0.87 -6.2,7.06 -3.73,5.55 -1.7,1.9 -1.74,1.07 -4.57,1.32 -2.7,0.19 -6.34,-0.97 0,0 -3.91,-2.2 -1.81,-1.6 -3.13,-6.17 -5.66,-2.34 -1.83,-1.82 -2.43,-3.51 -0.81,-2.83 5.18,-7.56 0.62,-3.02 -1.35,-3.3 0,0 3.04,-0.69 3.41,-4.53 -0.28,-8.39 0.61,-2.77 1.72,-2.83 2.66,-1.92 11.21,-3.02 6.11,-3.65 2.09,-3.08 0.24,-2.94 -0.76,-4.15 -0.04,-2.97 0.9,-2.86 2.89,-3.35 3.3,-5.9 4.54,-4.43 0.99,-2.11 -0.84,-3.33 -3.13,-3.75 -4.91,0.21 -0.64,-0.36 -0.15,-1.94 4.72,-9.14 -1.69,-7.44 0.13,-3.5 2.54,-16.29 0.05,-5.789995 -1.72,-3.83 0.55,-2.2 7.06,-6.31 2.37,-3.08 1.84,-4.21 -0.48,-3.74 -4.8,-3.84 -1.45,-1.82 -1.23,-3.85 1.49,-8.02 0.08,-4.21 0,0 1.45,-0.12 4.38,0.88 0.03,-1.19 0.59,-0.41 0.07,-0.74 0.19,-1.71 1.48,-1.33 1.14,0.24 1.35,-0.73 -0.34,-1.16 0.73,-1.08 -0.23,-0.32 -0.89,-0.19 0.4,-1.13 0.77,-1.33 0.8,-1.78 0.64,-0.6 2.28,0.35 1.38,-0.87 0.96,0.09 0.61,0.74 0.96,-1.11 0.23,-1.44 1.34,-0.23 1.47,-0.29 0.29,-0.46 -0.34,-0.4 0.98,-1.17 2.11,-0.48 0.62,-1.24 1.37,-0.78 0.16,-0.79 0.58,-0.74 0.4,-0.74 -0.02,-0.86 1.1,-0.43 0.43,-1.02 -0.81,-0.31 0.57,-0.61 1.23,0.63 -0.29,-1.57 1.1,0.12 0.06,0.47 0.85,0.29 1.1,-0.14 1.87,-1.67 1.02,-0.37 0.32,0.38 1.98,-0.1 1.39,-1.33 1.02,0.49 0.05,-1.08 1.08,-0.36 1.02,0.09 -0.89,1.17 1.47,0.79 0.92,-1.31 1.35,1.04 -0.2,-1.31 1.48,-0.51 -0.31,2.08 0.92,0.12 0.45,-0.97 1.15,-0.25 0.92,1.39 0.96,-2.53 1.66,-0.84 0.02,-0.44 -0.55,-0.19 0.19,-0.71 1.19,0.2 0.64,-0.8 -0.64,-0.17 -0.4,-1.02 1.68,-1.6 -0.06,-0.58 1.49,-0.67 -0.05,-0.93 1.05,-1.06 1.24,-0.24 0.39,-1.06 z",
    title: "Borno",
    id: "NG-BO",
    state: "Borno",
  },
  {
    d: "m 251.22165,579.30874 -0.21,-0.62 -0.68,0.1 -3.96,-2.6 -1.2,-4.38 -1.38,-1.87 -1.99,-0.02 -6.54,2.54 -1.04,-0.26 -0.35,-1.94 0.42,-1.46 -3.31,-1.44 -0.5,-0.83 0.07,-4.34 1.9,-2.67 0.76,-2.05 0.03,-1.27 -1.29,0.16 -0.84,-0.78 1.33,-4.44 4.49,-7.84 2.77,0.17 0.55,-0.5 0.75,-2.49 1.54,-0.79 -0.23,-1.81 1.58,-1.07 0.95,-1.48 -0.03,-1.94 -0.63,-1.54 -0.76,-0.58 -1.92,-0.83 -2.94,0.49 -1.04,-0.28 0.77,2.47 -1.2,0.85 -5.08,2.19 -3.49,-0.44 -2.74,0.49 -2.01,4.1 -2.11,0.52 -0.79,-0.6 -1.47,-0.08 -0.36,0.95 0.26,2.31 -2.83,1.56 -1.62,0.56 -3.01,-0.24 -1.23,1.99 -2.31,0.62 -1.89,-0.67 -0.99,-1.66 -2.11,-1.28 -0.75,0.5 -1.48,3.07 -3.3,1.64 -2.62,-0.42 -7.48,4.1 -0.94,-0.37 -2.32,0.4 -1,-1.1 -2.69,-1.6 -3.05,-0.71 -2.9,-1.66 -2.1,-2.1 -0.56,0.72 -0.72,-0.57 -1.43,0.53 -0.36,-0.5 -1.63,0.84 2.36,4.61 1.91,5.81 -0.34,0.79 0.95,1.52 0.35,1.86 4.06,6.77 0.19,1.44 0.94,0.55 0.01,0.17 0.05,1.1 7.5,10.38 1.19,0.62 -0.02,0.75 2.77,1.35 -0.27,0.41 1.05,0.75 0.12,0.65 2.56,1.59 0.19,-0.39 0.31,0.34 -0.22,0.24 0.02,0.34 2.61,2.16 0.48,-0.02 -0.14,-0.77 -0.45,-0.21 1.58,-0.46 -0.76,0.7 0.33,0.72 -0.26,0.27 0.07,0.51 2.32,1.7 5.07,2.36 0.19,-2 -0.79,-0.51 -0.55,-1.25 0.34,0.12 0.29,0.89 0.79,0.22 -0.12,-0.7 0.41,0.03 -0.02,0.7 0.52,0.17 0.26,0.77 -0.62,1.18 0.26,0.43 -0.34,1.3 0.4,0.29 5.18,1.32 0.19,-2.23 0.65,-0.58 0.38,3.84 8.34,-0.7 -0.64,-2.4 1.03,-3.05 0.65,-1.1 -0.29,-1.37 -1.91,-1.15 0.48,-0.05 1.19,0.27 0.96,1.58 0.6,-1.13 -0.55,-0.79 0.09,-2.14 -0.84,-1.35 0.31,-0.74 0.17,1.03 0.69,0.55 0.03,0.38 0.74,2.02 -0.1,3.1 2.72,-2.47 -0.58,-0.63 0.1,-1.94 1.91,-0.6 0.5,-0.63 0.69,1.61 0.12,1.29 -0.48,1.03 0.6,1.32 0.05,1.61 1.34,0.26 1.08,1.51 0.48,-0.05 -0.19,0.33 0.22,0.43 2.17,-0.48 0.19,0.34 -0.62,0.65 1.53,0.79 8.46,-0.91 0.02,-0.48 -0.4,-0.51 -0.07,-0.77 -0.1,-0.34 0.67,-0.86 0.6,-0.58 -0.52,2.04 0.22,0.39 2.03,1.76 0.96,-0.98 3.53,-0.38 -0.5,-2.47 -0.09,-0.38 -0.38,-1.13 -1.15,-0.75 -0.19,-0.99 0.02,-0.19 0.29,-1.06 -0.53,-2.25 -0.41,-0.55 0.35,-0.36 0.76,0.9 1.25,4.2 0.38,-0.58 -0.65,-5.23 1.7,-3.39 0.26,-1.83 z m -78.3,-19.41 0,0 0.01,0.01 -0.01,-0.01 z m 59.51,37.48 -8.22,0.99 -2.8,-0.1 -0.22,-0.7 1.36,-2.52 0.15,-0.02 0.45,0.04 0.14,-1.3 1.98,-2.19 0.12,-0.31 0.43,-0.89 0.45,-0.19 -0.59,-0.77 -0.18,-1.3 0.55,-0.35 1.03,-0.19 0.9,1.34 -0.5,1.33 0.78,1.62 -0.22,1.57 1.63,0.44 0.65,0.92 2.11,2.58 z",
    title: "Bayelsa",
    id: "NG-BY",
    state: "Bayelsa",
  },
  {
    class: "active-state",
    d: "m 348.48165,451.12874 2.99,-0.49 2.36,-1.96 1.36,-1.75 1.92,-0.45 2.06,0.67 3.84,0.14 3.13,-0.83 3.14,-1.92 -0.77,-4.5 1.52,-1.2 2.11,-0.67 2.31,-0.59 2.11,0.07 5.43,1.69 8.64,5.38 0.56,1.64 -0.66,4.77 1.21,0.89 4.38,0.44 9.57,-2.24 3.09,0.22 1.49,0.72 5.53,5.73 4.88,6.63 0.65,1.55 0,0 -2.17,8.34 -5.15,-2.21 -0.78,1.84 -0.02,1.98 -0.58,0.73 -1.08,0.94 -2.8,4.86 -3.23,0.94 -1.63,1.19 -1.2,1.18 -0.95,2.5 -0.99,0.97 -8.72,7.77 -3.81,2.73 -1.12,0.33 -1.64,2.3 -1.69,0.87 -1.3,1.48 0.4,0.86 1.36,1.04 -1.05,1.48 0.4,0.83 -0.45,0.96 -1.47,1.87 -0.57,-0.58 0.05,1.5 5.1,5.64 0.31,1.76 -2.4,4.05 -0.64,2.4 -1.12,1.36 0.21,3.89 -1.81,5.88 0.15,6.56 -2.54,4.2 -1.89,0.77 -0.08,0.84 -1.34,1.04 -1.22,3.3 -1.25,1.04 0.97,1.02 -0.9,0.35 -0.98,1.24 0.05,0.57 -1.01,0.38 0.09,1.76 -1.97,0.75 -1.02,1.25 -0.02,0.96 1.2,1.14 0.34,1.53 -2.42,1.46 -1.09,-0.24 -0.68,-0.72 -1.03,0.82 -0.64,1.52 -0.75,0.53 -0.16,1.47 0.67,0.07 0.6,-1.75 0.26,2.51 -0.36,0.56 -0.43,-0.67 -0.6,0.14 0.58,1.44 -1.48,0.27 0.06,0.76 -1.78,0.29 -1.47,-0.6 0.51,-1.77 1.07,-0.12 -1.27,-1.61 -0.8,1.22 -1.16,0.48 -2.07,-0.46 -0.65,-1.15 0.77,-0.7 0.21,-0.16 -0.31,-0.91 -1.36,0.41 -1.13,-0.63 -2.38,2.18 0,0 -0.59,-1.01 -3.67,-2.81 -3.78,-4.34 -3.18,-2.8 -3.41,-4.91 -1.63,-5.13 0.61,-6.1 -0.39,-2.1 -4.96,-2.68 -4.77,0.56 -0.79,-1.94 -0.83,-0.31 -0.66,-1.79 1.15,-2.45 0.85,-0.1 0,0 3.42,0.76 0.6,-1.21 -0.76,-2.55 -1.71,-2 -0.73,-1.68 -1.37,-4.63 -0.15,-3.78 0.59,-3.72 -1.08,-1.29 0,0 0.38,-2.39 2.34,-3.11 -0.36,-2.66 1.46,-1.26 0.34,-1.35 1.98,-2.29 0.08,-2.42 -1.14,-1.8 0.19,-0.98 2.27,-1.08 2.62,-0.18 2.69,4.5 1.34,-2.08 2.16,-0.77 2.2,-1.71 0.28,-1.31 1.88,-0.29 2.18,1.26 0.84,-0.91 0.68,-2.3 0.1,-2.59 0.8,-1.47 6.92,-8.39 0.02,-1.4 -1.86,-2.6 -0.01,-1.6 1.65,-1.63 2.19,-0.37 0.83,-1.7 -0.24,-1.05 -1.38,-1 -0.41,-1.5 -0.52,-0.37 0.1,-1.94 -1.28,-1.12 -0.5,-1.71 -2.7,-1.87 -1.99,-2.62 z",
    title: "Cross River",
    id: "NG-CR",
    state: "Cross River",
  },
  {
    class: "active-state",
    d: "m 252.45165,479.95874 -1.48,-7.29 0.08,-1.37 -1.13,-1.13 -2.13,-9.57 -1.88,2.04 -4.1,-0.38 -3.73,0.81 -8.19,5.12 -7.35,3.1 -4.03,4.53 -0.64,0.05 -2.58,-3.94 -1.01,-0.42 -1.67,-0.31 -1.78,1.58 -0.89,2.03 -0.15,2.37 0.4,0.75 1.46,0.81 0.54,4.82 2.03,3.59 1.96,2.42 1.88,1.46 2.23,0.81 0.29,1.75 -0.7,3.24 -1.55,1.91 -1.63,1.66 -3.08,2.03 -2.29,3.07 -2.78,1.99 -1.81,0.6 -5.23,1.04 -2.13,-0.56 0.7,-1.8 -1.6,-1.61 2.04,-4.03 -0.47,-0.83 -3.91,-2.35 -2,-2.83 -4.67,-2.62 -3.17,-1.25 -1.64,-1.34 -5.12,1.85 -1.85,2.38 -1.77,-0.4 -2.27,-1.98 -1.38,-0.29 -3.17,0.67 -2.98,-0.72 -0.99,0.31 -0.63,0.3 -0.06,1.03 0.89,1.57 -0.52,1.06 -4.1,3.22 -1.66,0.07 -0.05,-2.47 -0.66,-2.55 0.7,-2.93 -0.15,-1.43 -1.66,-1.67 -5.43,-2.8 -6.9,16.74 2.48,4.48 1.39,0.88 0.58,-1.6 1.31,-1.25 7.76,-4.22 1.26,-0.22 1.85,-1.28 1.13,-0.54 0.36,0.51 -0.02,0.17 -2,0.95 -1.01,1.6 -0.07,0.26 -0.83,-0.53 -2.25,0.98 -3.18,2.51 -0.34,0.75 -1.98,-0.45 -1.05,0.82 -0.79,3.14 0.26,1.54 2.63,4.5 3.18,3.14 1.12,-0.53 3.01,-1.34 2.97,0.41 0.74,-3.16 1.15,-2.15 -0.02,-0.38 0.4,-0.3 0,0.01 0.38,0.12 -0.23,0.14 -0.24,1.9 -1.12,2.27 1,2.13 1.91,0.63 1.63,-0.27 1.58,-3.18 1.6,0.1 0.19,-0.25 0,0.01 2.99,1.54 1.12,0.67 0.19,0.48 -1.19,-0.34 0.27,0.77 0.1,1.32 -1.33,-0.35 0.97,-0.67 -0.33,-1.34 -1.12,-0.72 -3.13,-0.29 -0.6,0.14 0.09,1.63 -0.55,1.13 -2.34,1.97 1,-1.58 -1.79,0.15 -2.1,-0.55 -4.44,-0.67 -1.96,0.19 -0.12,0.84 -1.62,1.08 -1.26,1.67 2.77,3.96 3.04,2.61 6.04,2.63 5.09,0.29 0.02,-0.65 -1.19,-1.39 -0.95,-2.9 -0.26,-0.45 0.07,-0.74 0.47,-0.12 -0.19,0.82 1,2.2 0.83,-0.6 0.36,0 -0.07,0.22 -0.95,1.08 0.26,0.5 2.65,1.12 0.57,-0.21 1.65,-4.8 0.84,-1.46 0.96,-0.62 -0.64,-0.33 3.2,0.12 0.48,0.15 1.05,-0.46 0.46,-1.13 0.74,-0.38 1.12,0.17 0.95,0.91 0.61,-0.66 0.09,0.23 -0.12,0.75 -0.89,0.04 -1.38,-0.94 -1.01,1.68 -1.58,0.79 -1.81,-0.12 0.22,0.86 -0.96,-0.98 -1.32,0.36 -0.55,3.02 0.27,1.32 0.58,1.08 0.45,0.72 3.36,1.09 -0.3,0.8 -1.55,-1.12 -0.65,0.36 -0.03,0.7 -0.07,0.22 -0.49,0.13 0.32,-1.47 -0.31,-0.12 -0.43,-0.34 -0.45,-0.46 -0.45,0.48 -0.74,0.5 -0.36,0.53 -0.79,0.12 -1.12,0.57 0.91,0.46 2.05,-0.1 -2.97,0.96 -0.4,0.63 -1,-1.61 -0.6,0.05 -0.28,-0.02 -2.53,0.15 -1.17,0.63 -0.07,-0.39 -0.69,-0.07 -0.41,-0.31 -0.67,0.22 -0.83,-0.43 0.05,2.44 1.91,7.63 -0.24,1.66 2.08,2.26 2.05,-0.88 2.65,-0.17 -0.89,-1.35 -0.09,-1.12 0.15,-0.24 0.5,-2.38 0.29,-0.03 -0.15,0.6 0.15,0.41 -0.52,2.69 0.88,0.55 -0.1,1.53 -0.8,0.31 2.1,2.1 2.9,1.66 3.05,0.71 2.69,1.6 1,1.1 2.32,-0.4 0.94,0.37 7.48,-4.1 2.62,0.42 3.3,-1.64 1.48,-3.07 0.75,-0.5 2.11,1.28 0.99,1.66 1.89,0.67 2.31,-0.62 1.23,-1.99 3.01,0.24 1.62,-0.56 2.83,-1.56 -0.26,-2.31 0.36,-0.95 1.47,0.08 0.79,0.6 2.11,-0.52 2.01,-4.1 2.74,-0.49 3.49,0.44 5.08,-2.19 1.2,-0.85 -0.77,-2.47 -0.57,-1.04 0.21,-0.44 3.52,-1.81 0.19,-5.3 0.7,-1.48 2.05,-1.42 0.89,-1.75 0.82,-3.18 -1.09,-3.54 0.23,-0.35 1.01,-1.17 1.92,-3.9 0.34,-2.63 1.76,-4.69 2.5,-4.55 0.38,-6.01 1.27,-3.65 -1.18,-3.74 z",
    title: "Delta",
    id: "NG-DE",
    state: "Delta",
  },
  {
    d: "m 319.74165,453.93874 -0.17,0.91 0.65,1.54 4.01,3.68 1.78,0.74 1.41,-0.59 0.99,-2.05 1.25,-8.23 3.45,-0.4 2.95,0.25 1.92,-0.93 1.77,-2.88 3.41,-0.37 1.02,-2.31 1.76,1.3 0.84,4.26 1.7,2.27 0,0 0.49,2.89 1.99,2.62 2.7,1.87 0.5,1.71 1.28,1.12 -0.1,1.94 0.52,0.37 0.41,1.5 1.38,1 0.24,1.05 -0.83,1.7 -2.19,0.37 -1.65,1.63 0.01,1.6 1.86,2.6 -0.02,1.4 -6.92,8.39 -0.8,1.47 -0.1,2.59 -0.68,2.3 -0.84,0.91 -2.18,-1.26 -1.88,0.29 -0.28,1.31 -2.2,1.71 -2.16,0.77 -1.34,2.08 -2.69,-4.5 -2.62,0.18 -2.27,1.08 -0.19,0.98 1.14,1.8 -0.08,2.42 -1.98,2.29 -0.34,1.35 -1.46,1.26 0.36,2.66 -2.34,3.11 -0.38,2.39 0,0 -1.34,-0.21 -3.21,-2.33 -0.7,-1.04 -0.22,-2.19 -1.24,-1.86 -14.09,-0.86 -0.94,-1.03 -0.05,-0.73 0.55,-2.86 -0.07,-4.36 0,0 3.63,-1.01 1.99,1.7 0.77,0.09 2.11,2.51 0.73,0.07 0.65,-1.44 -0.8,-2.92 -0.15,-2.64 2.67,-2.73 0.8,-1.73 -0.99,-6.64 -0.62,-2.55 -1.08,-1.07 0.02,-1.23 2.74,-6.11 0.01,-5.82 -0.65,-1.15 -0.38,-3.29 -1.48,-4.9 6.45,0.55 z",
    title: "Ebonyi",
    id: "NG-EB",
    state: "Ebonyi",
  },
  {
    class: "active-state",
    d: "m 208.35165,395.48874 0.77,0.64 1.75,-0.37 0.7,0.36 0.28,0.68 -0.38,0.89 0.46,0.65 2.18,-0.25 0.27,0.8 -0.96,1.85 -0.23,1.93 0.28,1.05 1.08,0.78 2.13,0.53 5.94,-2.93 1.56,2.1 0.65,-0.07 1.26,1.41 0.55,-0.06 1.96,2.23 2.26,-0.19 0.74,-0.51 2.56,0.15 1.06,2.01 0.07,1.22 0.85,0.61 0.48,1.74 0.74,0.56 -0.24,0.51 0.66,1.63 3.75,-0.84 0.43,0.38 1.46,-0.99 1.87,-0.41 1.75,1.41 0.55,2.12 1.45,1.08 0.79,2.01 0.15,3.41 -0.31,1.92 -1.62,3.94 0.06,4.16 -1.91,4.82 -2.16,3.55 1.28,2.15 -0.93,5.52 0.89,2.6 1.41,2.01 1.03,6.03 0,0 0.07,0.29 0,0 -1.88,2.03 -4.09,-0.38 -3.73,0.81 -8.19,5.11 -7.35,3.1 -4.03,4.53 -0.65,0.04 -2.58,-3.94 -1.01,-0.41 -1.66,-0.32 -1.79,1.59 -0.89,2.02 -0.15,2.37 0.4,0.75 1.46,0.81 0.54,4.82 2.03,3.58 1.96,2.42 1.88,1.46 2.23,0.81 0.28,1.74 -0.69,3.24 -1.55,1.91 -1.62,1.66 -3.08,2.03 -2.3,3.07 -2.77,1.99 -1.81,0.6 -5.24,1.04 -2.13,-0.57 0.7,-1.8 -1.6,-1.61 2.03,-4.03 -0.47,-0.83 -3.9,-2.35 -2,-2.83 -4.68,-2.62 -3.16,-1.25 -1.64,-1.34 -5.12,1.85 -1.85,2.38 -1.77,-0.4 -2.27,-1.98 -1.38,-0.29 -3.17,0.67 -2.97,-0.72 -0.99,0.31 -0.64,0.3 -0.06,1.03 0.89,1.57 -0.52,1.06 -4.09,3.23 -1.66,0.07 -0.05,-2.47 -0.66,-2.55 0.71,-2.93 -0.15,-1.43 -1.66,-1.67 -5.43,-2.79 0,0 0.39,-1.16 -1.23,-2.26 -1.33,-1.04 -1.56,-0.09 -1.65,-2.94 -1.94,-1.36 -0.7,-0.06 -0.44,-0.91 0.25,-0.59 -0.28,0.44 0.8,-0.7 0.96,-3.63 0.58,-0.61 2.95,-0.87 0.84,-3.74 1.74,-1.71 0.84,-1.96 0.35,-1.72 -0.57,-1.45 -1.4,-2.28 -1.23,-0.64 0,-2.84 0.81,-0.98 -0.1,-2.22 0.49,-0.96 1.75,-1.62 0.45,-1.03 1.73,-0.8 0.79,-2.27 0.96,-0.69 0.09,-1.95 0.45,-0.78 2.2,-1.01 2.13,0.4 2.28,-0.38 1.68,0.36 6.64,0.11 3.29,-0.38 1.64,0.34 1.74,2.08 -2.01,2.26 2.1,5.46 0.74,-0.03 3.77,-3.16 1.34,0.12 1.19,1.48 0.81,0.35 2.68,-1.02 1.51,-3.39 0.95,-4.96 0.25,-0.25 1.19,0.51 0.01,-1.63 0.88,-0.52 -0.15,-0.81 -1.18,-1.28 0.61,-4.64 1.24,-1.66 1.52,-0.73 0.37,-0.85 -0.32,-0.84 3.23,-6.89 -0.15,-1.39 0.47,-1.04 1.76,-1.83 2.15,-1.05 1.43,-3.54 -0.43,-0.28 -0.77,-2.48 0.87,-2.89 -2.01,-0.82 -0.4,-0.84 0.18,-1.39 1.41,-1.72 1.56,0.14 0.89,-0.6 z",
    title: "Edo",
    id: "NG-ED",
    state: "Edo",
  },
  {
    d: "m 148.66165,367.10874 0.41,-0.17 0.61,1.67 1.03,0.49 4.48,-1.25 0.95,0.37 1.47,2.06 0.95,0.49 2.33,-0.23 2.3,0.62 1.95,-0.58 1.29,0.55 1.04,-2.16 -0.29,-0.63 0.82,-2.22 4.11,-1.34 5.76,-0.09 0,0 -1.09,0.42 -0.03,4.28 0.55,0.45 2.48,-1.42 3.67,-0.64 2.31,0.27 0.56,0.7 -0.28,1.37 -1.34,0.64 -2.29,3.01 -0.08,1.56 1.32,3.75 1.32,0.96 1.28,0.03 1.85,1.69 6.82,2.39 0,0 -1.52,2.4 -0.82,0.3 -1.5,-1.25 -1.86,0.39 -0.85,2.06 -2.18,1.45 -2.4,2.48 -1.13,2.14 -1.71,8.1 -1.7,3.92 -3.05,4.43 -5.53,3.49 -2.27,-0.59 -1.09,-2.68 0.16,-0.86 -1.04,-3.19 -1.42,-2.22 -1.55,-0.52 -6.97,0.31 -7.78,-0.44 -4.55,1.45 0,0 -0.83,-1.7 -0.84,-3.79 -2.85,-6.11 -0.69,-4.78 1.19,-3.99 -0.81,-2.81 0.12,-1.4 1.9,-4.25 1.62,-1.5 2.18,-0.94 1.99,-1.64 z",
    title: "Ekiti",
    id: "NG-EK",
    state: "Ekiti",
  },
  {
    class: "active-state",
    d: "m 262.67165,444.90874 2.73,-5.01 0.91,0.25 0.18,2.28 0.74,0.05 1.33,2.01 0.69,0.34 1.24,-0.33 4.97,-5.39 5.98,-3.86 6.18,-7.42 2.44,-0.91 2.14,-2.1 3.31,-0.76 2.44,0.75 1.11,1.62 0,0 -0.13,0.53 2.74,6.51 2.89,3.35 3.58,2.76 2.92,1.52 2.1,-0.73 2.21,-2.11 2.81,0.35 1.52,1.15 1.42,2.14 0.9,5.62 -2.28,6.42 0,0 -1.79,0.36 -6.45,-0.55 1.48,4.9 0.38,3.29 0.65,1.15 -0.01,5.82 -2.74,6.11 -0.02,1.23 1.08,1.07 0.62,2.55 0.99,6.64 -0.8,1.73 -2.67,2.73 0.15,2.64 0.8,2.92 -0.65,1.44 -0.73,-0.07 -2.11,-2.51 -0.77,-0.09 -1.99,-1.7 -3.63,1.01 0,0 -0.33,-1.46 -2.05,-1.34 -2.71,-0.27 -4.83,0.89 -0.6,-0.77 0,0 -0.83,-0.17 0.04,-0.54 -1.12,-0.74 -1.08,-0.09 -1.66,0.96 -2.39,-1.4 -0.76,-0.98 -0.18,-1.51 -1.88,-3.79 0.35,-2.15 -1.33,-0.63 -0.59,-2.58 -0.61,-0.13 -1.89,1.13 -0.72,-0.74 0.5,-1.62 -0.41,-1.37 0.82,-0.29 0.3,-0.96 -1.31,-1.85 -1.34,-3.64 -1.42,-1.8 -3.85,-1.16 -0.39,-0.54 0.43,-2.35 0.62,-0.83 -0.24,-0.96 1.85,-2.48 1.69,-1.14 0.75,-1.08 1.25,-3.45 -0.36,-0.79 -3.73,-1.7 -2.05,-0.08 -2.44,-1.41 -3.83,0.13 -0.09,-3.62 z",
    title: "Enugu",
    id: "NG-EN",
    state: "Enugu",
  },
  {
    class: "active-state",
    d: "m 287.74165,288.29874 6.12,-0.63 3.2,0.32 1.52,0.85 1.13,-0.85 1.81,-3.04 1.06,-0.54 1.07,0.43 1.47,3.11 0.94,0.31 1.18,-0.79 0,0 -0.07,2.44 -0.42,0.62 -1.03,0.07 -0.53,0.61 -2.11,6.52 -0.08,5.62 0.51,2.19 -0.55,7 -1.98,5.27 -1.52,7.95 -0.79,0.36 -1.08,3.4 -1.04,1.64 -3.78,4.62 -6.96,3.64 -4.63,1.06 -2.91,1.2 -11.13,1.75 0,0 -1.4,0.46 -7.46,-0.15 0,0 -1.83,0.21 -1.42,-0.47 -1.95,-4.91 0.46,-1.37 -0.75,-30.21 0.36,-13.66 0.34,-0.38 2.68,-0.33 11.03,-0.47 1.76,0.63 9.19,8.1 0.94,-0.24 z",
    title: "Federal Capital Territory",
    id: "NG-FC",
    state: "Federal Capital Territory",
  },
  {
    d: "m 517.00165,163.43874 0.91,-0.88 4.17,-1.51 4.04,0.17 2.98,1.01 2.18,1.29 8.49,6.26 4.75,6.4 3.42,3.58 -1,1.54 1.58,-1.02 3.68,3.38 0.67,4.87 -1.2,11.85 0.77,6.45 0.3,0.51 6.78,-0.01 0,0 1.35,3.3 -0.62,3.02 -5.18,7.56 0.81,2.83 2.43,3.51 1.83,1.82 5.66,2.34 3.13,6.17 1.81,1.6 3.91,2.2 0,0 -0.68,10.23 0.52,3.7 -1.1,2.33 -5.75,4 -9.4,5.66 -3.37,1.43 -6.2,0.91 0,0 -6.37,0.47 -12.46,-0.02 -5.9,0.6 -3.57,-0.71 0,0 0.58,-0.16 0.13,-0.95 -1.69,-2.12 -2.58,-5.28 -0.61,-6.19 -1.23,-3.79 -9.15,-7.09 -2.5,-1.41 -4.29,-4.38 -0.33,-1.62 1.31,-1.91 1.99,-0.92 3.9,-0.63 0.83,-1.76 -0.4,-2.86 0.48,-8.63 -2.08,-4.94 -7.2,-2.62 -0.88,-1.15 -0.87,-7.15 -1.14,-1.71 -7.38,-2.99 0.2,-1.38 3.61,-5.07 2.61,-7.43 0.97,-4.94 1.38,-2.03 1.44,-1.36 3.91,-0.88 1.49,-0.76 2.01,-1.75 2.57,-3.7 6.04,-3.28 2.71,-3.76 z",
    title: "Gombe",
    id: "NG-GO",
    state: "Gombe",
  },
  {
    class: "active-state",
    d: "m 283.98165,497.48874 2.01,1.69 5.34,1.78 1.04,1.45 0.47,1.35 0.38,8.47 -1.23,0.77 1.51,2.44 -0.28,2.05 0.36,3.45 -0.43,2.01 -0.89,0.9 -1.18,3.04 -1.82,1.68 -2.1,3.87 -3.09,10.25 0,0 -2.57,0.95 -4.52,-1.13 -2.13,0.04 -4.15,1.06 -4.69,-1.11 -6.72,0.14 -2.14,-0.41 -2.16,-1.65 -1.72,-3.4 -1.84,-1.3 -0.26,-1.37 1.09,-2.76 0.52,-4.63 -0.45,-1.66 -2.12,-0.77 -3.46,0.67 -1.51,-0.44 2.75,-13.09 0,0 2.09,-0.83 3,-3.83 1.62,-0.8 4.51,1.92 2.68,-0.27 2.37,-4.61 0.93,-3.55 1.78,-1.04 6.31,-1.16 5.38,1.25 z",
    title: "Imo",
    id: "NG-IM",
    state: "Imo",
  },
  {
    d: "m 434.10165,67.298745 1.79,1.18 6,0.73 3.14,-1.8 2.1,-3.99 5.32,-2.59 3.16,-0.63 2.82,-1.37 6.33,-1.96 2.21,1.25 2.13,4.78 0.69,4.35 1.46,2.53 1.12,-0.72 5.86,-1.86 4.99,2.22 2.03,-0.61 1.85,0.88 2.21,3.4 1.76,11.53 0.87,2.9 0,0 -11.06,6.93 -0.12,-1.39 -0.83,-1.64 -0.99,-0.82 -3.48,0.55 -4.54,1.95 -6.71,20.589995 0.57,1.88 0.03,2.25 -1.19,0.94 -6.23,2.51 -10.94,3.73 -5.47,3.04 -6.16,0.46 -3.22,4.54 -0.49,4.26 1.35,0.63 2.61,-0.04 2.12,-1.03 2.75,-0.27 1.81,0.5 1.46,4.42 0.52,4.32 -2.51,5 0.55,1.74 1.18,1.11 3.84,-0.94 0.47,2.57 1.05,2.5 5.3,7.42 2.99,1.85 6.39,0.77 5.72,1.27 8.87,0.56 1.04,1.46 -1.1,2.72 -1.85,1.39 -1.44,0.78 -4.04,0.99 -2.53,1.36 -1.53,1.91 -0.04,1.8 1.11,3.43 -1.86,0.57 -2.46,-0.62 -1.86,-1.36 -1.56,-0.17 -5.6,1.39 -5.7,-1.19 -1.35,-1.36 -0.81,-2.05 0.83,-7.85 -0.54,-2.15 -2.67,-4.9 -1.14,-0.3 -3.57,0.91 -7.7,0.48 -3.13,-0.21 -1.78,-3.67 -2.3,-0.73 -3.35,1.46 -7.43,-2.41 -6,-1.1 -1,0.19 0,0 -0.08,-2.24 1.08,-3.72 7.12,-6.88 -0.89,-1.15 -2.09,-0.53 -2.83,-2.64 -1.48,-2.75 -0.5,-2 -1.09,-0.99 -5.06,0.15 -0.2,-1.96 0.5,-2.09 3.36,-4.69 0.19,-2.05 1.06,-1.84 -0.19,-2.46 -2.28,-7.18 -1.25,0.53 -1.47,1.75 -2.32,1.42 -1.82,0.18 -1.37,-0.25 -0.01,-2.57 -0.57,-1.44 -3.14,0.25 -1.9,1.19 0,-1.03 -1.65,-0.72 0.53,-1.72 1.18,-1.39 0.08,-5.61 -0.8,-2.94 -0.92,-0.81 -1.85,-0.56 -5.44,-0.56 -0.83,-0.42 -1.02,-1.389995 0.57,-2.01 -1.1,-3.08 -3.81,-2.12 -1.13,-1.38 -0.45,-5.92 -7.78,-2.02 -3.77,0.35 -3.99,1.93 -1.73,1.35 -0.62,2.6 -1.87,3.61 -1.07,-1.12 -0.1,-1.96 -3.51,-6.28 0,0 -1.24,-2.62 -0.83,-0.7 -4.94,-0.12 -2.86,-0.93 -0.59,-0.72 -0.07,-3.85 0.75,-3.4 -0.02,-2.69 0.46,-0.3 10.39,-1.38 5.37,0.99 9.22,-0.78 1.17,1.23 1.41,4.68 0.68,0.94 2.66,1.67 1.99,0.52 2.62,-1.51 0.64,1.56 1.49,0.7 3.68,-0.55 4.18,-1.74 3.19,-2.58 1.03,-2.63 0.58,-0.75 2,-0.88 0.01,-0.86 0,0 1.27,-0.39 10.06,0.44 9.02,1.42 5.24,-0.75 6.06,0.78 10.03,0.45 z",
    title: "Jigawa",
    id: "NG-JI",
    state: "Jigawa",
  },
  {
    class: "active-state",
    d: "m 316.55165,159.39874 3.09,0.02 2.44,-0.67 4.18,-3.83 4.8,-2.84 1.65,0 4.08,-1.24 1.22,0.19 1.13,0.82 0.32,1.25 -2.11,4.02 0.53,2.57 1.04,1.18 3.53,1.83 3.75,1.23 3.51,4.13 1.53,0.55 2.78,-0.03 2.45,0.59 5.38,4.43 3.59,6.42 0.38,3.88 -1.01,2.44 -1.01,4.91 1.2,6.05 -0.2,1.73 -0.72,1.1 -3.55,0.96 -0.55,0.79 0.6,2.08 1.06,1.07 7.02,0.97 1.98,2.75 1.6,1.05 3,0.64 1.05,-0.29 0,0 -0.53,3.96 -2.35,4.2 0.27,0.73 2.79,1.75 2.53,2.71 0,0 -0.37,0.29 -0.21,2.9 -0.55,1.43 -1.32,1.56 -2.19,0.73 -1.9,1.4 -2.13,4.97 -0.22,2.71 1.36,2.82 0.75,3.52 -2.39,1.97 -0.34,1.1 0.18,1.97 -0.7,7.81 0.53,2.1 -0.42,1.07 -1.91,1.55 -0.4,3.08 -1.76,1.28 0.21,4.74 -1.05,1.4 0.1,1.16 3.26,5.28 2.57,3.08 1.71,1.21 1,2.09 0.12,3.41 -1.67,3.94 0,0 -1.09,0.57 -2.65,5.61 -3.31,5.4 -0.82,0.72 -1.61,0.42 -2.47,-0.13 -0.6,-1.9 -5.34,-5.91 -3.81,-0.24 -1.5,-1.25 -1.33,-0.22 -1.29,0.98 -0.89,1.9 -4.16,4.75 -2.35,1.6 -1.15,0.21 -1.34,-0.96 -0.4,-1.31 0.05,-9.7 -1.03,-1.61 -4.22,-2.44 -0.32,-3.25 -2.93,-2.67 -1.1,-0.39 -1.01,0.35 -1.65,2.12 -0.94,2.54 -2.31,2.1 -1.1,0 -1.75,-1.06 -1.34,0.25 -2.44,-1.79 -0.93,-0.14 -1.5,0.61 -0.7,-0.79 -0.6,-1.88 -0.75,-0.11 -1.34,1.02 0,0 -1.18,0.79 -0.94,-0.31 -1.47,-3.11 -1.07,-0.43 -1.06,0.54 -1.81,3.04 -1.13,0.85 -1.52,-0.85 -3.2,-0.32 -6.12,0.63 0,0 -1.23,-0.42 -2.46,0.6 1.38,-4.13 -3.39,-2.78 0.09,-2.32 0.56,-0.93 2.45,-1.29 0.79,-0.87 0.6,-2.79 3.09,-3.17 -0.58,-1.88 -3,-1.62 0.83,-3.02 -3.62,-1.36 -1.13,-0.77 -0.17,-0.91 0.29,-0.64 0.88,-0.42 3.23,-0.41 0.63,-1.51 -0.1,-3.09 -0.92,-3.88 -0.16,-5.06 -0.33,-1.01 -1.37,-0.67 -12.87,0.08 -6.67,-2.49 -1.71,-1.66 -1.03,-1.98 0.91,-1.24 2.17,-1.36 1.62,-1.68 0.85,-1.48 4.24,-2.6 1.02,-1.79 0.31,-1.98 -3.23,-1.75 -4.83,-1.66 1.35,-4.14 0.05,-2.57 -1.98,-3.8 -1.61,-0.44 -2.25,0.67 -1.39,-0.14 -0.28,-4.5 -0.48,-1.92 -0.61,-0.51 -4.73,-0.5 -1.18,1.2 0.67,2.39 -0.64,0.98 -3.97,-0.56 -7.63,2.86 -1.04,-2.66 -1.02,-1 -2.91,0.13 -2.1,0.61 -2.46,1.5 -5.59,4.5 -5.38,7.01 -1.41,0.89 -1.43,-0.6 -1.22,-3.52 -3.05,-2 -0.22,-1.37 0.33,-2.31 1.84,-1.8 -0.24,-3.81 0.74,-2 -0.14,-1.48 -1.44,-2.38 0.4,-4.79 3.04,-5.38 0,0 1.68,-0.12 1.28,-0.76 2.86,-4.16 5.27,-4.71 5.64,-0.95 7.94,0.57 4.71,-0.62 2.33,-1.51 3.04,-3.1 1.51,-3.23 0.64,-3.55 1.71,-3.41 0.85,-1.14 2.75,-1.77 2.34,-2.38 1.01,0.03 0,0 4.41,0.88 1.94,-0.18 1.36,0.9 0.79,1.74 -0.23,1.07 -2.89,2.69 -0.39,1.32 6.35,1.93 4.25,4.29 1.75,0.23 2.69,-1.52 1.38,-1.91 -1.81,-3.36 -0.12,-2.04 3.45,-1.09 1.95,0.11 2.77,1.1 1.4,-0.09 0.58,-0.54 -0.01,-1.39 1.2,-2.97 3.06,-2.59 1.39,-0.28 6.78,2.29 2.05,1.73 0.97,1.58 1.57,0.78 5.62,-2.24 0.84,-2.05 z",
    title: "Kaduna",
    id: "NG-KD",
    state: "Kaduna",
  },
  {
    d: "m 90.771651,42.718745 6.62,-0.14 1.86,0.74 4.629999,-1.58 0.76,0.31 1.65,2.12 3.19,1.82 1.06,1.1 9.56,3.12 2.95,2.07 3.06,0.68 1.82,-0.43 0.63,-0.56 2.49,-3.69 1.16,-0.31 1.08,0.88 0.4,1.25 -1.62,3.93 0.09,2.4 -1.42,2.98 -0.42,3.7 1.86,2.15 1.8,4.28 -0.18,3.32 -1.3,6.06 0.04,2.04 1.68,5.52 -0.24,8.02 -0.64,1.56 -1.02,0.04 -3.17,-2.04 -2.68,0.02 -3.95,1.18 -1.28,1.48 -1.01,3.779995 -0.14,9.94 0.79,13.05 -2.12,9.79 -2.61,5.63 -1.16,4.77 2.55,3.65 0.76,0.51 2.78,0.29 1.71,-1.35 2.4,-3 12,-5.45 1.69,-0.12 1.89,0.86 2.04,-0.72 0.77,1.75 0.94,0.07 1.62,-0.97 0,0 0.86,-0.48 1.82,0 4.11,2.25 6.34,-1.46 0.82,-2.32 1.06,-0.62 0.79,-0.15 0.91,0.64 2.09,0.31 3.61,-0.65 1.08,0.57 1.69,3.3 2.87,0.11 3.65,2.41 5.47,-0.76 3.79,0.5 2.49,-0.59 1.22,-0.81 4.85,0.62 4.35,1.77 1.41,2.15 -0.01,2.47 -2.05,6.49 0,1.2 5.38,2.71 1.93,3.01 1.38,7.58 0.21,5.48 0,0 -1.36,-1.1 -1.85,-0.36 -3.42,2.76 -1.28,2.2 -3.93,0.41 -12.1,5.08 -10.67,0.69 -1.64,-1.25 -0.36,-4.02 0.37,-4.81 -0.48,-1.78 -3.75,-2.47 -0.81,-1.26 -0.98,-6.51 -1.69,-1.6 -2.84,-0.71 -3.64,-0.04 -9.86,1.59 -7.87,1.83 -4.43,1.62 -4.85,2.59 -1.37,2.07 0.16,1.54 0.87,1.26 3.63,2.01 5.4,2.19 5.36,0.53 1.05,2.01 1.71,-0.03 0.78,0.74 1.12,6.56 -0.25,1.07 -2.18,1.45 -0.63,1.47 0.49,1.45 2.74,1.63 1.17,1.36 -0.07,2.07 -1.01,1.49 -3.8,0.97 -5.22,2.64 -5,-0.52 -1.55,0.42 -0.9,0.75 -0.04,9.59 -0.45,1.37 1.25,2.83 1.81,1.97 1.86,3.03 0.75,2.44 -0.28,1.53 -1.77,2.13 -2.64,1.57 -3.38,0.26 -7.42,2.5 -0.5,5.85 -0.56,0.48 -4.32,-0.46 -1.42,-0.99 -0.02,-2.28 1.03,-3.28 0.29,-3.94 -2.93,-2.66 -1.12,-2.41 0.18,-6.32 1.46,-3.26 1.84,-2 1.48,-1.01 3.92,-1.44 4.62,-4.43 2.43,-10.71 0.2,-4.05 -0.51,-0.74 -2.89,-1.06 -1.58,0.1 -8.4,-5.7 -5.24,-1.69 -2.94,0.07 -4.5,0.85 -6.189999,-0.36 -12.17,0.81 -1.86,-0.29 -3.49,-1.42 -11.04,-6.08 -2.89,-0.36 -0.89,0.52 0,0 -1.29,-0.01 -12.13,-10.28 4.33,-20.39 2.12,-4.71 4.89,-4.18 -0.82,-3.26 -2.42,-1.82 -0.57,-4.87 3.17,-3.84 -2.36,-8.76 0.39,-5.22 1.27,-4.3 -0.93,-15.849995 10.82,-9.33 7.73,-6.05 9.53,-14.62 2.08,-9.63 z",
    title: "Kebbi",
    id: "NG-KE",
    state: "Kebbi",
  },
  {
    class: "active-state",
    d: "m 347.91165,83.288745 3.51,6.28 0.1,1.96 1.07,1.12 1.87,-3.61 0.62,-2.6 1.73,-1.35 3.99,-1.93 3.77,-0.35 7.78,2.02 0.45,5.92 1.13,1.38 3.81,2.12 1.1,3.08 -0.57,2.01 1.02,1.389995 0.83,0.42 5.44,0.56 1.85,0.56 0.92,0.81 0.8,2.94 -0.08,5.61 -1.18,1.39 -0.53,1.72 1.65,0.72 0,1.03 1.9,-1.19 3.14,-0.25 0.57,1.44 0.01,2.57 1.37,0.25 1.82,-0.18 2.32,-1.42 1.47,-1.75 1.25,-0.53 2.28,7.18 0.19,2.46 -1.06,1.84 -0.19,2.05 -3.36,4.69 -0.5,2.09 0.2,1.96 5.06,-0.15 1.09,0.99 0.5,2 1.48,2.75 2.83,2.64 2.09,0.53 0.89,1.15 -7.12,6.88 -1.08,3.72 0.08,2.24 0,0 -5.52,2.17 -1.14,-0.09 -1.14,-1.07 -1.69,0.3 -2.48,1.57 -0.67,1.1 -4.74,4.17 -2.65,4.11 -2.74,3.21 -2.04,0.51 -2.7,-0.16 -1.02,0.43 -1.6,4.57 -0.45,3.5 0.4,6.89 0.45,1.99 3.86,4.33 0.77,1.67 0.08,2 -1.33,3.85 -2.59,4.09 -0.99,0.56 0,0 -1.05,0.29 -3,-0.64 -1.6,-1.05 -1.98,-2.75 -7.02,-0.97 -1.06,-1.07 -0.6,-2.08 0.55,-0.79 3.55,-0.96 0.72,-1.1 0.2,-1.73 -1.2,-6.05 1.01,-4.91 1.01,-2.44 -0.38,-3.88 -3.59,-6.42 -5.38,-4.43 -2.45,-0.59 -2.78,0.03 -1.53,-0.55 -3.51,-4.13 -3.75,-1.23 -3.53,-1.83 -1.04,-1.18 -0.53,-2.57 2.11,-4.02 -0.32,-1.25 -1.13,-0.82 -1.22,-0.19 -4.08,1.24 -1.65,0 -4.8,2.84 -4.18,3.83 -2.44,0.67 -3.09,-0.02 0,0 -3.6,-2.68 -1.11,-2.26 -0.78,-3.61 1.52,-2.67 0.07,-2.21 1.82,-1.63 3.75,-1.03 2.45,-1.7 2.71,-0.07 0.95,-0.58 -3.14,-7.8 0.67,-4.06 -2.09,-4.58 0.86,-6.33 -0.7,-12.32 0.27,-2.89 2.18,-2.28 4.25,-2.369995 7.64,-2.38 3.68,-1.93 0.78,-0.85 1.13,-4.39 2.14,-4.61 1.28,-0.52 z",
    title: "Kano",
    id: "NG-KN",
    state: "Kano",
  },
  {
    d: "m 219.65165,323.91874 2.2,0.57 2.77,1.58 3.52,3.25 2.77,4.32 2.55,8.25 3.71,2.3 2.71,2.69 5.47,7.27 2.72,2.54 1.63,0.25 0.33,-0.35 0.62,-2.89 1.24,-2.53 0.19,-0.26 0.99,0.88 0.46,-0.09 0.06,-2.97 3.57,-1.74 1.12,-3.25 0,0 7.46,0.15 1.4,-0.46 0,0 -0.6,2.64 -1.55,2.66 0,0.86 0.82,1.69 2.19,2.66 0.54,6.17 -1.17,4.71 -0.04,4.69 -1.61,1.67 -0.85,2.12 -0.17,3.74 0.69,0.56 4.26,-2.95 9.26,-4.07 12.4,-3.37 7.07,-0.7 3.58,0.68 7.7,0.57 0,0 -0.32,2.84 0.54,5.87 1.88,3.22 2.7,2.61 0.73,1.85 0.01,6.9 0.57,6.81 1.24,5.53 1.27,1.05 3.31,-0.32 1.48,0.47 -0.36,1.81 -1.23,1.21 -0.47,1.29 -0.42,3.93 -1.94,5.83 -3.3,3.11 -6.44,3.12 -0.96,1.44 -0.34,4.42 -1.76,0 -1.35,-1.05 -0.82,0.1 -3.37,-3.29 -0.84,-0.58 -0.41,0.5 0,0 -1.11,-1.62 -2.44,-0.75 -3.31,0.76 -2.14,2.1 -2.44,0.91 -6.18,7.42 -5.98,3.86 -4.97,5.39 -1.24,0.33 -0.69,-0.34 -1.33,-2.01 -0.74,-0.05 -0.18,-2.28 -0.91,-0.25 -2.73,5.01 0,0 0,0 0,0 -1.34,1.87 -1.54,0.86 -2.24,2.31 -1.24,4.12 -0.06,2.73 -1.84,2.51 -1.43,0.89 -3.59,-0.66 -1.67,0.77 0,0 -1.03,-6.03 -1.41,-2.01 -0.89,-2.6 0.93,-5.52 -1.28,-2.15 2.16,-3.55 1.91,-4.82 -0.06,-4.16 1.62,-3.94 0.31,-1.92 -0.15,-3.41 -0.79,-2.01 -1.45,-1.08 -0.55,-2.12 -1.75,-1.41 -1.87,0.41 -1.46,0.99 -0.43,-0.38 -3.75,0.84 -0.66,-1.63 0.24,-0.51 -0.74,-0.56 -0.48,-1.74 -0.85,-0.61 -0.07,-1.22 -1.06,-2.01 -2.56,-0.15 -0.74,0.51 -2.26,0.19 -1.96,-2.23 -0.55,0.06 -1.26,-1.41 -0.65,0.07 -1.56,-2.1 -5.94,2.93 -2.13,-0.53 -1.08,-0.78 -0.28,-1.05 0.23,-1.93 0.96,-1.85 -0.27,-0.8 -2.18,0.25 -0.46,-0.65 0.38,-0.89 -0.28,-0.68 -0.7,-0.36 -1.75,0.37 -0.77,-0.64 0,0 -0.23,-0.78 -4.74,-4.17 -2.04,-2.7 0.71,-4.14 -2.51,-0.43 -4.62,0.88 0,0 -6.82,-2.39 -1.85,-1.69 -1.28,-0.03 -1.32,-0.96 -1.32,-3.75 0.08,-1.56 2.29,-3.01 1.34,-0.64 0.28,-1.37 -0.56,-0.7 -2.31,-0.27 -3.67,0.64 -2.48,1.42 -0.55,-0.45 0.03,-4.28 1.09,-0.42 0,0 0.75,-1.44 -0.82,-2.41 -4.76,-2.58 -0.13,-0.59 -2.42,-1.81 -0.07,-0.67 -2.41,-2.45 -1.92,-3.7 0.17,-0.99 2.14,-2.43 2.29,-3.91 3.71,-4.04 3.6,-2.29 1.77,2.62 2.17,1.76 7.04,3.01 1.84,0.08 2.76,1.08 3.71,-0.21 2.13,0.69 3.92,-0.12 6.3,1.52 3.03,-0.5 1.57,-3.76 0.64,-6.49 2.31,-7.79 z",
    title: "Kogi",
    id: "NG-KO",
    state: "Kogi",
  },
  {
    d: "m 322.66165,35.138745 9.16,1.35 5.19,1.38 3.58,1.94 2.92,2.5 2.73,0.73 9.89,9.64 3.29,-0.88 2.92,0.38 3.03,1.55 2.29,1.75 1.85,2.11 1.04,2.44 2.96,1.37 5.26,1.27 12.11,3.92 0,0 -0.01,0.86 -2,0.88 -0.58,0.75 -1.03,2.63 -3.19,2.58 -4.18,1.74 -3.68,0.55 -1.49,-0.7 -0.64,-1.56 -2.62,1.51 -1.99,-0.52 -2.66,-1.67 -0.68,-0.94 -1.41,-4.68 -1.17,-1.23 -9.22,0.78 -5.37,-0.99 -10.39,1.38 -0.46,0.3 0.02,2.69 -0.75,3.4 0.07,3.85 0.59,0.72 2.86,0.93 4.94,0.12 0.83,0.7 1.24,2.62 0,0 -4.63,0.36 -1.28,0.52 -2.14,4.61 -1.13,4.39 -0.78,0.85 -3.68,1.93 -7.64,2.38 -4.25,2.369995 -2.18,2.28 -0.27,2.89 0.7,12.32 -0.86,6.33 2.09,4.58 -0.67,4.06 3.14,7.8 -0.95,0.58 -2.71,0.07 -2.45,1.7 -3.75,1.03 -1.82,1.63 -0.07,2.21 -1.52,2.67 0.78,3.61 1.11,2.26 3.6,2.68 0,0 -0.99,1.1 -0.84,2.05 -5.62,2.24 -1.57,-0.78 -0.97,-1.58 -2.05,-1.73 -6.78,-2.29 -1.39,0.28 -3.06,2.59 -1.2,2.97 0.01,1.39 -0.58,0.54 -1.4,0.09 -2.77,-1.1 -1.95,-0.11 -3.45,1.09 0.12,2.04 1.81,3.36 -1.38,1.91 -2.69,1.52 -1.75,-0.23 -4.25,-4.29 -6.35,-1.93 0.39,-1.32 2.89,-2.69 0.23,-1.07 -0.79,-1.74 -1.36,-0.9 -1.94,0.18 -4.41,-0.88 0,0 0.02,-2.33 1.25,-6.1 -0.9,-3.69 -1.91,-1.9 -0.16,-1.07 0.45,-3.76 1.56,-4.14 0.65,-4 1.5,-0.84 6.61,-0.13 1.28,0.87 4.88,-3.97 0.55,-3.2 3.34,0.81 1.89,-1.62 -0.5,-1.95 -1.16,-1.43 -2.68,-2.29 -2.53,-1.16 -1.26,-1.21 1.82,-3.63 1.09,-5.16 -0.95,-2.47 0.13,-1.68 -0.69,-3.05 -2.5,-5.199995 0.4,-3.57 -1.31,-3.21 -0.39,-4.75 -1,-5.17 0.07,-6.05 -0.99,-6.17 1.44,-10.82 0,0 4.86,-1.57 5.28,-5.36 8.7,0.78 3.58,-0.74 23.4,-14.15 1.28,-0.33 z",
    title: "Katsina",
    id: "NG-KT",
    state: "Katsina",
  },
  {
    class: "active-state",
    d: "m 62.361651,236.35874 5.38,-0.92 11.32,-0.35 3.62,0.93 13.98,15.86 1.99,3.1 5.609999,6.48 2.29,1.58 1.7,-0.18 1.04,0.48 0.27,2.94 -0.73,4.65 0.06,5.38 0.88,3.68 1.3,0.39 7.57,-0.79 0.84,0.74 0.43,1.62 -0.19,3.43 0.35,1.4 0.66,1.02 3.21,2.41 3.04,0.39 1.07,0.55 0.9,2.11 0.74,5.45 1.89,1.32 2,-0.01 9.16,-3.56 2.41,-0.16 6.35,3.01 1.42,1.1 6.35,7.23 2.25,0.69 3.96,-1.16 4.52,0.81 3.73,1.61 0.64,-0.27 11.77,7.32 5.19,3.67 0.93,1.49 1.46,0.71 1.84,0.6 4.92,0.32 3.39,-0.91 7.52,-0.31 8.26,1.71 0,0 -2.46,3.35 -2.31,7.79 -0.64,6.49 -1.57,3.76 -3.03,0.5 -6.3,-1.52 -3.92,0.12 -2.13,-0.69 -3.71,0.21 -2.76,-1.08 -1.84,-0.08 -7.04,-3.01 -2.17,-1.76 -1.77,-2.62 -3.6,2.29 -3.71,4.04 -2.29,3.91 -2.14,2.43 -0.17,0.99 1.92,3.7 2.41,2.45 0.07,0.67 2.42,1.81 0.13,0.59 4.76,2.58 0.82,2.41 -0.75,1.44 0,0 -5.76,0.09 -4.11,1.34 -0.82,2.22 0.29,0.63 -1.04,2.16 -1.29,-0.55 -1.95,0.58 -2.3,-0.62 -2.33,0.23 -0.95,-0.49 -1.47,-2.06 -0.95,-0.37 -4.48,1.25 -1.03,-0.49 -0.61,-1.67 -0.41,0.17 0,0 -0.39,-0.54 -1.67,0.8 -3.49,0.13 -1.48,-3.17 -2.18,-0.58 -4.74,1.7 -2.65,-0.38 0.08,0.88 -0.18,-0.85 -0.36,0.09 -3.55,1.61 -2.6,0.31 -8.27,-0.22 0,0 -0.49,-0.66 -1.45,-0.07 -0.71,-0.94 -1.9,-4.81 -0.39,-2.77 -0.78,-0.66 -0.03,-0.8 -3.46,-2.25 -2.95,-4.24 -1.22,-3.44 -0.09,-2.1 -0.79,-2.77 -1.97,-2.63 -2.999999,-7.11 -1.66,-1.91 -1.32,-5.29 -0.81,-1.58 1.03,-4.5 2.08,-1.55 0.35,-1.6 0.57,-0.59 3.159999,-2.09 2.34,-3.16 -0.16,-1.3 -1.31,-0.78 -2.829999,1.8 -2.21,0.08 -3.83,-1.08 -1.1,0.13 -2.4,-1.54 -5.7,-1.74 -3.25,-2.42 -1.69,-2.04 -0.54,-2.48 -4.08,-2.46 -2.04,0.09 -3.82,2.08 -1.69,3.71 -0.02,2.65 -0.45,1.11 -4.42,3.43 -6.64,2.92 -5.79,3.3 -2.49,1.94 -1.13,0.26 -3.01,2.21 -7,3.26 -0.93,0.15 -0.53,-0.75 -0.45,0.11 -0.91,-1.13 -0.69,-0.19 -2.57,0.27 -6.93,5.53 -1.66,0.66 -3.91,3.44 -0.19,0.99 -1.5,0.79 -4.08,0.72 -3.17,0.02 -3.19,2.78 0,0 0.56,-1.78 -0.59,-1.36 -0.01,-3.54 -0.71,-0.9 0.24,-1.44 0.55,-1.39 -0.39,-2.71 -0.97,-1.79 0.74,-1.4 1.43,-0.91 -0.4,-3.34 0.69,-0.23 0.34,-1.72 -0.2,-0.62 0.02,-0.88 0.69,-1.64 0.43,-1.56 -0.41,-0.76 -0.27,-0.77 -0.35,-0.78 0.13,-1.17 0.25,-1.73 0.16,-0.69 5.37,0.18 0.71,-0.16 1.05,-1.18 3.55,-0.56 0.66,0.82 1.24,0.45 1.49,-0.1 4.95,-1.73 0.25,-1.76 1.95,-3.88 0.17,-3.74 1.91,-1.88 -0.34,-5.82 -1.28,-4.01 0.31,-1.42 1.16,-1.88 2.47,-1.38 0.82,-1.83 2.59,-3.62 0.85,-3.1 1.04,-0.59 2.14,0.25 2.09,-1.73 0.1,-1.22 -1.34,-2.56 -0.32,-1.93 0.37,-1.34 1.11,-1.22 6.75,-2.7 3.39,0.24 1.14,-0.3 2.02,-2.06 0.12,-1.3 2.36,-2.59 0.57,-2.41 0.25,-4.97 0.85,-1.1 2.08,-0.86 z",
    title: "Kwara",
    id: "NG-KW",
    state: "Kwara",
  },
  {
    class: "active-state",
    d: "m 3.411651,463.64874 1.25,0.4 3.41,-0.43 1.94,0.89 3.46,-2.44 0,-1.61 0.41,-0.11 3.55,0.53 13.71,-0.19 1.06,-1.01 0.77,-3.95 2.08,-1.65 0.09,-2.35 1.36,-2.51 1.85,0.25 3.41,1.43 1.2,0.8 0.81,1.43 4.57,-0.48 -0.51,-1.45 1.59,-1.06 37.58,0.39 1.07,0.21 0.54,0.9 -2.73,2.88 -0.23,0.94 0.73,1.24 0.04,1.46 2.19,1.09 3.22,-2.16 3.45,-0.41 1.06,1.48 0.12,0.95 -1.12,1.06 -2.8,1.31 -0.56,1.03 0.22,0.7 0.92,0.74 2.77,0.77 1.13,1.31 0.58,0.14 1.12,-0.58 5.269999,0.65 0.35,1.25 -0.36,2.36 0,0 -9.529999,-1.15 -2.19,-0.67 -12.02,-1.84 -8.59,-0.46 -9.91,0.94 -15.11,0.16 -0.57,0.31 -0.19,1.32 -0.53,-0.1 0.24,0.34 -5.42,-0.82 -6.02,0.01 -21.6,0.73 -9.49,1.1 -0.36,-3.11 z",
    title: "Lagos",
    id: "NG-LA",
    state: "Lagos",
  },
  {
    d: "m 307.24165,287.46874 1.34,-1.02 0.75,0.11 0.6,1.88 0.7,0.79 1.5,-0.61 0.93,0.14 2.44,1.79 1.34,-0.25 1.75,1.06 1.1,0 2.31,-2.1 0.94,-2.54 1.65,-2.12 1.01,-0.35 1.1,0.39 2.93,2.67 0.32,3.25 4.22,2.44 1.03,1.61 -0.05,9.7 0.4,1.31 1.34,0.96 1.15,-0.21 2.35,-1.6 4.16,-4.75 0.89,-1.9 1.29,-0.98 1.33,0.22 1.5,1.25 3.81,0.24 5.34,5.91 0.6,1.9 2.47,0.13 1.61,-0.42 0.82,-0.72 3.31,-5.4 2.65,-5.61 1.09,-0.57 0,0 1.69,1.65 2.42,0.11 2.08,0.85 0.63,4.48 1.93,3.41 2.16,0.98 5.32,0.56 3.7,0 2.77,-1.35 1.04,0.56 2.01,2.21 -0.79,2.93 -2.7,4.01 -2.11,1.98 -1.41,0.2 -1.46,1.05 -1.55,2.86 -1.55,1.36 -0.32,2.25 0.64,1.72 2.09,2.43 0.32,1.24 -0.3,5.41 1.44,2.07 5.15,2.71 3.66,1.3 8.19,-0.15 9.76,-2.79 10.36,4.33 2.52,2.07 1.46,2.68 0,0 -2.58,3.68 -2.74,0.82 -4.51,-0.95 -0.33,-0.41 -1.52,0.23 -1,-1.07 -1.73,-0.9 -1.86,0 -1.28,0.86 -1.33,2.14 -0.73,2.86 1.71,1.36 2.03,2.51 0.35,2.88 -0.54,0.65 1,2.68 -0.11,1.19 -11.23,7.21 -1.21,1.39 0,0 -11.79,-8.93 -0.01,0.7 -3.96,0.22 -4.88,-0.41 -6.86,-1.55 -10.09,-3.72 -2.68,-0.44 -2.59,0.18 -1.38,0.28 -3.95,2.2 -1.24,1.41 -1.02,2.86 0.08,2.52 4.7,11.64 -0.09,1.36 -1.14,1.1 -5.33,-2.23 -3.32,-2.8 -1.07,0.14 -5.25,-0.99 -4.92,-2.82 -8.71,-3.55 -8.51,-1.25 -9.13,-2.48 0,0 -7.7,-0.57 -3.58,-0.68 -7.07,0.7 -12.4,3.37 -9.26,4.07 -4.26,2.95 -0.69,-0.56 0.17,-3.74 0.85,-2.12 1.61,-1.67 0.04,-4.69 1.17,-4.71 -0.54,-6.17 -2.19,-2.66 -0.82,-1.69 0,-0.86 1.55,-2.66 0.6,-2.64 0,0 11.13,-1.75 2.91,-1.2 4.63,-1.06 6.96,-3.64 3.78,-4.62 1.04,-1.64 1.08,-3.4 0.79,-0.36 1.52,-7.95 1.98,-5.27 0.55,-7 -0.51,-2.19 0.08,-5.62 2.11,-6.52 0.53,-0.61 1.03,-0.07 0.42,-0.62 z",
    title: "Nassarawa",
    id: "NG-NA",
    state: "Nassarawa",
  },
  {
    d: "m 65.001651,173.89874 0.89,-0.52 2.89,0.36 11.04,6.08 3.49,1.42 1.86,0.29 12.17,-0.81 6.189999,0.36 4.5,-0.85 2.94,-0.07 5.24,1.69 8.4,5.7 1.58,-0.1 2.89,1.06 0.51,0.74 -0.2,4.05 -2.43,10.71 -4.62,4.43 -3.92,1.44 -1.48,1.01 -1.84,2 -1.46,3.26 -0.18,6.32 1.12,2.41 2.93,2.66 -0.29,3.94 -1.03,3.28 0.02,2.28 1.42,0.99 4.32,0.46 0.56,-0.48 0.5,-5.85 7.42,-2.5 3.38,-0.26 2.64,-1.57 1.77,-2.13 0.28,-1.53 -0.75,-2.44 -1.86,-3.03 -1.81,-1.97 -1.25,-2.83 0.45,-1.37 0.04,-9.59 0.9,-0.75 1.55,-0.42 5,0.52 5.22,-2.64 3.8,-0.97 1.01,-1.49 0.07,-2.07 -1.17,-1.36 -2.74,-1.63 -0.49,-1.45 0.63,-1.47 2.18,-1.45 0.25,-1.07 -1.12,-6.56 -0.78,-0.74 -1.71,0.03 -1.05,-2.01 -5.36,-0.53 -5.4,-2.19 -3.63,-2.01 -0.87,-1.26 -0.16,-1.54 1.37,-2.07 4.85,-2.59 4.43,-1.62 7.87,-1.83 9.86,-1.59 3.64,0.04 2.84,0.71 1.69,1.6 0.98,6.51 0.81,1.26 3.75,2.47 0.48,1.78 -0.37,4.81 0.36,4.02 1.64,1.25 10.67,-0.69 12.1,-5.08 3.93,-0.41 1.28,-2.2 3.42,-2.76 1.85,0.36 1.36,1.1 0,0 3.32,4.4 3.8,6.64 1.59,4.09 -0.07,0.84 0,0 -3.04,5.38 -0.4,4.79 1.44,2.38 0.14,1.48 -0.74,2 0.24,3.81 -1.84,1.8 -0.33,2.31 0.22,1.37 3.05,2 1.22,3.52 1.43,0.6 1.41,-0.89 5.38,-7.01 5.59,-4.5 2.46,-1.5 2.1,-0.61 2.91,-0.13 1.02,1 1.04,2.66 7.63,-2.86 3.97,0.56 0.64,-0.98 -0.67,-2.39 1.18,-1.2 4.73,0.5 0.61,0.51 0.48,1.92 0.28,4.5 1.39,0.14 2.25,-0.67 1.61,0.44 1.98,3.8 -0.05,2.57 -1.35,4.14 4.83,1.66 3.23,1.75 -0.31,1.98 -1.02,1.79 -4.24,2.6 -0.85,1.48 -1.62,1.68 -2.17,1.36 -0.91,1.24 1.03,1.98 1.71,1.66 6.67,2.49 12.87,-0.08 1.37,0.67 0.33,1.01 0.16,5.06 0.92,3.88 0.1,3.09 -0.63,1.51 -3.23,0.41 -0.88,0.42 -0.29,0.64 0.17,0.91 1.13,0.77 3.62,1.36 -0.83,3.02 3,1.62 0.58,1.88 -3.09,3.17 -0.6,2.79 -0.79,0.87 -2.45,1.29 -0.56,0.93 -0.09,2.32 3.39,2.78 -1.38,4.13 2.46,-0.6 1.23,0.42 0,0 -8.65,12.34 -0.94,0.24 -9.19,-8.1 -1.76,-0.63 -11.03,0.47 -2.68,0.33 -0.34,0.38 -0.36,13.66 0.75,30.21 -0.46,1.37 1.95,4.91 1.42,0.47 1.83,-0.21 0,0 -1.12,3.25 -3.57,1.74 -0.06,2.97 -0.46,0.09 -0.99,-0.88 -0.19,0.26 -1.24,2.53 -0.62,2.89 -0.33,0.35 -1.63,-0.25 -2.72,-2.54 -5.47,-7.27 -2.71,-2.69 -3.71,-2.3 -2.55,-8.25 -2.77,-4.32 -3.52,-3.25 -2.77,-1.58 -2.2,-0.57 0,0 -8.26,-1.71 -7.52,0.31 -3.39,0.91 -4.92,-0.32 -1.84,-0.6 -1.46,-0.71 -0.93,-1.49 -5.19,-3.67 -11.77,-7.32 -0.64,0.27 -3.73,-1.61 -4.52,-0.81 -3.96,1.16 -2.25,-0.69 -6.35,-7.23 -1.42,-1.1 -6.35,-3.01 -2.41,0.16 -9.16,3.56 -2,0.01 -1.89,-1.32 -0.74,-5.45 -0.9,-2.11 -1.07,-0.55 -3.04,-0.39 -3.21,-2.41 -0.66,-1.02 -0.35,-1.4 0.19,-3.43 -0.43,-1.62 -0.84,-0.74 -7.57,0.79 -1.3,-0.39 -0.88,-3.68 -0.06,-5.38 0.73,-4.65 -0.27,-2.94 -1.04,-0.48 -1.7,0.18 -2.29,-1.58 -5.609999,-6.48 -1.99,-3.1 -13.98,-15.86 -3.62,-0.93 -11.32,0.35 -5.38,0.92 0,0 0.49,-3.02 -1.96,-0.7 -2.1,-2.02 -1.75,-3.54 3.08,-6.97 -0.14,-1.69 0.89,-1.14 2.58,-1.33 6.08,3.19 1,-3.12 0.25,-2.99 2.82,-6.43 -0.66,-6.2 -2.69,-1.9 -2.97,-5.6 1.21,-4.6 0.13,-2.04 -1.23,-5.05 -2.13,-0.82 0.42,-1.95 -0.28,-1.95 0.51,-1.95 z",
    title: "Niger",
    id: "NG-NI",
    state: "Niger",
  },
  {
    class: "active-state",
    d: "m 0.96165097,375.38874 5.97000003,-4.29 3.49,-0.21 1.9,0.93 1.24,1.79 0.41,1.43 0.15,6.48 0.56,2.36 1.31,2.17 0.84,0.13 0.94,-5.56 0.57,-1.25 0.47,-0.45 1.37,0 0.88,0.61 0.54,1.75 -0.16,3.09 -1.74,5.98 -0.41,-0.24 -0.51,0.57 0.52,3.66 2.12,2.51 3.05,2.47 1.02,3.04 3.2,4.51 3.01,2.36 2.34,1.13 4.05,0.28 1.74,-0.49 2.78,-3.97 1.14,-4.24 1.62,-1.48 2.6,0.29 1.75,4.34 1.59,1.13 1.02,-0.26 1.13,-1.11 2.47,-0.6 6.2,0.22 1.17,1.89 0.33,5.66 0.41,0.71 2.98,1.22 0.64,1.1 -0.1,2.22 1.1,2.7 0.41,2.87 -3.97,4.01 -0.33,1.13 0.37,0.28 6.09,-0.25 2.7,-0.58 3.04,0.13 3.18,-1.24 1.51,-1.37 5.89,-0.88 0,0 2.74,-1.08 1.4,-1.11 0.94,0.39 0.52,0.84 0.59,4.28 1.97,-0.01 3.85,-1.98 3.389999,0.59 2.97,7.11 3.06,-1.96 1.1,-0.02 1.15,0.69 2.12,-0.92 4.16,-0.26 0.31,0.13 -0.3,1.01 0,0 -0.75,5.5 -1.06,3.26 -2.35,2.1 -2.06,0.97 -3.63,3.28 -2.98,4.92 0.03,3.41 2.01,1.97 4.81,0.81 1.83,-0.13 1.42,-1.06 1.65,-2.27 1.76,-0.51 0.65,0.78 -0.02,4.47 0.85,3.57 -0.72,1.81 -2.44,0.66 -0.77,1.14 -1.12,0.68 -2.4,0.11 -1.32,1.34 0.98,0.43 2.79,-0.25 3.3,1.74 0.21,1.08 -0.82,1.72 -4.01,-0.28 0,0 -5,-2.24 -4.38,-0.93 0,0 0.36,-2.36 -0.35,-1.25 -5.269999,-0.65 -1.12,0.58 -0.58,-0.14 -1.13,-1.31 -2.77,-0.77 -0.92,-0.74 -0.22,-0.7 0.56,-1.03 2.8,-1.31 1.12,-1.06 -0.12,-0.95 -1.06,-1.48 -3.45,0.41 -3.22,2.16 -2.19,-1.09 -0.04,-1.46 -0.73,-1.24 0.23,-0.94 2.73,-2.88 -0.54,-0.9 -1.07,-0.21 -37.58,-0.39 -1.59,1.06 0.51,1.45 -4.57,0.48 -0.81,-1.43 -1.2,-0.8 -3.41,-1.43 -1.85,-0.25 -1.36,2.51 -0.09,2.35 -2.08,1.65 -0.77,3.95 -1.06,1.01 -13.71,0.19 -3.55,-0.53 -0.41,0.11 0,1.61 -3.46,2.44 -1.94,-0.89 -3.41,0.43 -1.25,-0.4 0,0 0.42,-3.28 1.13,-1.18 0.63,-1.54 -1.34,-3.74 1.3,-2.16 2.11,-1.8 0.2,-2.74 -0.21,-0.96 -2.14,-0.28 -0.78,-0.39 -0.41,-0.86 -0.17,-1.82 1.2,-1.9 -0.34,-1.07 0.48,-3.46 -0.22,-0.98 -1.3,-0.14 -0.54,-0.61 0.15,-2.86 1.4,-1.61 3.06,-1.78 -2.46,-2.23 -0.48,-0.96 1.87,-2.2 0.59,-1.92 -0.66,-4.66 -1.53,-1.66 -0.12,-9.69 2.37,-0.08 0.82,-0.48 0.04,-0.72 -0.42,-3.5 -2.68,-2.04 -0.22,-1.76 -0.98,-1.52 -0.3,-4.2 0.25,-8.96 -0.3,-0.95 -0.82,-0.35 -0.97,-2.58 -1.69000003,-2.17 z",
    title: "Ogun",
    id: "NG-OG",
    state: "Ogun",
  },
  {
    d: "m 194.92165,384.14874 4.62,-0.88 2.51,0.43 -0.71,4.14 2.04,2.7 4.74,4.17 0.23,0.78 0,0 -2.45,3.49 -0.9,0.6 -1.56,-0.14 -1.41,1.72 -0.18,1.38 0.4,0.84 2.02,0.82 -0.88,2.89 0.77,2.49 0.42,0.28 -1.43,3.54 -2.15,1.05 -1.76,1.83 -0.47,1.04 0.15,1.39 -3.23,6.89 0.32,0.83 -0.37,0.85 -1.51,0.73 -1.24,1.67 -0.62,4.63 1.18,1.28 0.16,0.82 -0.88,0.51 -0.01,1.63 -1.19,-0.51 -0.25,0.25 -0.95,4.96 -1.51,3.39 -2.68,1.03 -0.81,-0.36 -1.19,-1.48 -1.34,-0.12 -3.77,3.16 -0.74,0.03 -2.1,-5.46 2.01,-2.25 -1.74,-2.09 -1.64,-0.34 -3.29,0.39 -6.64,-0.11 -1.68,-0.36 -2.28,0.38 -2.12,-0.39 -2.2,1.01 -0.46,0.78 -0.09,1.96 -0.95,0.68 -0.79,2.27 -1.73,0.8 -0.45,1.04 -1.76,1.61 -0.49,0.96 0.09,2.22 -0.8,0.99 0,2.84 1.23,0.64 1.39,2.28 0.58,1.45 -0.36,1.72 -0.83,1.96 -1.74,1.71 -0.85,3.74 -2.94,0.86 -0.58,0.62 -0.96,3.62 -0.8,0.7 0.28,-0.44 -0.25,0.6 0.44,0.91 0.7,0.05 1.94,1.36 1.65,2.94 1.56,0.1 1.33,1.04 1.24,2.26 -0.39,1.16 0,0 -6.9,16.74 0,0 -4.86,-5.94 -9.17,-9.24 -14.82,-11.96 -2.7,-1.66 0,0 4,0.28 0.83,-1.73 -0.21,-1.07 -3.3,-1.74 -2.79,0.25 -0.98,-0.43 1.32,-1.35 2.4,-0.1 1.11,-0.68 0.78,-1.14 2.44,-0.66 0.72,-1.82 -0.84,-3.57 0.01,-4.47 -0.64,-0.78 -1.77,0.51 -1.65,2.27 -1.42,1.06 -1.83,0.13 -4.8,-0.81 -2.01,-1.96 -0.03,-3.41 2.98,-4.92 3.63,-3.28 2.06,-0.96 2.35,-2.1 1.07,-3.25 0.74,-5.51 0,0 2.67,-1.42 2.15,-4.97 4.29,-3.44 2.32,-0.02 2.51,1.24 2.91,2.22 1.81,0.03 0.64,-1.26 -0.23,-1.63 0.41,-2.11 -0.46,-3.98 1.56,-6.54 0.84,-0.57 5.86,-1.59 -0.62,-2.4 0,0 4.55,-1.45 7.78,0.43 6.97,-0.31 1.55,0.53 1.42,2.21 1.03,3.19 -0.16,0.86 1.09,2.69 2.28,0.59 5.53,-3.5 3.04,-4.43 1.71,-3.92 1.7,-8.1 1.13,-2.14 2.4,-2.48 2.18,-1.45 0.85,-2.06 1.86,-0.38 1.5,1.24 0.82,-0.3 1.49,-2.44 z",
    title: "Ondo",
    id: "NG-ON",
    state: "Ondo",
  },
  {
    d: "m 117.18165,366.88874 8.27,0.22 2.6,-0.31 3.55,-1.61 0.36,-0.09 0.18,0.85 -0.08,-0.88 2.65,0.38 4.74,-1.7 2.18,0.58 1.48,3.17 3.49,-0.13 1.67,-0.8 0.39,0.54 0,0 -1.52,5.3 -1.99,1.64 -2.18,0.94 -1.62,1.5 -1.9,4.25 -0.12,1.4 0.81,2.81 -1.19,3.99 0.69,4.78 2.85,6.11 0.84,3.79 0.83,1.7 0,0 0.62,2.41 -5.86,1.58 -0.84,0.58 -1.56,6.54 0.46,3.98 -0.4,2.11 0.23,1.63 -0.64,1.26 -1.81,-0.03 -2.91,-2.22 -2.51,-1.24 -2.32,0.01 -4.28,3.45 -2.15,4.96 -2.67,1.43 0,0 0.3,-1.01 -0.31,-0.13 -4.16,0.26 -2.12,0.92 -1.15,-0.69 -1.1,0.02 -3.06,1.96 -2.97,-7.11 -3.389999,-0.59 -3.85,1.98 -1.97,0.01 -0.59,-4.28 -0.52,-0.84 -0.94,-0.39 -1.4,1.11 -2.74,1.08 0,0 2.34,-9.84 0.43,-5.29 1.67,-8.72 -0.87,-0.49 -3.05,-4.88 -3.11,-2.33 -0.27,-0.93 -0.14,-0.88 1.15,-1.09 0.78,-1.76 0.87,-9.27 0.6,-0.28 4.3,1.34 2.32,-0.75 0.78,-0.99 0.13,-2.3 1.06,-0.57 2.81,-3.32 3.009999,1.84 3.59,5.56 2.13,-0.93 0.65,-1.43 2.05,-1.16 0.98,-1.39 0.28,0.39 1.83,-1.51 2.29,-0.76 0.25,0.38 0.99,-1.34 0.31,-1.28 z",
    title: "Osun",
    id: "NG-OS",
    state: "Osun",
  },
  {
    class: "active-state",
    d: "m 5.381651,335.88874 3.19,-2.78 3.17,-0.02 4.08,-0.72 1.5,-0.79 0.19,-0.99 3.91,-3.44 1.66,-0.66 6.93,-5.53 2.57,-0.27 0.69,0.19 0.91,1.13 0.45,-0.11 0.53,0.75 0.93,-0.15 7,-3.26 3.01,-2.21 1.13,-0.26 2.49,-1.94 5.79,-3.3 6.64,-2.92 4.42,-3.43 0.45,-1.11 0.02,-2.65 1.69,-3.71 3.82,-2.08 2.04,-0.09 4.08,2.46 0.54,2.48 1.69,2.04 3.25,2.42 5.7,1.74 2.4,1.54 1.1,-0.13 3.83,1.08 2.21,-0.08 2.829999,-1.8 1.31,0.78 0.16,1.3 -2.34,3.16 -3.159999,2.09 -0.57,0.59 -0.35,1.6 -2.08,1.55 -1.03,4.5 0.81,1.58 1.32,5.29 1.66,1.91 2.999999,7.11 1.97,2.63 0.79,2.77 0.09,2.1 1.22,3.44 2.95,4.24 3.46,2.25 0.03,0.8 0.78,0.66 0.39,2.77 1.9,4.81 0.71,0.94 1.45,0.07 0.49,0.66 0,0 0.53,3.2 -0.31,1.28 -0.99,1.34 -0.25,-0.38 -2.29,0.76 -1.83,1.51 -0.28,-0.39 -0.98,1.39 -2.05,1.16 -0.65,1.43 -2.13,0.93 -3.59,-5.56 -3.009999,-1.84 -2.81,3.32 -1.06,0.57 -0.13,2.3 -0.78,0.99 -2.32,0.75 -4.3,-1.34 -0.6,0.28 -0.87,9.27 -0.78,1.76 -1.15,1.09 0.14,0.88 0.27,0.93 3.11,2.33 3.05,4.88 0.87,0.49 -1.67,8.72 -0.43,5.29 -2.34,9.84 0,0 -5.89,0.88 -1.51,1.37 -3.18,1.24 -3.04,-0.13 -2.7,0.58 -6.09,0.25 -0.37,-0.28 0.33,-1.13 3.97,-4.01 -0.41,-2.87 -1.1,-2.7 0.1,-2.22 -0.64,-1.1 -2.98,-1.22 -0.41,-0.71 -0.33,-5.66 -1.17,-1.89 -6.2,-0.22 -2.47,0.6 -1.13,1.11 -1.02,0.26 -1.59,-1.13 -1.75,-4.34 -2.6,-0.29 -1.62,1.48 -1.14,4.24 -2.78,3.97 -1.74,0.49 -4.05,-0.28 -2.34,-1.13 -3.01,-2.36 -3.2,-4.51 -1.02,-3.04 -3.05,-2.47 -2.12,-2.51 -0.52,-3.66 0.51,-0.57 0.41,0.24 1.74,-5.98 0.16,-3.09 -0.54,-1.75 -0.88,-0.61 -1.37,0 -0.47,0.45 -0.57,1.25 -0.94,5.56 -0.84,-0.13 -1.31,-2.17 -0.56,-2.36 -0.15,-6.48 -0.41,-1.43 -1.24,-1.79 -1.9,-0.93 -3.49,0.21 -5.97000003,4.29 0,0 1.07000003,-2.08 0.73,-4.3 1.33,-4.15 -0.3,-1.12 0.37,-2.7 1.13,-2.26 0.36,-2.89 -2.44,-3.06 -1.17,-3.99 0.08,-2.02 1.05,-1.87 -0.44,-2.05 0.48,-0.7 1.25,-0.3 1.37,-2.88 -0.43,-0.44 0.73,-0.97 0.01,-1.07 z",
    title: "Oyo",
    id: "NG-OY",
    state: "Oyo",
  },
  {
    d: "m 379.00165,223.49874 1.53,-0.49 3.18,0.08 2.78,0.88 2.61,4.16 0.78,4.8 -0.04,12.38 10.97,-2.19 1.06,0.21 1.8,1.92 0.97,3.13 0.26,5.94 -0.23,1.17 -2.38,4.47 -0.09,1.69 0.6,0.85 3.92,1.42 0.79,0.71 0.9,1.16 1.65,4.07 1.56,1.34 1.51,0.53 4.8,0.27 5.47,1.48 10.04,-0.59 4.39,-1.41 2.89,-5.21 4.76,-1.3 0.5,-1.67 -0.27,-1.74 -3.17,-4.06 0.3,-1.44 3.03,-1.78 7.6,3.95 2.57,0.51 9.26,4.93 11.07,4.74 6.18,4.04 6.36,3.43 0,0 1.56,3.94 0.21,2.15 -0.51,4.08 0.76,5.96 2.3,3.86 1.05,6.02 -0.55,1.33 0.3,2.25 0.43,0 0.21,5.54 -1.78,3.08 -12.18,5.86 -1.9,-0.11 -9.52,2.1 -2.49,1.44 -2.06,4.19 -4.74,5.72 -7.11,3.76 -7.68,7.65 -2.43,1.19 -4.41,1.01 -4.11,0.54 -3.85,-0.25 0,0 -1.46,-2.68 -2.52,-2.07 -10.36,-4.33 -9.76,2.79 -8.19,0.15 -3.66,-1.3 -5.15,-2.71 -1.44,-2.07 0.3,-5.41 -0.32,-1.24 -2.09,-2.43 -0.64,-1.72 0.32,-2.25 1.55,-1.36 1.55,-2.86 1.46,-1.05 1.41,-0.2 2.11,-1.98 2.7,-4.01 0.79,-2.93 -2.01,-2.21 -1.04,-0.56 -2.77,1.35 -3.7,0 -5.32,-0.56 -2.16,-0.98 -1.93,-3.41 -0.63,-4.48 -2.08,-0.85 -2.42,-0.11 -1.69,-1.65 0,0 1.67,-3.94 -0.12,-3.41 -1,-2.09 -1.71,-1.21 -2.57,-3.08 -3.26,-5.28 -0.1,-1.16 1.05,-1.4 -0.21,-4.74 1.76,-1.28 0.4,-3.08 1.91,-1.55 0.42,-1.07 -0.53,-2.1 0.7,-7.81 -0.18,-1.97 0.34,-1.1 2.39,-1.97 -0.75,-3.52 -1.36,-2.82 0.22,-2.71 2.13,-4.97 1.9,-1.4 2.19,-0.73 1.32,-1.56 0.55,-1.43 0.21,-2.9 z",
    title: "Plateau",
    id: "NG-PL",
    state: "Plateau",
  },
  {
    class: "active-state",
    d: "m 277.72165,584.56874 -1.46,1.39 0.02,0.77 -0.62,-0.24 0.22,-1.42 1.44,-0.82 0.4,0.32 z m -3.14,-1.84 -1.72,-0.98 -0.55,0.15 -0.55,0.15 -0.21,-0.69 0.86,-0.79 -0.31,-0.67 0.31,-0.65 -0.07,-1.05 -0.57,-0.81 -0.91,-0.17 -0.22,0.16 -0.71,-1.7 -0.27,-0.17 0.14,-0.46 -0.86,-0.86 -0.27,0.36 -0.96,0.15 -0.19,0.82 0.57,1.03 0.5,1.05 0.41,2.04 -0.48,-0.23 -0.45,0.63 1.07,3.48 -0.14,1.27 1.17,4.04 -0.24,0.22 0.77,0.46 2.06,-0.43 0.4,-0.45 0.13,-0.58 1.75,0.49 0.03,-2.23 0.67,-1.56 -1.16,-2.02 z m -3.8,-10.26 0.41,0.46 2.18,0.09 0.19,-0.91 -0.41,-0.31 -1.69,0.3 -0.68,0.37 z m 1.27,-2.46 0.36,1.13 0.52,0.19 -0.29,-1.9 -0.59,0.58 z m 7.2,9.74 -1.44,-2.86 -1,-0.7 -1.63,-0.81 -0.27,-0.12 -0.84,0.65 0.65,0.09 1.31,1.13 0.14,0.21 -0.23,0.46 0.52,0.93 0.12,1.92 1.29,1.2 0.91,0.17 0.67,-1.41 -0.2,-0.86 z m 5.92,6.12 -2.08,-2.62 -1.31,1.63 0.79,0.79 0.81,-0.24 0.38,0.91 0.76,0 0.22,0.62 1.17,-0.5 1.08,1.08 1.86,-1.49 -0.62,-0.55 -3.06,0.37 z m -19.91,-6.61 -1.12,0.53 -0.28,1.32 1.14,0.4 1.44,1.08 1.03,2.28 -0.29,-3.36 -0.36,-0.15 0.26,-1.49 -1.82,-0.61 z m 18.13,2.56 -2.37,-1.62 -1.55,-2.35 -0.03,-0.27 -0.48,-1.7 -0.48,0.43 -0.4,-0.36 0.43,-0.67 -0.03,-1.49 -0.12,-0.07 -0.57,1.85 -2.25,-0.7 -0.53,-0.1 -0.88,-1.08 -0.07,-1.52 -0.36,-0.29 -0.07,-0.46 -0.26,-0.17 -0.15,-0.65 0.5,-0.79 -0.98,-1.22 -0.81,0.53 -0.34,0.89 0.65,1.54 -2.06,0.77 -0.41,0.36 -0.93,0.38 -0.52,0.05 -1,0.77 -0.46,0.62 -0.09,-1.51 -0.58,0.74 -0.22,0.51 1,1.65 0.55,2.45 -1.31,0.45 -0.53,0.21 -1.38,-1.61 -0.71,-1.9 -1.45,-2.41 -1.5,-0.51 0.56,-1.55 -0.68,-2.22 0.98,-0.81 0.35,-0.48 -0.53,-0.67 -1.81,-0.24 -1.81,-1.11 -0.28,1.59 -0.89,0.57 -0.33,-0.77 -1.27,-0.14 -0.34,-0.34 -0.64,0.19 -0.77,0.03 -0.62,-0.87 -0.19,-0.14 -0.55,0.41 0.19,0.99 -0.14,0.33 0.46,0.31 1.27,1.27 -0.12,1.53 0.98,4.64 3.22,3.31 0.02,1.18 -1.81,1.46 -0.1,0.58 1.82,6.56 0.55,3.32 2.41,2.48 -0.29,0.33 -7.24,0.69 -2.24,-0.75 -0.09,-2.71 -0.24,-2.54 0.14,-0.46 -0.03,-0.17 -0.46,-2.71 -0.19,-0.75 1.94,-3.67 -0.19,-2.67 -0.67,0.15 -0.68,0.1 -3.96,-2.6 -1.2,-4.38 -1.38,-1.87 -1.99,-0.02 -6.54,2.54 -1.04,-0.26 -0.35,-1.94 0.42,-1.46 -3.31,-1.44 -0.5,-0.83 0.07,-4.34 1.9,-2.67 0.76,-2.05 0.03,-1.27 -1.29,0.16 -0.84,-0.78 1.33,-4.44 4.49,-7.84 2.77,0.17 0.55,-0.5 0.75,-2.49 1.54,-0.79 -0.23,-1.81 1.58,-1.07 0.95,-1.48 -0.03,-1.94 -0.63,-1.54 -0.76,-0.58 -1.92,-0.83 -2.94,0.49 -1.04,-0.28 -0.57,-1.04 0.21,-0.44 3.52,-1.81 0.19,-5.3 0.7,-1.48 2.05,-1.42 0.89,-1.75 0.82,-3.18 -1.09,-3.54 0.23,-0.35 1.11,1.28 2.4,0.21 -2.75,13.08 1.51,0.44 3.47,-0.67 2.12,0.78 0.44,1.66 -0.52,4.62 -1.09,2.76 0.26,1.37 1.84,1.3 1.72,3.41 2.16,1.65 2.14,0.41 6.72,-0.14 4.7,1.12 4.15,-1.07 2.13,-0.03 4.51,1.13 2.57,-0.95 0.55,0.05 0.66,1.72 0.06,2.78 -2.4,4.19 -3.41,4.33 -1.37,3.71 -0.16,1.09 0.6,1.11 1.45,1.41 1.8,0.27 3.13,-0.59 1.11,-0.64 2.79,-0.12 3.28,1.22 1.81,-0.42 2.94,1.4 2.35,1.79 1.95,3.49 0.63,2.3 -0.96,4.27 0.58,4.55 -0.51,0.32 -0.04,0.64 0.61,1.17 -1.22,0.77 -0.84,-0.72 -0.17,-0.98 -1.22,-0.27 -0.55,-0.26 -0.26,0.46 -1.39,1.18 -0.58,-0.24 -0.26,-0.36 -0.38,-0.02 -0.71,0.39 -1.5,-2.36 -1.27,0.96 -0.93,-0.36 -1.6,-0.5 -0.65,-1.03 -0.67,0.19 -0.74,-0.86 -0.62,0.51 -0.19,0.79 -0.89,0.33 0.34,1.08 0.27,1.03 0.24,0.6 0.78,0.6 0.77,-0.24 0.57,0.08 0.86,-0.31 -0.17,1.75 -1.77,0.17 -1.44,0.53 -0.74,-1.2 -0.1,-0.33 -1.05,-1.17 -0.15,-0.94 0.11,-0.22 z m 21.52,4.31 -0.69,-0.39 -0.43,-0.03 -0.88,-0.36 -0.02,-0.02 -0.4,-0.36 -0.42,0.46 -0.32,-0.13 0.35,-0.54 -0.88,-1.49 -0.9,0.53 -1.04,-0.9 -0.36,-0.34 -0.17,-0.51 -1.39,0.01 -0.26,0.28 -1.23,0.87 -1.33,-0.05 -0.46,0.04 -0.43,-0.23 -0.63,-0.63 -0.53,-0.31 -0.09,-0.81 -1.24,0.34 -1.03,0.02 0.02,-0.42 -1.25,-0.34 -0.91,-0.46 -1.34,-0.09 -0.48,0.24 -0.23,0.58 -0.02,0.79 1.72,0 0.09,0.08 1.17,1.07 0.23,0.67 0.36,1.37 0.84,0.31 0.16,-0.4 0.34,0.28 1.07,0.03 0.06,0.22 -1.84,0.74 -0.43,0.15 -0.69,2.4 5.47,0.77 4.18,-0.92 5.93,-0.14 -0.19,-1.22 0.52,-1.16 z m -48.68,-18.07 0.79,-0.17 0.92,-0.79 0.08,-1.12 1.29,0.9 1.6,0.63 -0.96,1.17 0.43,1.85 0.27,0.32 -0.03,0.58 -0.6,0.94 0.22,0.64 1.01,0.31 1.26,1.35 2.07,4.36 -0.93,0.61 -0.42,0.84 0.15,0.91 3.15,1.85 0.6,2.9 0.88,1.32 -0.12,1.39 0.48,1.61 1.48,1.13 -1.12,1.39 -0.96,0.36 -0.86,-0.5 -0.6,0.41 -6.38,-1.39 -0.81,-2.54 0.53,-0.62 -0.6,0.02 -1.36,-3.89 -0.81,-1.9 0.1,-2.06 1.63,-1.56 -0.17,-1.35 -1.81,-1.66 -1.69,-1.15 -0.76,-4.06 -0.29,-0.58 0.02,-1.82 -0.77,-1.08 1.24,-0.74 0.88,0.63 0.67,0 0.3,0.56 z",
    title: "Rivers",
    id: "NG-RI",
    state: "Rivers",
  },
  {
    class: "active-state",
    d: "m 178.43165,0.2287449 12.88,5.68 20.53,7.2500001 4,2.35 4.64,-1.49 3.65,-0.02 8.54,4.12 15.88,15.56 5.98,10.42 0,0 -3.03,2.6 -7.1,4 -9.51,-1.28 -1.9,-0.66 -1.7,-2.05 -2.27,-0.68 -4.97,-0.19 -0.59,5.48 -0.73,1.89 -0.5,0.22 -2.7,-1.44 -2.79,0 -4.85,1.56 -2.11,1.82 -0.11,0.7 0.78,5.14 0.07,8.44 -1.35,1 -4.04,1.64 -10.02,0.79 -6.09,0.95 -5.83,8.58 -1.88,1.87 -3.07,1.91 0.06,2.88 1.43,4.64 0.65,4.25 -0.74,3.029995 -2.46,1.7 -6.11,0.53 -1.28,-0.29 -4.8,0.64 -2.64,-0.31 -4.47,0.33 -9.33,-1.67 -0.92,0.6 -0.93,4.51 0.1,18.21 -0.66,13.78 0,0 -1.62,0.97 -0.94,-0.07 -0.77,-1.75 -2.04,0.72 -1.89,-0.86 -1.69,0.12 -12,5.45 -2.4,3 -1.71,1.35 -2.78,-0.29 -0.76,-0.51 -2.55,-3.65 1.16,-4.77 2.61,-5.63 2.12,-9.79 -0.79,-13.05 0.14,-9.94 1.01,-3.779995 1.28,-1.48 3.95,-1.18 2.68,-0.02 3.17,2.04 1.02,-0.04 0.64,-1.56 0.24,-8.02 -1.68,-5.52 -0.04,-2.04 1.3,-6.06 0.18,-3.32 -1.8,-4.28 -1.86,-2.15 0.42,-3.7 1.42,-2.98 -0.09,-2.4 1.62,-3.93 -0.4,-1.25 -1.08,-0.88 -1.16,0.31 -2.49,3.69 -0.63,0.56 -1.82,0.43 -3.06,-0.68 -2.95,-2.07 -9.56,-3.12 -1.06,-1.1 -3.19,-1.82 -1.65,-2.12 -0.76,-0.31 -4.629999,1.58 -1.86,-0.74 -6.62,0.14 0,0 0.09,-16.44 4.14,-0.02 16.559999,-14.58 25.12,-5.0100001 2.41,2.14 5.71,0.48 6.45,-0.72 4.85,0.56 5.33,-0.16 5.25,-6.26",
    title: "Sokoto",
    id: "NG-SO",
    state: "Sokoto",
  },
  {
    d: "m 488.91165,275.87874 4.59,-2.65 5.85,0.78 10.59,-4.85 6.44,1.09 3.99,0.03 0,0 3.57,0.71 5.9,-0.6 12.46,0.02 6.37,-0.47 0,0 5.45,10.18 1.46,1.92 4.65,1.08 2.08,1.29 5.26,9.82 -0.46,2.17 0.34,3.84 2.66,2.94 4.14,1.47 2.02,3.84 0.26,1.81 -1,3.62 -5.99,11.44 0.38,5.78 -0.44,2.08 -6.12,5.22 -8.63,11.52 -5.08,5.48 -3.8,3.22 -4.14,4.78 -0.82,1.58 2.52,6.73 2.91,4.7 2.71,2.45 2.72,-1.99 2.83,-4.01 1.64,-0.38 1.42,0.43 1.52,1.12 2.5,3.15 4.32,3.84 2.15,2.6 1.04,2.02 -0.58,5.49 0.74,1.73 0.38,3.54 1.94,4.62 -0.05,1.56 1.22,0.88 0,0 -4.94,5.48 -1.09,1.94 -0.89,2.92 0.38,5.92 0.92,3.32 1.33,2.12 -0.18,1.29 -0.98,0.73 -4.04,-0.35 -0.68,0.46 -2.06,0.06 -0.18,1.64 -1.72,0.75 -1.54,1.93 -1.91,0.43 -1.09,4.21 -2.12,0.65 -1.37,2.72 0.06,0.5 0.94,-0.05 0.46,0.44 0.09,1.77 0.88,0.11 0.19,0.89 -0.99,0.43 -0.62,1.15 0.94,1.52 -0.08,1.04 -1.92,1.11 -0.22,3.22 -1.46,1.44 -0.57,1.91 -1.81,0.78 -1.77,-0.83 -0.6,0.54 -1.24,0.15 -0.46,0.64 0.46,0.88 -0.18,1.73 -0.44,0.5 -3.75,0.68 -0.42,0.22 -0.2,1.37 -1.37,-0.18 -3.03,-2.03 -2.25,1.01 -0.67,-0.7 -3.01,-0.66 -1.42,-1.22 -0.58,0.05 -1.22,1.41 -2.03,-0.08 0.24,-8.73 -2.03,-2.16 -2.24,-0.11 -2.36,2.14 -2.84,-0.48 -1.86,-0.85 -1.43,-3.38 -1.18,-2.19 -1.22,-0.81 -1.17,-0.07 -1.31,-2.11 -0.12,-0.73 1.66,-4.79 -2.66,-1.84 -1.49,-0.2 -0.6,0.74 -1.69,-2.15 -1.03,-0.08 -1.5,-1.61 -0.77,-0.07 -0.36,-1.52 -1.25,-0.63 -0.4,0.46 -1.47,-0.36 -1.85,-1.58 0.52,-1.93 -0.4,-2.09 -1.65,-1.31 -0.76,4.76 0.08,2.89 -1.39,6.02 -0.88,1 -1.67,0.57 -0.34,0.87 -0.64,0.11 -0.94,-0.97 -15.69,1.52 -2.64,-3.08 0.62,-1.75 -0.85,-2.06 -0.19,-1.18 0.07,-0.81 -0.89,-0.32 -8.2,7.4 -0.64,1.12 -2.44,1.72 -1.12,1.84 -4.62,4.63 -1.34,-0.72 -2.2,-0.1 -1.6,-0.22 -0.8,-0.61 -0.9,2.13 0.3,0.79 -0.76,0.97 -0.38,1.8 0.36,2.03 -0.28,1.07 -0.6,0.37 -1.02,2.82 -1.35,5.37 -0.5,0.39 -0.68,-0.34 -1.32,0.37 -1.03,-1.32 -0.44,0.46 0,0 1.9,-8.19 0.03,-8.76 0.33,-1.08 -0.61,-0.73 2.11,-11.5 3.31,-6.16 3.44,-3.25 3.09,-1.94 0.92,-1.43 -0.29,-5.92 2.38,-5.89 0.59,-3.23 -0.56,-1.78 0.26,-1.04 -1.17,-1.36 0.14,-0.65 -8.37,-7.57 -4.44,-5.65 -5.14,-4.9 -7.48,-1.77 -8.18,-0.48 -7.47,0.95 -6.12,2.63 -1.9,-0.57 3.79,-5.97 0,0 1.21,-1.39 11.23,-7.21 0.11,-1.19 -1,-2.68 0.54,-0.65 -0.35,-2.88 -2.03,-2.51 -1.71,-1.36 0.73,-2.86 1.33,-2.14 1.28,-0.86 1.86,0 1.73,0.9 1,1.07 1.52,-0.23 0.33,0.41 4.51,0.95 2.74,-0.82 2.58,-3.68 0,0 3.85,0.25 4.11,-0.54 4.41,-1.01 2.43,-1.19 7.68,-7.65 7.11,-3.76 4.74,-5.72 2.06,-4.19 2.49,-1.44 9.52,-2.1 1.9,0.11 12.18,-5.86 1.78,-3.08 -0.21,-5.54 -0.43,0 -0.3,-2.25 0.55,-1.33 -1.05,-6.02 -2.3,-3.86 -0.76,-5.96 0.51,-4.08 -0.21,-2.15 z",
    title: "Taraba",
    id: "NG-TA",
    state: "Taraba",
  },
  {
    d: "m 526.42165,32.448745 12.45,0.19 9.56,1.2 10.76,4.18 11.69,2.55 2.73,1.51 6.09,5.17 4.78,3 1.58,0.14 0.3,-0.82 1,-0.28 1.65,0.65 0.62,-0.52 -0.55,-1.18 1.49,0.16 1.7,0.94 1.66,-0.42 0.83,0.71 0.63,1.07 1.04,-0.62 2.85,0.61 0.74,0.5 0.93,0.12 0.99,-0.01 0,0 -0.08,4.21 -1.49,8.02 1.23,3.85 1.45,1.82 4.8,3.84 0.48,3.74 -1.84,4.21 -2.37,3.08 -7.06,6.31 -0.55,2.2 1.72,3.83 -0.05,5.789995 -2.54,16.29 -0.13,3.5 1.69,7.44 -4.72,9.14 0.15,1.94 0.64,0.36 4.91,-0.21 3.13,3.75 0.84,3.33 -0.99,2.11 -4.54,4.43 -3.3,5.9 -2.89,3.35 -0.9,2.86 0.04,2.97 0.76,4.15 -0.24,2.94 -2.09,3.08 -6.11,3.65 -11.21,3.02 -2.66,1.92 -1.72,2.83 -0.61,2.77 0.28,8.39 -3.41,4.53 -3.04,0.69 0,0 -6.78,0.01 -0.3,-0.51 -0.77,-6.45 1.2,-11.85 -0.67,-4.87 -3.68,-3.38 -1.58,1.02 1,-1.54 -3.42,-3.58 -4.75,-6.4 -8.49,-6.26 -2.18,-1.29 -2.98,-1.01 -4.04,-0.17 -4.17,1.51 -0.91,0.88 0,0 -3.04,-0.37 -1.63,-1.53 0.99,-6.78 1.05,-2.72 0.23,-4.92 -8.35,-20.91 -0.2,-3.87 -0.95,-2.71 -0.33,-2.7 -0.21,-6.74 -3.16,-4.66 0.19,-1.81 -0.77,-7.079995 -1.14,-2.93 -7.74,-6.19 0,0 -0.87,-2.9 -1.76,-11.53 -2.21,-3.4 -1.85,-0.88 -2.03,0.61 -4.99,-2.22 -5.86,1.86 -1.12,0.72 -1.46,-2.53 -0.69,-4.35 -2.13,-4.78 -2.21,-1.25 -6.33,1.96 -2.82,1.37 -3.16,0.63 -5.32,2.59 -2.1,3.99 -3.14,1.8 -6,-0.73 -1.79,-1.18 0,0 7.38,-7.5 3.25,-4.6 4.08,-3.51 5.19,-5.85 3.98,-2.54 9.05,-4.06 16.06,-0.94 12.55,-4.7 19.58,-1.07 z",
    title: "Yobe",
    id: "NG-YO",
    state: "Yobe",
  },
  {
    d: "m 258.59165,50.268745 5.45,6.52 5.08,-0.11 3.34,-0.61 0,0 -1.44,10.82 0.99,6.17 -0.07,6.05 1,5.17 0.39,4.75 1.31,3.21 -0.4,3.57 2.5,5.199995 0.69,3.05 -0.13,1.68 0.95,2.47 -1.09,5.16 -1.82,3.63 1.26,1.21 2.53,1.16 2.68,2.29 1.16,1.43 0.5,1.95 -1.89,1.62 -3.34,-0.81 -0.55,3.2 -4.88,3.97 -1.28,-0.87 -6.61,0.13 -1.5,0.84 -0.65,4 -1.56,4.14 -0.45,3.76 0.16,1.07 1.91,1.9 0.9,3.69 -1.25,6.1 -0.02,2.33 0,0 -1.01,-0.03 -2.34,2.38 -2.75,1.77 -0.85,1.14 -1.71,3.41 -0.64,3.55 -1.51,3.23 -3.04,3.1 -2.33,1.51 -4.71,0.62 -7.94,-0.57 -5.64,0.95 -5.27,4.71 -2.86,4.16 -1.28,0.76 -1.68,0.12 0,0 0.07,-0.84 -1.59,-4.09 -3.8,-6.64 -3.32,-4.4 0,0 -0.21,-5.48 -1.38,-7.58 -1.93,-3.01 -5.38,-2.71 0,-1.2 2.05,-6.49 0.01,-2.47 -1.41,-2.15 -4.35,-1.77 -4.85,-0.62 -1.22,0.81 -2.49,0.59 -3.79,-0.5 -5.47,0.76 -3.65,-2.41 -2.87,-0.11 -1.69,-3.3 -1.08,-0.57 -3.61,0.65 -2.09,-0.31 -0.91,-0.64 -0.79,0.15 -1.06,0.62 -0.82,2.32 -6.34,1.46 -4.11,-2.25 -1.82,0 -0.86,0.48 0,0 0.66,-13.78 -0.1,-18.21 0.93,-4.51 0.92,-0.6 9.33,1.67 4.47,-0.33 2.64,0.31 4.8,-0.64 1.28,0.29 6.11,-0.53 2.46,-1.7 0.74,-3.029995 -0.65,-4.25 -1.43,-4.64 -0.06,-2.88 3.07,-1.91 1.88,-1.87 5.83,-8.58 6.09,-0.95 10.02,-0.79 4.04,-1.64 1.35,-1 -0.07,-8.44 -0.78,-5.14 0.11,-0.7 2.11,-1.82 4.85,-1.56 2.79,0 2.7,1.44 0.5,-0.22 0.73,-1.89 0.59,-5.48 4.97,0.19 2.27,0.68 1.7,2.05 1.9,0.66 9.51,1.28 7.1,-4 3.03,-2.6 0,0 z",
    title: "Zamfara",
    id: "NG-ZA",
    state: "Zamfara",
  },
];

export const nigeriaText = [
  {
    x: "308.0166015625",
    y: "514.7637176513672",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Abia",
  },
  {
    x: "590.822021484375",
    y: "279.6189422607422",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Adamawa",
  },
  {
    x: "319.4166717529297",
    y: "566.6486511230469",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Akwa Ibom",
  },
  {
    x: "267.7466583251953",
    y: "478.3687286376953",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Anambra",
  },
  {
    x: "432.2466583251953",
    y: "196.69873809814453",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Bauchi",
  },
  {
    x: "374.1866760253906",
    y: "412.8487091064453",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Benue",
  },
  {
    x: "649.5014343261719",
    y: "126.86371803283691",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Borno",
  },
  {
    x: "209.60169982910156",
    y: "565.0484924316406",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Bayelsa",
  },
  {
    x: "351.68157958984375",
    y: "515.7439117431641",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Cross River",
  },
  {
    x: "200",
    y: "521.8837127685547",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Delta",
  },
  {
    x: "329.47166442871094",
    y: "477.6887512207031",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Ebonyi",
  },
  {
    x: "191.65664672851562",
    y: "464.2837219238281",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Edo",
  },
  {
    x: "166.9366683959961",
    y: "389.37371826171875",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Ekiti",
  },
  {
    x: "292.3466491699219",
    y: "461.0137634277344",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Enugu",
  },
  {
    x: "280.0166702270508",
    y: "314.17869567871094",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "FCT",
  },
  {
    x: "530.9564819335938",
    y: "216.0187225341797",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Gombe",
  },
  {
    x: "269.41165924072266",
    y: "520.5637664794922",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Imo",
  },
  {
    x: "409.6615447998047",
    y: "106.47876739501953",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Jigawa",
  },
  {
    x: "320.68660736083984",
    y: "228.81375122070312",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Kaduna",
  },
  {
    x: "89.92168807983398",
    y: "140.1137466430664",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Kebbi",
  },
  {
    x: "362.7017059326172",
    y: "146.62374877929688",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Kano",
  },
  {
    x: "244.58175659179688",
    y: "392.11370849609375",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Kogi",
  },
  {
    x: "315.8217010498047",
    y: "89.8387451171875",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Katsina",
  },
  {
    x: "111.85667037963867",
    y: "303.1237564086914",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Kwara",
  },
  {
    x: "53.51664400100708",
    y: "459.5337219238281",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Lagos",
  },
  {
    x: "347.5567169189453",
    y: "333.9937438964844",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Nassarawa",
  },
  {
    x: "173.33160400390625",
    y: "258.5587615966797",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Niger",
  },
  {
    x: "50.01666617393494",
    y: "422.0937957763672",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Ogun",
  },
  {
    x: "134.53164672851562",
    y: "442.55877685546875",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Ondo",
  },
  {
    x: "116.60665130615234",
    y: "398.4237518310547",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Osun",
  },
  {
    x: "59.33665370941162",
    y: "361.89878845214844",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Oyo",
  },
  {
    x: "429.42161560058594",
    y: "285.22373962402344",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Plateau",
  },
  {
    x: "256.6966552734375",
    y: "552.6838989257812",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Rivers",
  },
  {
    x: "162.65164184570312",
    y: "50.18874396383762",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#ffffff",
    font_weight: "500",
    pointer_events: "none",
    active: "active-text",
    name: "Sokoto",
  },
  {
    x: "487.77178955078125",
    y: "365.5087585449219",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Taraba",
  },
  {
    x: "521.2167358398438",
    y: "119.89373016357422",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Yobe",
  },
  {
    x: "214.806640625",
    y: "117.50875091552734",
    text_anchor: "middle",
    dominant_baseline: "middle",
    font_size: "10",
    fill: "#333",
    font_weight: "500",
    pointer_events: "none",
    active: "",
    name: "Zamfara",
  },
];

export const worldMapsSvg = [
  {
    id: "ae",
    d: "M528.466 468.135l.753 3.008 8.52.752.597-6.172 1.644-.897.45-2.257-2.69.752-2.99 4.52-6.284.293z",
    id: "heat-1",
  },

  {
    id: "af",
    d: "M545.85 435.383l1.374 10.77 3.423.753.32 1.937-2.455 2.05 4.573 3.69 8.885-3.198.71-3.786 5.592-3.492 2.145-8.09 1.6-1.723-1.66-2.887 5.412-3.347-.692-.967-2.498.155-.226 2.3-3.354-.034-.062-3.068-1.08-1.288-1.814 1.65.052 1.514-2.74 1.036-5.058-.32-6.568 6.882-5.88-.537z",
    id: "heat-3",
  },

  {
    id: "al",
    d: "M450.68 420.438v3.984l1.14 2.152.82-.096 1.41-2.566-.82-1.15-.32-2.844-1.09-1.012-1.14 1.532z",
    id: "heat-1",
  },

  {
    id: "am",
    d: "M507.47 420.55l4.15 5.41-1.22 1.427-2.938-.51-3.646-3.268.196-2.147 3.458-.914z",
    id: "heat-0",
  },
  {
    id: "mainland heat-1",
    d: "M437.366 547.46l2.948 11.004-.07 3.478-4.312 4.633-.647 7.527 16.597.147 5.395 1.953 4.45-.58-2.594-3.25.01-9.283 5.1-.217v-3.62l-4.14-.173-.83-8.575-1.746.024-.943-.85-1.027.055-1.365 2.646h-5.255l-1.22-1.226.363-1.738-1.436-2.1-9.278.145z",
  },

  {
    d: "M435.577 544.453l1.504 1.953 1.946-1.842-.57-1.91-.484-.034-2.395 1.833z",
    id: "heat-1",
  },

  {
    id: "mainland heat-1",
    d: "M279.05 600.613l1.677 1.57-6.37 9.468-2.24 2.48.777 10.813 4.918 5.974-4.132 7.21-3.13 1.35h-3.578l1.003 5.626-5.593 1.92 1.34 4.73-3.354 10.7 4.14 3.38-2.238 5.515-3.804 5.975 2.014 4.165-4.918.786-4.028-4.95-.674-15.433-6.258-26.208 1.893-9.163-4.028-11.714 2.68-15.204 2.463-2.93-.605-2.223 3.164-2.89 7.053.484 3.942 4.21 4.555.078 4.668 2.853-1.375 3.217.33 3.25 6.61-.312 3.097-4.727z",
  },

  {
    d: "M264.745 687.564l.225 4.95 3.803-.336 3.242-2.144-5.48-1.124-1.79-1.346z",
    id: "heat-1",
  },

  {
    id: "at",
    d: "M430.46 403.46l-.562 1.166.483.83 2.016-.415h1.71l1.858 1.573 3.95-.717 2.904-1.73.743-1.166-.11-1.504-2.612-1.954-3.5.035-.295 1.988-3.683 1.797-2.9.097z",
    id: "heat-1",
  },
  {
    id: "mainland heat-1",
    d: "M672.96 609.067l-.302 21.938-3.37 2.472-.304 2.16 4.598 3.087 11.35-2.16h5.826l2.145-3.096 12.88-2.472 9.197 2.784-.614 3.708 1.228 3.708 7.055-1.236.302 1.85-4.6 3.397 1.53 1.236 3.37-1.236-.916 10.2 6.44 4.944 3.683-1.235 1.84 1.852 10.735-1.548 10.123-16.382 3.682-.925 7.357-13.596 1.84-11.74-4.598-5.868 1.84-1.237-3.683-11.436-3.984-2.783.614-15.448-3.684-2.782-.916-8.652h-1.842l-6.138 20.392-3.37.312-7.668-7.728 4.296-11.437-7.97-1.546-8.897 2.472-2.455 7.104-3.984.925-.303-4.944-16.252 9.89.304 3.708-2.455 3.397h-6.14l-13.19 5.56-4.604 12.392z",
  },

  {
    d: "M728.775 668.09l-1.53 6.18.303 4.322 4.6-.312 5.212-8.03-8.585-2.16z",
    id: "heat-1",
  },

  {
    id: "az",
    d: "M508.93 418.674l-.872 1.486 4.07 5.342 1.42-.458 2.333 2.446 1.012-4.287 2.533.406-.104-1.23-4.164-3.646-.795 2.143-5.43-2.203z",
    id: "heat-1",
  },

  {
    id: "ba",
    d: "M442.708 411.084l-.32.527 5.802 5.982 2.127-3.13-.078-1.234-1.858-2.256-5.674.112z",
    id: "heat-1",
  },

  {
    id: "bd",
    d: "M616.256 457.908l-1.134 2.05 2.938 5.583.087 4.358.535 1.166 3.45.06 1.952-1.874 1.418.855.285 2.652 1.133-.708.07-3.39-.952-.112-.596-2.88-2.403-.085-.597-1.6 1.47-1.962.023-.97h-4.27l-3.41-3.142z",
    id: "heat-3",
  },

  {
    id: "be",
    d: "M414.02 391.704l-.555 1.383 5.947 3.925.4.05.375-1.093.837-.59-1.336-1.498h-.916l-1.255-1.426-3.498-.752z",
    id: "heat-1",
  },

  {
    id: "bf",
    d: "M404.493 493.496l3.146-.25 5.16 7.295-4.79 3.614-3.466-.892-4.66.062-.752 2.73-3.907.19-1.07-1.46 1.384-4.443 8.953-6.844z",
    id: "heat-2",
  },

  {
    id: "bg",
    d: "M457.092 414.066l.14 4.305 1.45 3.026 5.455.095 2.455-1.736 2.412-.96-.588-2.75.545-1.468-1.227-.64-1.687.138-1.323 1.332-5.55.043-2.08-1.384z",
    id: "heat-1",
  },

  {
    id: "bi",
    d: "M478.504 538.385l3.69-.078-.958 3.232-.935.81h-1.14l-.813-2.186.157-1.78z",
    id: "heat-1",
  },

  {
    id: "bj",
    d: "M411.512 515.288h1.833l.104-5.204 2.314-3.363-.104-5.85-2.102-.053-3.604 2.816 1.504 2.87.054 8.785z",
    id: "heat-2",
  },

  {
    id: "bn",
    d: "M689.038 515.08l-2.49 3.018 2.04.64 1.15-1.607-.7-2.05z",
    id: "heat-1",
  },

  {
    id: "bo",
    d: "M238.63 561.36l7.115-3.103 2.35.226 1.566 6.534 10.84 3.604 1.79 5.524 4.47.562 1.9 4.73-1.34 4.277-7.27.562-2.68 6.872-5.704-.112-1.79-.337-3.293 3.197-1.625-.156-5.593-12.958 1.547-2.316.545-9.163-1.383-5.455-1.443-2.487z",
    id: "heat-1",
  },

  {
    id: "br",
    d: "M286.63 618.464l5.403-10.39.198-8.73 10.08-6.502h5.645l4.435-7.512.804-14.418-1.815-3.855 10.683-9.75.406-10.762-14.515-7.105-17.53-5.48-8.264-.812 2.222-4.67-.604-7.103-1.808-.596-2.67 5.307-1.4 1.754-3.596-1.59-12.093 4.262-4.027-5.073.648-5.3-3.803 3.872-4.2-2.265-.425.597.01 1.84 3.62 1.946-5.436 5.73-3.432-.034-3.475-3.535-3.934.122-.484 4.2 2.256 2.74-2.663 8.53-3.112.242-4.953 3.13-1.21 6.146 4.296 4.6.787-.89 3.017-.813 2.576 4.34 7.374-3.164 2.86.165 1.972 6.976 10.52 3.337 1.815 5.565 4.478.537 2.135 5.314-1.443 4.73 1.884 2.473-.275 3.682 5.048-.477 4.625 5.844-.363 4.104 2.74 2.316-6.57 9.95 11.566 6.474z",
    id: "heat-1",
  },
  {
    d: "M222.12 463.112l-1.088-.337-.086 2.1 1.34 1.35.917-1.35-1.082-1.763zM224.29 466.397l-1.504.838 1.417 2.02.752-1.01-.665-1.848zM229.14 467.91l-1.59-.087.164 1.012 1.167 1.687 1.003-1.1-.743-1.512zM228.388 465.896l-2.593-1.1-.5-2.608 1-.425 1.004 2.023 1 .76.088 1.35zM225.88 460.588l-1.34-.337-.25-1.685-1.417-.5.917-.927 1.668.588 1.253.762-.83 2.1z",
    id: "heat-1",
  },

  {
    id: "bt",
    d: "M616.108 453.56l1.34 1.834 4.528.034-.458-2.507-5.41.64z",
    id: "heat-0",
  },

  {
    id: "bw",
    d: "M454.56 594.59l1.858.57-.26 5.313 1.91.26 4.392-3.96 5.273.57 1.4-3.544 6.672-6.096-8.013-9.223-.104-1.513-.883-.26-2.43 2.24-6.31.154-.884 7.867-2.478.57-.142 7.052z",
    id: "heat-1",
  },

  {
    id: "by",
    d: "M456.418 382.86l1.297 2.136-.52 1.703.087 1.348.476 1.616 2.68-1.52 3.33.085 2.333.958h5.923l1.73-4.14 1.036-1.565v-1.045l-3.718-5.23-3.285-1.305-2.68-.303-2.335.743.088 2.35-3.24 4.1-3.202.068z",
    id: "heat-1",
  },

  {
    id: "bz",
    d: "M191.823 483.228l-.043 3.154h.726l2.472-4.615H193.3l-1.477 1.46z",
    id: "heat-1",
  },
  {
    id: "mainland heat-1",
    d: "M151.767 281.182l1.72 2.602.864 3.475 4.306 1.08 3.017-3.25 2.585 1.306 7.32.647 5.17-2.17.864 7.157h3.017v-3.034l3.016.216 7.538 8.895 4.953 3.035-2.584 4.123 1.08 1.08 9.674 1.954.216 4.34 2.585.432.648-6.51 4.09-1.08 3.016 4.556 6.457 3.034 3.232.647 2.152-2.603.216-4.124 3.873-2.387 1.288 3.476-3.448 6.077.432 3.032L231 314.16l3.874-3.476.216-4.556-2.152-3.476.648-2.817 5.17-2.603 2.368 1.738.432 15.188 3.657-3.25 2.152 1.305-3.017 5.204 3.873.865 5.603-8.68 4.737 4.987-1.936 8.894-4.737 2.603-4.52-2.17-8.178 1.737.863 2.818-2.152 3.476-6.672 1.52-7.538 5.86-6.673 8.897-.864 2.817 4.52 1.737 1.72 4.338 6.242 6.293 9.906 4.34-2.15 9.975-.217 2.818 2.585 1.736 3.45-4.556.43-8.68 5.386-.215 2.584-4.99.433-7.588 6.89-13.45 8.61 3.034 4.52 6.293-1.937 6.29 3.45 1.955 8.393-5.646 2.368 15.403 7.754 9.327.216 4.77-8.61 2.17-4.087 4.34-8.61-1.954-4.304-.217-7.538 5.86 4.52-1.082 5.602-1.08 1.08 1.305-1.503 4.77.216 4.34 2.585 1.737 2.584-.648 1.295-1.953h1.72l-2.8 5.204-5.386.215-2.37 3.475h-3.016l-.864-2.603 4.305-4.338-5.17 1.737-.232-7.373-1.487-.863-4.52 1.953-.433 3.69h-10.338l-8.832 6.08-11.842 3.91-1.287-1.74 5.964-8.9-3.388-3.262-2.153-4.132-4.383-3.346-4.702-.39-8.428-5.903-61.122-10.043-1.01-4.14-5.603-5.205v-4.34l.864-3.906-.433-2.17-2.15-2.17-.433-3.475 5.602-3.908-3.45-18.653-4.737-.217-4.305-5.645 23.65-40.18z",
  },

  {
    d: "M130.684 350.117l-1.47 2.818.51 1.996.96.6-.226.81-1.03.295.295 2.965 1.106 1.115.88-.96-1.105-2.886.657-2.3 1.616-2.152-1.175-1.997-1.02-.303zM135.542 367.008l-1.323.52 2.428 2.818.588 3.336 2.43 2.592 2.057-.37v-3.407l-2.498-1.557-3.683-3.932zM268.15 295.833l-1.53 1.547 1.34 2.126 6.328.77-4.028-4.252-2.11-.19zM191.105 270.143l.19 3.475-6.898 7.148 1.73 5.79 4.978-1.347 2.878-4.254 7.278-2.706 5.94-.39-4.6-5.02-2.3 1.736-1.728-.58-.96-2.125-2.108-2.125-4.4.398zM200.113 259.908l-1.53 2.706 7.477 2.706 2.68-4.055 1.15 2.707h1.92l3.638-4.055-4.41-1.158-1.728-1.35-2.3 2.317-6.897.18zM213.148 265.318l-5.938 2.508v1.928l7.667 2.896-1.73 1.928 1.15 2.507 4.79-2.126h4.028l1.92 3.085 3.258-3.285-.77-3.095-2.68.968-.38-3.863 1.34-2.316h-1.34l-2.11 1.35-.958.768.58 2.707-1.53 1.157-2.3-.19-.58-3.476-4.417-3.452zM221.005 259.33l-.58 1.926 3.64 1.738 2.68-1.547-.19-1.158-5.55-.96zM223.875 256.044l-2.68.968.19 1.35 5.94-.39-.19-1.348-3.26-.58zM236.72 259.33l-.38 1.347-.96 1.35v1.928l3.64-.58 3.83 3.286h1.34v-3.284l-3.83-4.253-3.64.206zM246.497 263.19l1.53 1.74-1.34 2.315.96 2.507 4.217-2.317V265.7l-2.49-2.897-2.877.388zM252.055 258.75l.19 3.086h5.178l1.34 1.158-.19 1.348-4.6.58 3.26 4.443 4.41.77 6.127-2.705-8.817-13.33-2.68 1.738.19 2.316-3.07-1.158-1.338 1.754zM207.4 280.576l-7.28 1.928-4.218 3.673.38 4.054 7.667 2.318-1.73 3.864-5.558-3.477-1.53 2.896 3.64 2.508-.19 4.054 5.557 1.547 6.707-.39 1.15-2.126 4.978 5.6 3.45-1.156.578-3.864 2.49 1.737.38-3.863-3.068-1.928.19-12.163-2.68-2.126-2.87 3.865-8.046-6.95zM230.782 289.073l-2.49-1.158-1.34 1.737 2.68 4.253.19 4.054 5.75-3.476v-5.022l2.11-2.126-2.11-1.547h-3.45l-1.34 3.283zM243.048 287.335l-4.028 3.285.96 4.054h2.49l1.148-2.126 1.73 1.737 1.728-.19 4.6-3.864-8.628-2.895zM242.66 280.956l-.96 1.928 4.218 1.548 1.15-1.738-4.41-1.738zM240.17 273.617l-4.22.58-2.49 2.314 4.6.19-1.34 3.476.96 1.548 1.34-.19 3.258-5.212-2.11-2.705zM247.456 272.27l-2.3.77.38 3.086 3.83 2.507.19 1.927-1.148 1.16.58 3.863 14.754 4.823 4.028 1.35 4.028-3.476-4.79-3.864-4.408 1.158-6.128-.58-2.3-2.315-.578-6.372-3.83-1.928-2.308-2.11zM259.523 292.357l-4.218-.39-4.98 1.927-2.68 3.666.77 10.043 8.238.39 7.857 3.864 5.56 6.37 4.217-.19-1.15 5.982-3.83 6.37-4.217 1.926-3.07-.578-1.53-1.348-2.298 3.086.96 3.086 3.258.19 4.028-1.93 3.45 8.887 8.625 5.602 5.938-7.53-4.978-8.107 2.878-3.284 4.028 6.76 7.278-6.372-1.34-2.896-4.98 1.548-3.447-9.466 3.258-5.403-6.518-6.948-3.64 2.507-3.448-7.53-7.277.968-1.92-9.076-5.937 4.055-.58 5.02h-3.258l.38-4.442 4.573-6.758zM262.02 274.006v1.738l-4.217.968 1.15 1.927 4.788 1.927 5.37.58 3.83 2.705 3.83-2.127-2.682-2.705h3.45l2.108-2.316 5.178-.77v-1.158l-2.878-1.928.38-2.127 8.047 1.35 11.886-4.634-4.41-1.348 1.15-1.547h9.196l1.53-1.546-18.592-6.57-4.41-1.546-4.79 3.476-5.367-4.443-2.878-.19-.58 3.676-3.638-3.285-4.218 1.35.77 2.126 6.327 1.35-.38 3.086 3.45 2.125 8.438-2.125.19 2.896-6.898 3.285-4.218-3.285-3.83.39 3.83 5.41-1.92.97-2.877-2.51-2.11 1.35 1.92 3.665h3.26l-.77 3.475-2.68-.39-3.45-3.673-2.284.4zM244.94 327.16l-3.656 4.598-.225 5.065 3.197-1.84h3.88l2.74 2.532 2.516-2.076-8.452-8.28zM289.466 386.977l-9.136 8.748.916 2.074 11.186 4.14 1.6-2.758-.917-4.6-3.657.46-2.057-2.3 3.424-3.45-1.358-2.315z",
    id: "heat-1",
  },

  {
    id: "cd",
    d: "M438.023 546.597l8.912-.155 1.808 2.567-.07 1.892.666.605h4.425l1.27-2.5h1.81l.733.743 2.48-.07.734 8.715 4.287.14v.674l11.52 5.194.536 1.012h2.41l-.267-3.648-4.357-2.092.27-2.766 1.875-4.392 4.287-.14-3.683-12.223.068-5.195 5.826-9.11.068-1.278-.874-.477.035-2.472-1.062-.095-1.072-1.366-17.59-.795-3.225 3.138-5.28-3.475-1.858 1.14-1.348 11.35-3.338 2.576-1.003 2.283.178 3.38-6.017 4.918-1.6-.726.217.94-1.774 1.705z",
    id: "heat-1",
  },

  {
    id: "cf",
    d: "M443.452 519.23l4.028 4.355 1.59-2.057 2.532.104.544-2.006 2.49-1.556 5.17 3.562 2.98-2.956 11.575.51-10.735-11.082 1.443-.897.198-1.954-2.438-1.15h-3.58l-5.766 5.716-.197 2.35-4.573-.146-.146 1.003-2.982-.305-2.688 5.108.556 1.4z",
    id: "heat-1",
  },

  {
    id: "cg",
    d: "M439.424 526.55l-.052 1.256 4.13.104.147 10.728-3.778-.104-2.187-1.703-1.693.952-.078.476.873.423.25 2.205-2.333 2.006.5 1.058 2.586-2.006h1.244l.396 1.2 1.644.7 5.27-4.46-.103-3.26 1.1-2.652 3.38-2.507.907-8.48-2.402.01-2.783 3.812-7.018.246z",
    id: "heat-0",
  },

  {
    id: "ch",
    d: "M423.787 402.82l-3.77 4.01.077.406 1.547-.483 1.394 1.937 2.352-.83 1.625 1.263.668-.38 2.005-3.146-.51-.484-1.98-.05-.96-1.964-2.446-.28z",
    id: "heat-0",
  },

  {
    id: "ci",
    d: "M388.484 521.562l3.697-2.617 4.6-.806 4.694 1.012-2.395-3.622-.702-2.213.7-6.544-4.19.198-1.9-1.813-3.995.104-1.9.305.197 4.425-1.002.406-1.203 2.215 3.095 3.62.304 5.332z",
    id: "heat-2",
  },
  {
    d: "M261.39 683.51l-3.69 8.11 6.37.673.113-5.403-2.792-3.38zM260.137 682.24l-2.775 3.067-.337 3.604-5.368-3.042-5.705-8.22-1.677-2.933 2.35-3.043-.224-3.83-2.68-1.124-2.125-1.572.45-2.144 2.79-.787.563-12.387-4.356-2.48-2.844-64.477.735-1.277 5.567 12.836 1.78.034.58 2.05-2.37 2.867-2.722 15.45 3.873 11.894-1.79 9.007 6.31 26.486.667 15.49 4.52 5.23 4.79-.697zM241.717 649.833l-1.115 1.686.562 2.93 1.115.113.56-3.718-1.123-1.012z",
    id: "heat-1",
  },

  {
    id: "cm",
    d: "M428.03 519.428l2.784 2.56-.2 3.96 15.267-.354 1.246-1.4-4.375-4.71-.647-1.703 2.784-5.21-1.893-3.46-1.59-.854V506.5l1.84-1.2.104-5.464-1.46-.164-.024 2.87-6.414 11.972-3.925.2-2.688 1.85-.806 2.864z",
    id: "heat-1",
  },
  {
    id: "mainland heat-3",
    d: "M594.498 386.128l-2.99 7.52-4.124-.216-4.35 9.518 3.692 4.7-7.606 10.505-3.907-.658-2.61 3.285.647 1.97 3.043.218 1.52 3.5 3.045.658 9.344 12.04v6.13l4.563 2.843 4.996-.872 6.304 3.72 7.605 2.186 3.69-.44 4.132-.44 8.687-5.688 2.827.44 1.08 2.567 2.396.718 3.26 4.814-2.17 4.814 1.306 3.285 3.69 1.312.646 3.942 4.35.44.647-1.972 6.302-3.285 3.907.217 4.563 5.03 3.043-1.312 1.954.216.873 2.413 1.52.216 2.17-3.06 8.688-3.286 7.823-9.413 2.61-8.973-.217-5.912-3.26-.656 1.953-2.19-.434-3.5-8.256-8.314V421l2.386-3.063 2.388-1.098.216-2.413h-6.085l-1.09 3.285-2.828-.656-3.475-3.718 2.17-5.688 3.043-3.285 2.827.217-.434 5.03 1.52 1.314 3.692-3.717 1.306-.217-.432-2.844 3.476-4.16 2.61.217 1.52-4.813 1.782-.942.182-3-1.73-1.815-.146-4.736 3.33-.216-.217-12.214-2.334 1.4-.863 3.13-3.897-.01-11.298-6.353-8.16-9.837-8.28-.086-2.108 1.833 2.68 6.137-.935 5.758-3.336 1.383-1.876-.147-.14 5.696 1.955.44 3.476-1.53 4.562 2.188v2.188l-3.26.216-2.61 5.688-2.387.215-8.472 11.16-8.902 3.94-6.085.44-4.124-2.843-5.868 3.068-6.302-1.97-1.52-4.16-10.643-.656-5.646-9.19h-2.385l-1.92-4.26-2.287-.182z",
  },

  {
    d: "M671.802 472.655l-2.064.58-1.487 1.832 1.237 2.41 1.814.164 2.067-1.83.492-2.412-2.058-.743z",
    id: "heat-3",
  },

  {
    id: "co",
    d: "M234.326 498.25l-1.78-.18-11.774 9.706-1.245 3.414-1.608.182.716 7.546-4.105 10.07 4.46 3.776 5.715.363 3.924 5.757 5.704.183-.182 4.312h2.135l2.316-7.91-2.144-2.694.535-5.03 4.46-.364-.536-11.688-9.994-3.232-2.316-6.293 5.716-7.92z",
    id: "heat-1",
  },

  {
    id: "cr",
    d: "M202.905 502.745l1.202 2.352.977 1.297-1.314 3.898-2.507-1.764-4.097-3.752v-2.48l5.74.45z",
    id: "heat-0",
  },

  {
    id: "cu",
    d: "M205.904 469.846v1.1l4.6.086 2.168-1.263.337.925 4.51 1.098 4.012 3.622-.917 1.262.165 1.436 3.345.84 3.345-1.515 1.504-1.513-2.17-1.098-11.193-6.57-3.923-.423-5.783 2.012z",
    id: "heat-1",
  },
  {
    d: "M350.01 490.264l-1.642.942 1.175.94 1.41-.707-.943-1.176zM354.046 492.165l-1.07.95.76 1.41 1.833-.82-1.524-1.54zM351.704 494.836l-1.375.82 1.478 1.98 1.168-.612-1.272-2.188z",
    id: "heat-1",
  },

  {
    id: "cy",
    d: "M484.555 437.794l1.062.77-3.294 3.12-1.573-.052-1.167-.82.156-1.53 2.385-.155 2.43-1.333z",
    id: "heat-1",
  },

  {
    id: "cz",
    d: "M437.202 398.92h3.829l2.05 1.462 3.794-3.155-3.683-2.627-3.648-1.765-2.498.45-3.39 2.178 3.545 3.458z",
    id: "heat-1",
  },

  {
    id: "de",
    d: "M422.257 384.234l3.086-.5v-2.178l2.584-.425 1.418 1.428 1.495.164 2.334-1.012 2.083.588 1.832 1.592.25 5.955 1.832 2.438-2.41.337-4.004 2.515.338.84 3.58 3.353-.252 1.677-3.328 1.677-3.085.086-.752 1.59h-1.58l-.753-1.676-2.75-.675-.087-2.767-1.39-.77.114-1.86-.406-1.33-1.982-1.823.414-2.854 2.16-1.01-.74-5.36z",
    id: "heat-1",
  },
  {
    d: "M427.123 370.076l-3.586 3.968-.13 2.584 1.635 4.263 2.56-.483-.32-3.483 1.764-1.97-.034-1.55-1.245-3.222-.644-.106zM428.98 377.354l-1.063.23v1.582l1.128.875.997-.25-.243-1.502-.82-.934zM432.306 375.848l-.95.23-1.055.968.45 1.954 1.29.507-1.333.535-.255.685h2.005l.602-1.1-.77-.377.25-.962.917-1.205-.25-1.042-.9-.192z",
    id: "heat-1",
  },

  {
    id: "dj",
    d: "M508.99 499.77l-.492 2.904 3.424-.052.052-4.27-1.253-.77-1.73 2.19z",
    id: "heat-1",
  },

  {
    id: "dm",
    d: "M256.23 485.37l-.76 1.617.916 1.228 1.14-.994-1.296-1.85z",
    id: "heat-0",
  },

  {
    id: "do",
    d: "M242.434 481.533l-4.573-2.99-2.886-1.022-.578 5.522.578-.047.76 1.46.995-1.15 2.895-.77 2.516.537.294-1.54z",
    id: "heat-1",
  },

  {
    id: "dz",
    d: "M424.625 435.764l-3.526-1.186-14.678 2.758-3.198 2.43 1.953 10.087-5.835.233-3.51 5.646-8.358 2.005.025 4.105 27.53 21.048 4.693.398 15.654-12.23-1.565-1.972-2.938-.398-1.764-2.955V453.5l-1.177-1.184.2-3.155-3.13-3.154-.39-3.354 1.366-.986-.59-3.553-.765-2.35z",
    id: "heat-3",
  },
  {
    id: "mainland heat-1",
    d: "M213.986 529.43l-4.088 2.54-.294 3.772-.82 1.234 2.575 2.473-1.116 1.218.26 3.113 4.606 1.1 6.976-8.257-.017-2.878-3.346-.216-4.738-4.1z",
  },

  {
    d: "M183.533 531.443l-.536 2.378-.994 1.003.683 1.228 1.754-.69.838-1.46-.536-1.537-1.21-.92z",
    id: "heat-1",
  },

  {
    id: "mainland heat-1",
    d: "M462.562 363.3l-4.84-.174-3.068 1.875-.043 1.393 1.988 1.875 6.182 1.047-.218-6.016z",
  },

  {
    d: "M452.236 364.042l-1.308.44 1.308.226.595.69.712-.852-.71-1.215-.596.712zM452.792 365.792l-1.862.833-.643 1.11.643.723 2.362-.875 1.137-.752-1.638-1.038z",
    id: "heat-1",
  },

  {
    id: "eg",
    d: "M466.16 449.222l2.308.062 4.495 1.244 2.135.06 2.646-2.212h1.234l2.25 1.245h2.844l.51-.034 1.798 5.17.51 1.668.477 2.498-.85.622-1.46-.734-1.687-5.498-1.52-.11-.112 1.866 1.012 3.232 8.1 10.027.173 4.305-2.36 2.723-22.162-.25-.34-25.883z",
    id: "heat-3",
  },

  {
    id: "er",
    d: "M496.224 493.86l-.216-5.094 3.423-3.992.927.71 1.686 5.636 8.09 6.023-1.47 1.808-5.92-5.09h-6.52z",
    id: "heat-2",
  },
  {
    id: "mainland heat-1",
    d: "M402.565 416.322H391.55l-2.22-1.004-1.072.078-1.297 2.696.46 2.775 4.21.39.535 1.77-1.833 10.33.078 1.85 2.98 1.618 3.44.232 6.88-1.694 3.364-4.233.077-4.313 5.966-5.395.302-2.386-5.428-.078-5.425-2.636z",
  },

  {
    d: "M374.265 458.444l-1.513.873.7.71.813-1.583zM369.01 458.608l-1.876.476.935 1.418h1.406l-.467-1.894zM364.55 457.19l-1.177 1.185 1.643 1.418.935-2.126-1.4-.476zM413.578 426.877l-1.375.467.304 1.235h1.988l.84-.926-1.757-.777z",
    id: "heat-1",
  },

  {
    id: "et",
    d: "M489.982 508.606l6.292-14.005 6.25.036 5.54 4.814-.39 3.968h4.297l.44 2.386 6.95 4.157 4.287.218-8.15 8.756-11.194 3.45h-2.773l-4.944-4.22-1.953-.82-3.786-5.576-2.5.035-.293-2.56 1.928-.637z",
    id: "heat-2",
  },

  {
    id: "fi",
    d: "M453.072 340.202l1.79.786 1.104 2.074-1.104 1.436-5.55 6.068-.952 3.2 1.27 4.632 4.28 3.2 5.705-2.716 4.598-.64 4.28-6.872-3.174-7.512-3.02-7.192.478-4.633-1.9-.32-.493-3.38-2.56-4.175-2.835 1.962-1.114 4.556-3.008-1.807-4.185-1.022-.934 1.09 1.606 1.453 2.93-.052 2.36 3.812.426 6.052z",
    id: "heat-1",
  },
  {
    d: "M281.194 678.393l-2.273-.25-2.264 1.52 1.642 1.782 2.896-3.052zM283.46 677.252l-.753 2.41-2.144 1.902.13.63 3.655-1.4 1.513-1.9-2.4-1.642z",
    id: "heat-0",
  },

  {
    id: "mainland heat-2",
    d: "M412.973 393.588l-1.91.467-3.82 4.158-1.15.078-1.53-1.08-.992.233-.76 2.386-5.585.154.156 1.236 3.82 2.543 4.436 3.543-.077 4.236-2.37 4.157 5.127 2.463 5.204.154 1.607-1.85 3.286.078.916.848 3.284-.233 1.686-2.162-2.145-2.54-.155-1.617.458-1.77-1.07-1.54-1.834.536-.232-1.383 4.054-4.47v-2.696l-2.348-.767-1.432-.987-6.623-4.175z",
  },

  {
    d: "M276.163 517.285l5.058 3.154-2.645 5.254-.96 1.21-2.808-1.615.08-5.664 1.276-2.34zM540.023 586.93l-1.972.13-.128 1.72 1.313.27 1.972-.925-1.184-1.195zM516.857 562.666l.656 1.46h1.055l.526-1.856-2.237.396zM258.823 489.822l-.917.847.683 1.382 1.295-.38-1.062-1.85zM428.04 418.016l-1.688 1.695-.154 1.54 1.374.846.536-.076.303-2.24-.37-1.764zM254.095 484.065l-1.296.535.457 1.15 1.52-.995-.302-.31-.38-.38z",
    id: "heat-2",
  },

  {
    id: "ga",
    d: "M435.438 526.646l-.104 2.15-4.875-.103-2.983 5.766 7.012 7.666 1.735-1.453-.052-1.503-1.192-.554v-1.057l2.69-1.702 2.386 1.807 2.638.052-.054-9.067-4.176-.196-.052-1.903-2.974.096z",
    id: "heat-1",
  },
  {
    id: "mainland heat-2",
    d: "M400.63 367.984l-1.583 2.395.63.958h3.65v1.6l-.953 1.278.632 3.354 2.058 3.994 1.58 3.672 2.534.96 1.105 1.92-.155 1.754-1.582.96-.156.794 1.106.64-.95 1.28-2.222.958-4.28-.477-6.663 3.035-2.22-1.115 6.345-3.674-.796-.476-3.33-.32 2.06-3.033.318-2.56 2.696-.318-.475-4.953-3.175-.156-.95-1.115.155-3.675-1.9.156 1.9-6.387 3.492-2.56 1.127 1.11z",
  },

  {
    d: "M393.974 378.693l-2.853.32-.155 2.56 1.9 1.278 2.06-.474.795-1.436-1.746-2.247z",
    id: "heat-2",
  },

  {
    id: "ge",
    d: "M495.144 415.596l2.827 3.69 3.528 1.626 2.17-.01 3.725-1.01.935-1.46-11.02-4.124-2.164 1.288z",
    id: "heat-1",
  },

  {
    id: "gh",
    d: "M399.09 513.18l.97 2.272 2.523 3.96 1.4-.053 3.82-2.172-.27-12.354-2.956-.864-4.14.112-1.346 9.097z",
    id: "heat-2",
  },

  {
    id: "mainland heat-0",
    d: "M292.587 282.398l-1.176 1.877 2.12 2.117-.943 2.118 3.06 3.994 3.76-1.176 4.937-.466 5.644 6.11 3.76 10.105-3.05 6.345 4.227-.708 2.354 1.41.23 3.06-5.167.232 2.818 2.817 3.527.71-7.754 10.338-.942 6.346 1.644 5.17-1.176 3.06 2.118 6.577 3.993 4.47 1.175-.233 2.584-.71.232 3.76 1.642 2.353 3.052-.234 2.353-8.696 7.052-8.697 10.58-4.227 6.58-8.23 3.05 1.41h6.344l5.17-5.17 6.346-2.583.708-3.994-3.993-3.527-3.526-1.175-1.884-4.936 4.47-2.584 7.053 3.76 2.352-2.584-3.76-2.117 7.995-10.814-1.41-4.702-3.76-.232 1.408-4.228 4.703-2.118 9.637-8.46-2.816-3.054-10.815.94-5.645 5.647 3.295-7.288-3.762-.942-2.117 3.76-3.05-2.584-8.465.94 2.354-3.76 13.865-.466-3.528-4.702-15.04-2.817-6.11.942.233 3.06-6.345-2.117.232-2.118-4.47.94-.942 2.354 4.703 1.643-4.936 3.527-3.527-3.994-4.936-1.408-.71 3.76h-4.936l-1.885-3.994-7.754-1.176-4.23 2.117-.232 2.818-5.402-.71-3.294 1.41.234 3.293v1.644l-6.11 1.176-2.82-1.877-1.884 3.05 2.82 3.06 5.877-.708.466 1.885-4.47 2.118-3.99-1.907z",
  },

  {
    d: "M311.396 319.066l1.41 2.12-.71 2.583h-1.408l-1.885-2.12.467-1.643 2.126-.94zM370.16 313.19l3.992 1.175-.234 3.293-4.227-2.118-.94-1.176 1.41-1.175z",
    id: "heat-0",
  },

  {
    id: "gm",
    d: "M366.72 497.006l-.112.96 5.98-.087.304-.892-.13-.898-1.72.7-4.323.216z",
    id: "heat-2",
  },

  {
    id: "gn",
    d: "M369.77 505.304l2.63 4.046 3.422-2.974 3.51-.155 2.923 3.882 2.48 1.635.933-1.816.83-.465-.06-3.993-1.65-4.737-5.066.562-6.267-.5-.034 1.605-3.65 2.912z",
    id: "heat-2",
  },
  {
    d: "M427.184 522.134l-.396 1.703 1.19.648 1.144-.855-.397-1.755-1.54.26zM430.77 526.697l-.053 1.202 3.924.197-.05-1.356-3.82-.043z",
    id: "heat-1",
  },

  {
    id: "mainland heat-1",
    d: "M453.004 427.213l-.096 1.15 4.003 2.014 1.912.734-1.003 1.056-2.23.227-.32 1.01.77 1.738 2.5 1.33 1.09.097.137-2.98 1.635-1.973-4.46-5.272.59-1.79 1.045-.042 1.59 1.28 1.003-.502.32-1.79 3.73.534 1.135-3.24-1.953 1.376-5.73-.14-3.727 1.93-1.94 3.255z",
  },

  {
    d: "M461.69 438.442l1.408.043.59.873h2.05l1.362-.5.46.552-.908 1.192-4.002.14-.728-.96-.77-.458.538-.882z",
    id: "heat-1",
  },

  {
    id: "gt",
    d: "M183.456 491.11l5.126 3.752 5.17-6.423-.882-1.332-1.764-.062v-3.76l-1.322-.805-4.002 1.193 1.53 3.526-3.856 3.91z",
    id: "heat-1",
  },

  {
    id: "gw",
    d: "M368.196 502.356l1.21 2.395 3.397-2.92.035-.9-4.003-.58-.64 2.006z",
    id: "heat-1",
  },

  {
    id: "gy",
    d: "M261.4 510.654l6.24 5.652-2.48 2.87-.2 1.703 3.26 3.36-.08 3.233-5.67 2.16-3.396-4.59.726-5.515-1.452-4.105 3.05-4.77z",
    id: "heat-1",
  },

  {
    id: "hn",
    d: "M194.408 488.742l7.987-.303 2.37 2.816-1.48-.338-2.843.12-3.717 3.493-1.59 3.537-1.046-.555-.01-3.872-2.3-1.54 2.628-3.358z",
    id: "heat-1",
  },

  {
    id: "hr",
    d: "M443.417 407.816l-3.05 2.515h-3.096l-.37 2.18 1.417.37.71-1.054 1.113.977.89 3.112 6.11 2.853.605-.69-6.197-6.397.63-1.165 5.89-.226.595-1.877-3.838.11-1.408-.707z",
    id: "heat-1",
  },

  {
    id: "ht",
    d: "M231.845 477.16l2.974.31-.355 3.648-.294 1.92-3.465-.19-.614.925-1.062-.077-.38-1.997 3.656-.305-.225-2.073-1.678-.69 1.443-1.473z",
    id: "heat-1",
  },

  {
    id: "hu",
    d: "M444.386 403.01l-1.003 1.573.078 2.403 1.6.82 4.92.147 6.853-5.774.034-1.28-.742-.37-4.953 2.247-6.786.233z",
    id: "heat-1",
  },
  {
    d: "M639.517 513.628l-.24 1.97 5.868 9.863h1.71l12.23 20.462 4.895.492 2.445-7.148-3.916-2.464-.735-3.94-22.258-19.234zM697.475 540.89l1.954 2.397-1.272 3.596v.684h2.887l1.02-8.99.935.26 1.694 8.213 1.615.434 1.53-3.512-1.53-5.308-1.272-2.31 3.993-2.91-.934-1.29-3.82 2.48h-1.02l-1.866-2.74.597-1.2 3.146-1.54 4.754 1.454 1.444-.09 3.57-3.334-1.443-1.45-3.312 2.564h-2.127l-3.224-1.538-2.29.086-2.55 4.106-1.616 7.105-.863 2.834zM718.79 524.805l-1.615 3.935 2.55 3.337h.848l1.105-2.223.597-.77-1.105-1.2-1.617-.598-.762-2.48zM723.805 537.73l-3.482.77-1.02 1.114.846 1.453 2.29-.855 1.442-.855 2.126 1.712.935-.772-1.693-2.057-1.445-.51zM666.045 548.854l-2.377 1.625.51 1.363 7.564 1.712 3.82.684 1.615 1.71 4.33.346 2.04 1.71 1.868-.43 1.702-1.54-3.146-1.452-2.714-2.308-7.053-1.713-8.158-1.71zM690.768 556.295l-1.865 1.03 1.104 1.2 2.715-1.027-1.954-1.203zM693.99 555.526l.34 1.625 1.953.51.76-.94-.847-1.29-2.205.096zM698.668 559.805l-2.377.347 2.127 1.798h1.694l-1.442-2.145zM699.342 556.98l-.51 1.026 3.82.596 2.974-1.71-1.694-.512-2.715.77-1.02-.855-.855.684zM711.833 557.583l-4.416 3.683.423.942 1.866-.345 2.205-2.06 4.332-.596-.848-1.452-3.56-.172zM734.126 532.446l-3.604.406-2.315 1.693.96 1.938 3.924.726v.726l-2.48 2.015 1.202 4.193 1.2.078 1.038-4.114h1.92l.805 4.027 9.36 7.746.242 6.05 3.198 3.467 1.442-.077.32-21.37-5.44-3.784-5.124 3.467-1.843 1.132-3.043-1.937-.078-6.128-1.684-.254zM690.69 519.532l-1.998 7.503-10.83 3.656-3.242-3.803-1.573.433 2.94 11.34 4.397.493 5.87 2.222v2.222l2.687-.493 3.917-5.42v-4.435l2.204-4.436 2.446.49-2.938-6.162-.45-3.968-3.43.358z",
    id: "heat-6",
  },

  {
    id: "ie",
    d: "M394.915 383.085l-.786 5.187-6.976 2.56h-2.223l-1.58-1.115v-.96l3.49-2.238-.95-1.92.156-2.715 3.018.155 1.383-3.25-.183 2.887 2.344 1.858 2.307-.45z",
    id: "heat-1",
  },

  {
    id: "ps",
    d: "M486.378 444.9l-1.365 4.347 1.77 5.213 2.032-7.616v-1.633l-2.437-.31z",
    id: "heat-2",
  },

  {
    id: "in",
    d: "M595 509.688l3.958-1.938 2.352-8.505-.104-10.44 13.468-14.54v-3.448l2.774-1.08-.104-3.985-2.99-5.817 1.71-3.12 3.743 3.448 4.808.216v1.937l-1.495 1.616.318.863 2.567.104.536 2.904h.753l1.928-3.45.96-9.04 3.206-2.266.104-3.12-1.28-2.48-2.03-.105-7.95 5.256.5 3.38-5.585-.02-1.97-2.41-1.072.138.363 3.354-12.075-.863-7.484-3.338-.397-4.106-4.99-3.094-.06-6.37-3.422-3.917-7.867.752.856 3.424 3.854 3.12-6.665 13.642-4.46.337-.734 1.643 4.393 4.062-.216 4.105-4.486-.07-.483 2.04 3.727-.163.104 1.616-2.67 1.4 1.71 3.232 3.312 1.08 2.03-1.504.96-2.687 1.177-.535 1.392 1.398-.425 3.45-.96 1.616.217 2.8L595 509.688z",
    id: "heat-4",
  },

  {
    id: "iq",
    d: "M502.793 433.637l-1.348 6.664-5.585 4.65.354 2.196 5.455.37 8.687 7.07 4.857-.137.13-1.635 1.78-1.91 2.49 1.41.33-.313-4.816-6.405-2.282-.14-3.033-3.897.604-2.868.926-.12.32-1.272-4.133-4.348-4.737.685z",
    id: "heat-2",
  },

  {
    id: "ir",
    d: "M507.41 427.516l-1.058 1.098.104 1.738 1.314 1.842 4.658 5.1-.71 2.04h-.81l-.407 2.04 2.638 3.372 2.43.207 4.865 6.732 2.732.208 2.126 1.53.105 3.06 8.41 4.9h3.14l1.927-1.633 2.43-.104 1.418 3.268 9.085 1.262.27-3.337 3.007-1.09.14-1.193-2.396-3.268-5.334-4.288 2.8-2.55-.197-1.124-3.51-.544-1.487-11.843-.173-2.722-9.518-3.64-4.218.95-2.36 2.896-2.093-.14-.604.512-4.66-.303-5.878-4.288-2.188-2.394-1.003.24-1.808 2.067-3.187-.6z",
    id: "heat-1",
  },

  {
    id: "is",
    d: "M366.26 340.52l-1.692-.958-2.283 1.443-1.962 1.814.052 1.012 2.54.32-.155 1.814-.898.908.217.588 2.54.164v2.938l3.656.64 2.17 1.23 2.437.104 4.186-2.083 3.23-4.27.053-2.888-1.963-1.66-1.642-1.392-.743.536-1.115 1.444-1.27-.164-1.272-1.393-1.642.156-2.386 1.98-1.437 1.546-.795-.69-.053-1.713.795-.536-.57-.89z",
    id: "heat-0",
  },
  {
    id: "mainland heat-1",
    d: "M423.233 409.39l-.535 1.357.146 1.478 2.065 2.412 3.25-.113 7.174 8.334 4.48 1.297 2.645 2.498.63 5.695 1.417-.828 1.23-3.104-.304-2.23 2.1-.19.305-1.262-5.922-2.834-5.62-5.523-2.237-3.303-.546-3.137 2.86-.684-.733-2.066-1.754-1.478-1.513-.07-2.108.58-1.99 2.78-1.2.796-1.86-1.14-1.982.735z",
  },

  {
    d: "M440.668 431.898l-1.253-.674-4.278.674.146 1.158 3.847 1.937.58.63 1.01.148-.052-3.872zM427.806 423.566l-2.29 1.158.304 4.47 1.833.31 1.374-1.312v-4.235l-1.22-.39z",
    id: "heat-1",
  },

  {
    id: "jm",
    d: "M221.533 480.798l-3.008.76v.84l1.755 1.012h1.84l1.168-1.35-1.755-1.262z",
    id: "heat-1",
  },

  {
    id: "jo",
    d: "M489.473 447.25l-2.126 7.417-.096 1.133h3.347l3.743-3.303.094-1.253-1.53-1.564 2.74-2.272-.396-2.11-.752.174-2.282 1.635-2.74.144z",
    id: "heat-3",
  },
  {
    d: "M709.317 426.193l-1.41 1.418.58 1.997 1.235.086.83 4.332.993 1.08 1.738-1.582.15-4.773-2-2.125-2.116-.432zM716.688 422.188l-2.66 2.156-.59 2.72 1.812 1.25 2.625-2.75.37-3.063-1.557-.312zM713.613 418.033l-4.22 4.832v2.322l2.605-.312 4.085-3.592 2.73-.502.664.78.015 2.377.688 1.25h1.255l1.763-2.158.743-2.837 3.553-.086 3.476-4.166-1.815-6.915-.83-3.664 1.815-1.495-4.133-6.24-.944-.745-1.875.744-.48 2.584v2.083l.993 1.168.33 5.498-2.56 3.164-1.486-.917-1.16 2.584-.25 2.412.91 1.417-.58 1.08-1.902-1.582h-1.322l-1.157.666-.91.253zM720.73 380.396l-1.322 1.168.665 2.498 1.158 1.166-.085 3.83-1.487.578-1.158 2.584 3.388 4.66 2.23-.753.415-1.167-2.396-2.16 1.487-1.92 1.572.25 3.43 2.305.37-2.584 1.63-2.978 2.28-2.312-2.468-1.125-.944-1.8-1.236.83-1.07 1.33-2.317-.5-2.395-1.583-1.746-2.316zM733.2 377.812l-2.316 3.25.164 1.582 1.158-.502 2.723-3.414-1.73-.916zM736.26 373.066l-.828 2.248.086 1.496 1.41-.918 1.32-2.662v-.994l-1.987.83z",
    id: "heat-1",
  },

  {
    id: "ke",
    d: "M491.142 521.365l2.3 4.484-2.76 5.782-.36 1.754 13.77 8.516 4.27-6.708-2.16-1.754-.043-8.835 2.704-2.956-4.313 1.434-3.258.044-5.1-4.305-1.608-.692-2.98.277-.526.883.064 2.075z",
    id: "heat-2",
  },

  {
    id: "kg",
    d: "M565.463 411.316l-.268 2.188.216 1.35 7.522 2.523-6.604 2.662-.75-.624-1.428.917.068.5.76.347 4.636.12 2.35-.708 3.02-3.803 3.775.655 4.556-6.31-12.188-1.66-1.686 4.087-2.127-2.28-1.852.034z",
    id: "heat-1",
  },

  {
    id: "kh",
    d: "M655.076 497.982l3.535 3.776 6.577-4.875.58-7.692-3.397 2.344-1.764-.985-2.396-.32-1.34-.942-.65.035-1.753 2.878.285 1.333 1.78.994-.215 2.705-1.24.75z",
    id: "heat-2",
  },

  {
    id: "km",
    d: "M514.36 560.013l.395 1.32 1.71.27.657-1.72-2.763.13z",
    id: "heat-2",
  },

  {
    id: "kp",
    d: "M687.75 407.047l1.59.666.485 5.566 3.155.182 2.974-3.483-1.03-.917.122-3.734 2.73-3.304-1.39-2.506.907-1.04.5-2.59-1.58-.72-1.35.684-1.67 5.064-2.696-.232-3.12 3.682.374 2.68z",
    id: "heat-0",
  },

  {
    id: "kr",
    d: "M696.446 410.443l5.342 4.356.91 4.22-.184 2.263-2.61 2.94-2.248.12-2.55-5.507-.97-2.63 1.03-.794-.243-1.1-1.27-.568 2.793-3.3z",
    id: "heat-1",
  },

  {
    id: "kw",
    d: "M519.2 452.774l-1.945-1.056-1.35 1.356.147 2.715 3.14 1.2.008-4.216z",
    id: "heat-2",
  },

  {
    id: "kz",
    d: "M513.495 402.163l3.544-1.513 3.958-.14.276 6.052h-2.317l-1.772 2.888 2.317 3.847 3.414 1.928.31 2.205 1.256-.416 1.157-1.375 1.91.415.96 1.928h2.454v-2.473l-1.504-4.4-.684-3.57 4.364-1.928 5.87.96 3.683 3.708 8.323-.82 4.644 6.596 5.455.274 1.504-2.472 1.91-.416.273-2.748 2.862-.14 1.503 1.79 1.505-3.57 12.957 1.79 2.18-2.888-3.684-4.537 4.91-10.72 3.958.275 2.73-6.594-5.454-.553-3.138-3.024-8.644 1.002-11.134-10.762-3.926 3.482-11.902-5.402-14.6 7.148-.406 5.084 3.413 3.985-6.655 3.76-8.636-.19-1.807-2.654-6.77-.373-6.413 4.123-.14 5.638 5.983 4.8z",
    id: "heat-1",
  },

  {
    id: "la",
    d: "M650.745 466.397l-2.092 1.062-1.737 5.064 2.904 3.7-.485 4.09.485.195 4.832-2.343 6.482 7.243-.157 4.563 1.41.762 3.482-2.827-.286-2.238-10.053-9.552.096-1.46 1.254-.874-.874-2.438-4.158-.684-1.103-4.265z",
    id: "heat-1",
  },

  {
    id: "lb",
    d: "M487.14 440.04l.052 1.687-.708 2.56 2.438.208.156-3.63-1.94-.824z",
    id: "heat-1",
  },

  {
    id: "lc",
    d: "M258.746 493.28l-.614 1.306.994 1.07 1.296-.69-1.676-1.686z",
    id: "heat-1",
  },

  {
    id: "lk",
    d: "M603.264 505.4l.217 2.35.217 1.712-1.27.216.64 3.848 1.908 1.07 2.966-1.71-.846-4.055.216-1.494-2.756-2.56-1.29.623z",
    id: "heat-2",
  },

  {
    id: "lr",
    d: "M378.198 515.027l9.49 6.345-.226-4.805-2.87-3.38-2.8-2.48-3.594 4.32z",
    id: "heat-1",
  },

  {
    id: "ls",
    d: "M470.896 606.83l2.637-2.033 1.245.053 1.503 1.875-.154 1.877-2.533.934v.728l-2.792-.156-.673-2.03.77-1.25z",
    id: "heat-1",
  },

  {
    id: "lt",
    d: "M452.14 375.236l-2.146.363.173 2.024 3.355.25 1.27 1.042.333 1.81 1.034 1.443 3.068-.13 2.938-3.744-.172-2.222-5.533-.867-4.32.03z",
    id: "heat-0",
  },

  {
    id: "lu",
    d: "M420.424 397.582l.76.68.88.082.194-1.734-.253-.974-1.224.583-.356 1.362z",
    id: "heat-1",
  },

  {
    id: "lv",
    d: "M462.823 369.964l-6.362-1.037-1.085 2.823-1.833.548-.96-1.173-.96-1.81-1.04.76-.588 3.133v1.708l2.242-.375 4.665.084 5.618 1.044 2.25-.657-.13-2.523-1.815-2.523z",
    id: "heat-1",
  },

  {
    id: "ly",
    d: "M429.958 453.518l1.35-.225.397-3.112h.674l2.757-4.527 6.804 1.98 1.857 2.886 6.69 3.06 3.482-1.47-.34-1.47-1.52-1.47.173-1.02 2.473-2.093h4.894l1.856 2.49 3.934.57.51 31.888-2.92-.112-17.652-9.18-1.91 1.08-7.253-1.814-1.97-2.604-2.87-.397-1.46-2.604.043-11.858z",
    id: "heat-2",
  },

  {
    id: "ma",
    d: "M402.505 439.903h-9.982l-1.954 4.34-4.505 2.17-3.72 10.06-7.242 4.342-10.174 16.76 9.982-.198.39-4.927h2.54v-6.708h8.81l.196-8.68 8.42-1.97 3.526-5.724 5.48-.198-1.77-9.267z",
    id: "heat-2",
  },

  {
    id: "md",
    d: "M465.14 401.376l2.68 4.123-.225 2.333.96.043 2.272-3.847-2.73-3.39-1.548-.64-1.41 1.376z",
    id: "heat-1",
  },

  {
    id: "me",
    d: "M449.68 416.677l-1.266 1.79.362 1.098 1.504.275 1.184-1.607-1.784-1.556z",
    id: "heat-1",
  },

  {
    id: "mg",
    d: "M526.988 561.474l-1.842 4.374-3.154 5.566-5.523.396-2.37 2.783.397 8.488-3.423 3.978.396 6.76 2.897 3.312 3.423-.396 3.423-2.524-.787-3.977 7.894-13.657-1.582-1.72 1.582-3.312 1.71.526.527-1.322-1.582-6.76-.924-2.784-1.062.27z",
    id: "heat-1",
  },

  {
    id: "mk",
    d: "M456.643 418.924l-2.912.96.14 2.472.683.873 3.458-1.607-1.367-2.7z",
    id: "heat-1",
  },

  {
    id: "ml",
    d: "M377.584 494.845l2.662-1.823 14.8-.087-3.424-23.806 3.907-.113 18.902 14.428 2.54.362-.958 8.02-11.886 1.08-9.17 6.848-1.67 4.686-6.37.27-1.625-4.677-4.884.346.188-1.53-3.014-4.005z",
    id: "heat-3",
  },

  {
    id: "mm",
    d: "M645.533 501.596l-2.396-3.838 1.737-2.438-1.642-3.018-1.548-.294-.294-5.064-2.316-4.486-.675 1.07-1.548 2.63-1.937.293-.968-1.27-.484-3.414-1.453-2.73-5.913-5.576 1.453-.96.27-4.036 2.16-3.63.935-9.033 3.13-2.135.102-3.293 1.877.622 2.956 4.28-2.194 4.7 1.48 3.69 3.654 1.436.666 4.02 4.91.762-1.357 2.343-6.19 2.438-.673 3.993 4.547 5.844.19 3.12-1.063 1.072.095.977 3.39 4.97.095 5.16-.997 1.796z",
    id: "heat-1",
  },

  {
    id: "mn",
    d: "M597.438 386.215l5.03-6.673 6.043 2.792 4.106 1.098 5.03-4.615-3.414-2.517 2.248-3.172 6.707 2.37 2.325 3.81 4.2.113 2.195-1.633 4.52-.182.986 1.678 7.512.38 4.754-4.85 6.577.69-.38 6.605 2.88.656 3.534-1.606 3.744 1.85-.088.935-2.714.078-2.827 5.93-2.195.217-8.54 11.16-8.723 3.847-5.455.424-4.53-2.923-5.79 3.095-5.705-1.77-1.617-4.142-10.805-.762-5.532-9.377-2.688-.175-1.387-3.33z",
    id: "heat-1",
  },

  {
    id: "mr",
    d: "M364.998 478.266l1.885 2.463-.39 10.65 2.74-1.973 1.953-.397 2.74.985 3.13 4.34 2.938-1.97 14.288-.2-3.526-23.866 3.786-.02-7.054-5.4.01 3.51-8.93.01-.044 6.697-2.567-.01-.328 4.945-10.632.234z",
    id: "heat-2",
  },

  {
    id: "mt",
    d: "M440.815 438.34l-1.443.293.052 1.6 1.297.433.58-.484-.485-1.843z",
    id: "heat-0",
  },

  {
    id: "mu",
    d: "M544.89 584.008l-1.312 1.72.26 1.858 2.767-2.256-1.715-1.322z",
    id: "heat-1",
  },
  {
    d: "M582.396 516.386l.26 2.256 1.442.527.26-1.99-1.962-.794zM584.238 521.156l-.13 2.784 1.055.525.925-1.856-1.85-1.454zM584.506 526.595l-.925.925 1.057.925 1.313-.925-1.444-.925z",
    id: "heat-1",
  },

  {
    id: "mw",
    d: "M487.968 567.074l2.69 2.81-.054 3.597.52 1.515 3.57-3.855-.414-4.9-1.912-1.46-1.7-8.602-2.95-.104 1.34 6.196-1.09 4.804z",
    id: "heat-1",
  },

  {
    id: "mx",
    d: "M133.847 433.982l4.175 13.146-1.945 1.09.216 2.61 3.674 2.826v5.23l4.538 4.355-1.945-12.848-2.593-8.497.648-5.877 2.16.217.866 1.962-.864 5.005 11.237 21.99v7.84l9.077 10.667 9.94 4.572 4.106-2.396 5.835 4.79 3.46-3.484-1.514-3.925 4.97-1.52 1.513.872 1.512-1.522h2.377l4.32-7.624-2.16-1.962-8.428 1.962-1.945 5.662-4.97.874-5.835-2.396-2.593-8.27 1.96-10.435-4.01-2.5-1.91-10.02-1.6-.682-2.92 2.965-3.355-1.79-1.313-6.68-13.286-1.394-6.863-5.16-6.536.342z",
    id: "heat-1",
  },
  {
    id: "mainland heat-3",
    d: "M648.36 511.796l1.735 3.898.39 5.064 2.325 3.604 5.096 3.083 1-.79 1.464-.29-.212-1.91-1.84-4.477-2.698-5.73-.227 1.002-3.25-.146-2.334-3.354-1.45.046z",
  },

  {
    d: "M675.527 526.896l2.61 3.018 10.012-3.467 1.978-7.643 4.46-.32 4.08-2.955-5.29-3.855-1.21-2.12-2.61 4.816.958 2.767-1.59 2.31-3-.77-7.27 5.332.188 3.085-3.317-.2z",
    id: "heat-3",
  },

  {
    id: "mz",
    d: "M482.79 596.36l2.327 1.927 5.48-3.335.88-4.953v-8.18l8.79-7.19 1.507.053 5.322-5.107-.828-10.53-13.81 1.744.52 3.338 2.02 1.757.57 5.73-4.757 4.643-1.14-2.603.207-3.44-2.74-2.973-6.725 3.13 6.258 3.182.21 9.274-4.142 6.146.053 7.385z",
    id: "heat-1",
  },

  {
    id: "na",
    d: "M444.22 603.863l2.898.208 1.702 1.72 4.037.053.984-11.462v-7.502l2.586-.52.986-7.867 6.57-.205 2.322-1.927-3.933-.156-5.324.726-5.74-2.082h-16.13l.416 4.58 5.376 7.918-.934 4.062.053 2.136 4.134 10.32z",
    id: "heat-1",
  },

  {
    id: "nc",
    d: "M798.706 602.576l-.303 1.547 3.983 5.56 2.145.925.304-2.16-6.128-5.872z",
    id: "heat-0",
  },

  {
    id: "ne",
    d: "M413.396 500.17l2.204-.053 1.988-2.98 3.336-.598 3.553 2.17 7.58.215 5.86-2.386 2.205-1.895.164-2.49 4.088-4.122 1.08-9.104-2.688-5.637-6.88-1.677-15.923 12.413-2.256-.218-.97 8.617-8.123.812 4.782 6.928z",
    id: "heat-1",
  },

  {
    id: "ng",
    d: "M413.984 515.185l3.39.164 4.087 4.556 1.988.544 1.558-.76 2.367-.33.805-3.302 3.225-2.117 3.492-.162 6.396-11.766-.103-2.653-2.955-2.274-5.913 2.603-7.91-.112-3.77-2.386-2.688.596-1.4 2.438-.104 6.88-2.256 3.198-.208 4.88z",
    id: "heat-4",
  },

  {
    id: "ni",
    d: "M203.216 491.62l1.893.38.06 3.882-2.204 6.293-5.938-.588-1.323-3.034 1.764-3.682 3.344-3.11 2.402-.14z",
    id: "heat-1",
  },

  {
    id: "nl",
    d: "M421.35 384.572l-3.916 1.928.83.752.087 1.928-.828-.164-.917-1.426-2.188 3.467 3.363.7 1.253 1.322.666.016.44-2.99 2.116-.89-.907-4.644z",
    id: "heat-1",
  },
  {
    id: "mainland heat-1",
    d: "M460.567 327.41l1.747-1.28-.157-1.435-1.106-.64.158-1.755h.95v-.96l-4.123-1.114-6.18.64-.632 2.714-1.428-.477-.95-1.6-3.018.156-.32 3.032-1.426.64-.794-1.6-6.345 5.11 1.272 1.436-2.378 1.115-5.393 10.7-1.9 1.28.155.96 1.9.958-.475 2.075-3.173-.164-.952-1.114-2.057 2.395-1.27.96-.32 2.24-1.106.64-2.854.64-1.426 4.48.95 7.347 1.107 3.354 1.27 1.28 2.853-.156 4.124-3.994 1.58-2.713.48 3.992 2.696-4.79.154-13.424 2.195-1.383.657-7.408 6.654-9.586 3.173-1.116 1.427-1.755 4.754 1.114 2.377 1.435.796-3.993 3.97-2.396 2.387 4.16z",
  },

  {
    d: "M437.056 285.762l-1.426-1.435-3.164 1.54h-5.81l-.916 3.388 3.26 2.878 1.425-.208 2.04-3.49 1.73 1.234-1.23 2.463-.614 3.596 1.428 2.255 3.06-5.135 3.98-4.832-1.532-1.33-2.23-.926zM438.784 279.6l-2.55 2.36 1.53 2.358h2.748l1.124 1.54 3.363 1.745 3.87-2.256 2.654-2.256-.916-1.85-2.654-1.538-1.938 1.746-1.32-1.644-1.022.104-1.322 2.878-1.936-1.954-.208-1.33-1.424.098zM444.593 290.18l-2.04 1.85-1.73 1.332.813 1.435 1.636.51 2.652-1.235 1.23-1.54-1.125-1.85-1.437-.503z",
    id: "heat-1",
  },

  {
    id: "np",
    d: "M595.182 448.79l.397 3.69 6.982 3.162 11.193.83-.423-2.705-7.478-2.058-6.346-3.778-4.326.857z",
    id: "heat-2",
  },
  {
    d: "M804.22 655.73l.918 10.198-1.228 4.634-4.6 3.396.305 4.02v4.322l1.228 1.548 12.577-10.814v-2.472h-3.068l-4.298-14.52-1.833-.313zM795.023 677.98l2.455 4.632-6.752 6.492-.613 3.396-4.6.613-7.667 7.104-7.054-3.396-.613-2.473 12.878-5.558 11.965-10.81z",
    id: "heat-1",
  },

  {
    id: "om",
    d: "M532.244 481.88l6.388-3.684 1.133-5.402-1.4-.804.58-5.792 1.22-.71 1.305 2.05 7.77 4.062v2.258l-9.412 13.854-4.33.147-3.254-5.98z",
    id: "heat-2",
  },

  {
    id: "pa",
    d: "M205.68 506.748l-1.262 3.94 4.167 1.08 2.584.512.44-3.052 2.775-1.4 2.463 1.27.968 1.548 1.175-.138.926-2.81-3.078-1.27-2.334-1.272-2.333 1.59-2.774 1.4-2.835-1.14-.88-.258z",
    id: "heat-0",
  },

  {
    id: "pe",
    d: "M209.518 541.246l-1.677 1.695.114 2.704 14.643 26.694 15.205 9.802 2.35-3.94.563-8.67-1.228-5.402-4.14-6.984-2.464.786-1.115 1.236-4.918-5.636 1.228-6.647 5.705-3.717-.45-3.492-5.808-.226-3.017-5.064-1.677-.562.114 3.044-7.486 8.895-5.593-1.348-.347-3.166z",
    id: "heat-1",
  },
  {
    id: "mainland heat-0",
    d: "M752.132 540.183l-.32 21.126 3.045-.165 4.002-4.676 3.36.163 2.16 1.937.72 5.964 6.88 3.63 1.764-.647v-2.18l-5.523-4.598-2.722-6.294 2.16-1.047-1.6-3.467-3.197-.078-.804-3.71-8.48-5.72-1.444-.242z",
  },

  {
    d: "M778.176 546.008l-.82.19-.5 2.223-1.573 1.022-4.73.83.19 1.78 4.98-.25 3.155-1.972-.188-3.432-.514-.39zM776.093 540.797l-.762 1.08 4.16 3.683.57 2.16 1.132-.13.13-2.22-1.263-1.14-3.967-3.433z",
    id: "heat-0",
  },

  {
    d: "M697.337 496.306l-.743 1.418-.414 1.746-4.132 5.246.25 1.08 1.737-.25 5.368-6-2.066-3.24zM704.027 494.31l-.088 4.33 1.572 1.582.578 3.077 1.574.336.742-1.92-1.236-.915-.328-5.41-2.815-1.08zM708.496 495.978l-.087 3.83.907 1.494 1.57-1.832-.413-3.328-1.978-.164zM709.48 492.64l1.573 2.084.743 1.997h1.41l-.25-3.414-1.574-1.08-1.9.415zM712.542 500.472l.328 2.498-2.896 2.334-2.396.25-2.56 2.75.087 1.252 2.396-.75 1.652-1.08 1.408 3.577 2.48 1.747.994-.338.907-1.08-1.978-1.997 1.16-.916 1.32 1.08.907-1.496-.907-1.833-.164-4.08-2.738-1.918zM699.074 475.076l-2.23 1.58-.25 4.998 3.477 6.742 1.16.915 1.484-1.002 2.56.415.492 2.248 1.9.165.91-1.245-1.16-1.582-1.408-1.33-2.974-.328-1.573-2.585 1.817-2.75.163-2.41-1.236-3.077-3.13-.752zM700.232 489.98l.657 2.334 1.157.752.83-1.08-1.323-1.833-1.322-.174z",
    id: "heat-3",
  },

  {
    id: "pk",
    d: "M553.638 455.082l2.248 3.337-.216 1.72-2.99 1.185-.218 2.8h3.424l1.175-.968h6.52l5.878 5.17.752-2.48h4.383l.104-3.12-4.486-4.306.96-2.368 4.6-.318 6.198-12.924-3.425-2.688-1.278-4.52 8.333-.753-4.917-7-2.62-.71-1.07 1.297-.804.06-4.92 3.12 1.61 2.697-1.816 1.937-2.25 8.29-5.557 3.554-.752 3.882-8.862 3.106z",
    id: "heat-4",
  },

  {
    id: "pl",
    d: "M457.11 390.184l.732 1.348.174 1.435-.604 1.392-1.383 2.663-1.168.526-1.514-.658-.908.043-2.204.83-2.506-.742-4.062-2.88-3.978-2.134-1.6-2.44-.303-5.75 3.112-2.704 4.06-1.35 1.33-.138.314 1.007 1.725.692 4.765.09 1.47-.043 2.42 3.708-.603 1.52.26 1.79.467 1.792z",
    id: "heat-1",
  },

  {
    id: "pr",
    d: "M249.297 482.068l-2.282-.77-1.833 1.15.917 1.07 3.12.458.077-1.908z",
    id: "heat-0",
  },
  {
    id: "mainland heat-1",
    d: "M387.5 421.716l-.537 7.478-1.53 1.384.156.846 1.07 1.772-.69 2.16 1.148.39 2.68-.312-.155-2.16 1.756-10.02-.383-1.383-3.518-.154z",
  },

  {
    d: "M367.834 443.48l-.934 1.186.934 1.185 1.408-.708-1.408-1.66zM337.112 426.713l-1.175 1.184 2.107 1.185.234-1.65-1.166-.72zM343.448 426.004l-1.408.94 1.175.942 1.876-.476-1.642-1.406zM344.382 429.314l-.7 1.892.935 1.185 1.175-.94-1.41-2.136zM350.01 433.092l-.467 1.184.7.71 1.876-1.185-2.11-.708z",
    id: "heat-1",
  },

  {
    id: "py",
    d: "M267.2 584.458l1.9 2.074-.224 4.392 5.48-.338 4.14 5.3-.336 4.728-2.68 4.054-5.48.225-.225-2.256 1.564-3.718-5.37-3.38h-4.468l-3.354-3.605 2.438-6.968 6.613-.51z",
    id: "heat-0",
  },

  {
    id: "bh",
    d: "M524.5 462.4l.3 1.2.9.2.6-1.1-.5-1.3-.9-.2z",
    id: "heat-2",
  },

  {
    id: "qa",
    d: "M527.273 463.018l-.45 3.467 1.332 1.012 1.21-.112.45-4.365-1.048-.752-1.494.75z",
    id: "heat-1",
  },

  {
    id: "ro",
    d: "M457.73 401.28l-.225 1.28-5.005 4.166 4.184 6.137 2.682 1.877h4.823l1.59-1.33 2.135-.277 1.59.96 2.82-3.208-.546-1.607-2.862-.734-1.953-.095.094-2.75-2.594-4.08-6.735-.34z",
    id: "heat-1",
  },

  {
    id: "rs",
    d: "M452 407.28l-1.77 1.33h-.864l-.588 1.833 2.092 2.43.14 1.928-.883 1.247 3.068 3.197 3.317-1.012-.274-4.72-4.237-6.233z",
    id: "heat-1",
  },
  {
    id: "mainland heat-2",
    d: "M722.06 302.16l1.52 5.256 3.044.873 3.042-4.815-1.737-3.285.647-2.845h4.563l-1.09 2.188.434 7.883-6.52 16.2.65 3.5-.217 5.912 12.16 17.73 2.388.656.216-14.443 2.387-2.187-2.61-5.688 2.17-2.412-4.78-6.346-2.61.217-.865-10.503 6.734-1.754.432-3.068 3.478-.873 1.953 1.756 2.385-9.63 4.124-7 3.258-1.756 2.827.217v-3.284l-4.563-.873-6.302-5.256 3.044-3.5-2.61-5.913 2.17-2.187 2.61 3.5 6.518 2.41 7.166.658.873-3.06-3.69-3.718 4.124-5.688-9.345-3.286-2.387 4.814-3.043-3.94-17.158-5.914-16.295 2.844-2.387 1.314v1.313l3.476 1.756-.434 4.158-6.3-2.628-13.9 5.473-2.387-5.03h-9.56l-4.35 4.598-15.42-3.5-14.116 2.844-1.738 4.375 2.17.655-.216 3.285-13.685 1.53.874 4.374-12.604-2.188 3.044-5.688-12.82-.657 1.09 5.914-4.123 1.97-3.475-3.284-14.116 2.412-5.43 5.03-.216 3.06-3.476.217-.433-3.5 11.082-9.63v-6.57l-7.166-1.97-9.344 3.06-3.907-3.942h-1.738l-2.17 4.374 1.737 1.97-12.39 6.788-10.64 8.1-6.52 8.972v3.717l6.95 2.844-3.476 2.627-7.382-2.626-3.044 2.627-4.563-5.255-.873 1.972 4.996 15.758 1.305.44 3.478-1.754 1.737 1.314v2.844l-3.26-1.313-1.954 1.53 1.308 2.843-1.09 7.443-6.733.658-.432-2.412 3.907-2.41.873-6.57-4.35-5.69-1.52-9.845-6.948-1.097-.648 3.5 1.304 1.754-2.825 2.412 1.088 6.57 4.124 1.754.873 4.814-4.133-2.627-10.64-1.97-1.307 3.5-8.473 3.06-1.305-2.186-11.082 6.127-.216 4.16-4.35.656 1.307-3.06v-3.06l-4.35-1.53-2.825 1.098 2.386 4.6 1.737 3.06v2.41l-3.26-.655-.647-.658-3.26 3.5 1.737 3.062-7.383-.217 2.387 3.07-.648 1.312h-3.907l-2.827-1.972-.647-5.472-4.562-1.755v-2.186l9.56 1.972 5.214.44 2.17-3.285-1.954-3.5-13.9-5.472-4.797 1.192-1.64 1.41.51 3.24 2.04.354-.477 5.1 6.293 14.782-4.548 7.21-.312 1.624 2.31 1.625-2.085 1.375-1.382.026.26 6.353 1.91 2.705.026 2.627 2.446.225 3.74 1.426 3.96 5.446.045 1.434-1.288 2.205 2.956-.165 2.878.83 3.892 5.506 9.577.874-.416 6.552-3.3 2.827.682 1.105-3.26 3.502-.864 3.284 1.954 2.845 6.3 2.186 2.612-1.53 16.727 6.346.648-1.756-3.476-3.283v-4.158l-2.17-.657.433-3.5 3.476-4.158-6.23-4.667.43-6.492 6.666-4.382 7.822.44 1.306 2.413 8.04.44 5.87-3.283-3.045-3.285.647-6.13 15.205-7.44 11.695 5.27 3.907-3.5 11.513 10.943 8.688-.873 3.045 3.06 8.255.873 5.43-7.44 6.948 3.067 3.69.658 3.692-3.285-3.26-2.188 2.827-4.374 8.04 2.628 1.735 3.502 3.477.216 2.17-1.53 5.868-.216.647 1.53 6.733.44 4.562-4.814 9.345 1.098 2.827-1.098.864-5.256-2.826-6.346 2.826-2.41h8.904l8.47 10.068 10.858 6.13h3.26l.432-2.628 3.907-2.412.433 14.228-3.475.216v3.5l1.953 2.412-.363 3.13 1.443.597.874-2.188 1.306.44.864.873 3.907-.873 3.905-11.385.434-14.23-4.997-11.384-6.3-7.656-3.045.44v2.412l-7.382-2.845 2.826-6.127 2.387-16.2 9.99-3.06 4.78-3.06h5.213l-1.312 1.755 1.307 2.188 4.563-4.814 2.61.215-.433-2.844-4.132-.873 2.827-10.287 3.737-3.523z",
  },

  {
    d: "M450.108 378.288l-1.296 2.396 4.665.043h.95l-.18-1.352-.727-.854-3.412-.232zM741.137 353.246l-1.07 1.332.086 2.083.992-.085 1.65-2.913-1.658-.416zM776.793 272.303l-2.04 1.33-.483 1.695.96 1.09 2.16-.727 2.16.727 1.202.363-.12-3.994-3.84-.483zM488.54 272.648l1.486.598-1.046 1.798v2.55l-2.23 1.35h-2.377l-1.34-1.65.146-1.8 1.045-1.35h2.084l2.23-1.496zM494.192 270.998v1.798l1.486 1.202 2.083-.146 1.79-1.65v-1.203h-1.635l-1.34.448-1.046-1.2-1.338.75zM502.68 271.152l1.047 2.248 2.084.147 1.487-.596-.742-2.1-1.937-.45-1.937.752zM511.16 268.154l-1.634-.303-1.487 1.505.743 1.35.45 2.1 1.936-1.496.448-1.65-.457-1.506zM520.237 284.05l-.45 2.1-3.424 3-7.294 1.652-5.958 9.897-1.046 2.852 5.957 1.505.89-3.597 1.79-5.55 4.614-2.402 3.872-3 2.825-1.2h1.487v-4.047l-3.265-1.21zM501.04 305.946l4.018.45 1.342 4.65 3.423 3.596-1.193 2.402h-2.083l-1.937-2.248-4.313-.146-1.79-2.403v-1.65l2.683-.753-.15-3.898zM563.855 254.81l-1.938-1.204h-2.23l-.448 1.35-2.378 1.35-1.79.596-.294 1.798 4.167.303 4.91-4.194zM568.463 255.257l-1.047 2.247-2.083-.146-3.276 2.402-.89 3h2.083l1.193-1.953 2.826 2.1 2.68-1.2 1.937-1.65-.744-2.552-1.046-1.798-1.634-.45zM572.784 256.908l1.046 4.2 1.634 3.898 1.79-3.146 3.423-.752v-2.248l-2.23-1.65-5.663-.302zM654.453 250.184l2.326 1.953 1.648-.683.484-2.74-3.39-2.342-2.23 1.47-5.427.492v2.445l-5.724.095v4.002l6.69 4.98 1.748-1.272-.39-3.52 4.27-1.07-.873-1.66-1.547-1.563 2.415-.588zM660.66 247.84l1.547 2.932 6.017-.684 1.65-2.152-.39-1.857-1.65-.685-1.547 1.176-4.46.98-1.167.29zM660.27 259.268l-3.01-.777-1.735 1.858-.778 2.54 4.07-.388 3.105-1.564-1.65-1.668zM738.23 242.37l-2.522-.78-2.904 1.073-1.453 2.15 1.843 2.447 4.85-2.15.968-1.073-.78-1.668zM739.156 358.33v3.664l1.16.415.827-1.333v-2.827l-1.987.08zM705.35 345.086l-.076 5.333 6.69 10.33 2.395 8.988 4.218 7.996 1.65.58 1.408-1.168.657-1.918-6.033-6.578.164-3.416 1.322-.578.33-1.997-11.817-16.736-.91-.838zM751.967 328.516l-1.65.164.994 1.418 2.066 1.418.58-.666-1.99-2.334zM755.183 329.52l.25 1.416 2.56.752.252-1.002-3.062-1.166zM769.23 334.956l1.08 1.937 1.8-.12.36-1.333-3.24-.484zM787.356 337.98l1.442 2.662 1.08-1.21v-1.814l-2.522.362z",
    id: "heat-2",
  },

  {
    id: "rw",
    d: "M479.896 532.93l2.43 2.24-.105 2.395-3.768.077v-2.646l1.444-2.065z",
    id: "heat-1",
  },

  {
    id: "sa",
    d: "M519.812 458.02l6.06 8.444 1.954 1.558.874 3.785 9.327.734 1.055.555-1.046 4.667-6.13 3.613-8.963 2.715-4.78 4.668-5.68-3.312-3.438 3.01-4.79-7.824-3.285-1.504-1.192-1.807v-3.915l-11.954-14.452-.45-2.56h3.44l4.183-3.612.146-1.807-1.192-1.2 2.396-1.954 5.084.302 8.67 7.226 5.116-.232.33 1.263 4.266 1.64z",
    id: "heat-6",
  },
  {
    d: "M783.786 549.882l1.072 2.98 1.892 1.843.57-.51-.19-1.972-2.144-2.603-1.2.262zM789.016 554.324l.13 1.97 1.2 1.142 1.135-.7-1.01-2.102-1.454-.31zM790.528 559.218l-1.012 1.08 1.07 1.97 1.263.382-.06-1.33-1.262-2.102zM792.992 558.076l.882 2.16 1.702 2.03.943-1.52-1.264-2.16-2.264-.51zM797.41 561.317l.5 2.67 1.203 1.65 1.01-2.09-2.714-2.23zM798.792 567.29l-.44.76 1.452 1.912 1.012.062-.632-2.482-1.392-.25zM795.576 571.094l-1.514.7 1.323 1.843 1.133-.64-.942-1.903z",
    id: "heat-0",
  },

  {
    d: "M535.676 548.87l-.525 1.062 1.443 1.192 1.056-1.192-1.974-1.062zM543.05 540.92l-1.583 1.06 1.186 1.858h1.582l-1.186-2.92zM543.706 545.56l-1.055 1.193.787 1.192 1.442.27.13-2.523-1.304-.132z",
    id: "heat-1",
  },
  {
    id: "mainland heat-1",
    d: "M466.144 505.035l-2.55-1.504-2.325-4.59.13-4.27 3.223-2.772.155-10.228 2.127.062-.242-5.68 22.302.198 3.19-3.215 6.88 11.004-3.77 4.44v6.786l-4.6 9.89-1.04 2.3-3.708-5.315-2.708 3.442-3.06.834-9.94-1-4.334 1.54.268-1.92z",
  },

  {
    id: "mainland heat-1",
    d: "M489.336 508.02l-2.04.897.647 3.553h2.542l3.448 5.004-2.767.354-.71 1.288-.068 1.857-8.298-.146-.848-1.288-5.8-.33-10.65-10.96 1.064-.64 4.517-1.365 9.897.754 3.366-.755 2.235-2.996 3.466 4.77z",
  },

  {
    id: "mainland heat-1",
    d: "M445.232 329.52l1.693 1.563h3.173l1.746 3.354.477 5.748-4.277 3.035v3.033l-3.017 4.158-1.746.155-2.378 3.994.155 3.837 4.124 3.035-.318 1.754-1.582 2.396-2.377 2.074.155 6.872-3.647 1.28-1.27 2.712h-1.747l-.95-4.79-3.968-6.083 3.26-5.455.225-13.477 2.248-1.236.545-7.71 6.405-9.172 3.074-1.078z",
  },

  {
    d: "M445.898 368.927l-1.824 1.443.917 2.118 1.617-1.573-.71-1.988z",
    id: "heat-1",
  },

  {
    id: "sg",
    d: "M658.314 527.705l.686.39 1.548-.127-.13-1.167-1.262.2-.842.705z",
    id: "heat-1",
  },

  {
    id: "si",
    d: "M442.708 405.076l-2.195 1.314-4.097.898.82 2.368 2.87.034 2.646-2.213-.044-2.4z",
    id: "heat-1",
  },

  {
    id: "sk",
    d: "M443.607 400.875l.597.527.077.898 6.597-.146 4.875-2.102-.077-2.135-.934.415-1.34-.718-.82-.035-2.16.864-2.94-.71-3.873 3.14z",
    id: "heat-1",
  },

  {
    id: "sl",
    d: "M372.804 509.79l4.884 4.72 3.483-4.227-2.178-3.415-3 .303-3.188 2.62z",
    id: "heat-2",
  },

  {
    id: "sn",
    d: "M372.424 498.77l-5.792-.14 1.072 2.603.596-1.607 7.27.76.807-.027 3.405.12.12-1.505-3.11-3.733-3.467-4.693-2.152-.9-1.66.425-3.406 2.472-.776 1.384-.24 1.384 1.252.9 4.185-.062 2.688-.728.303 1.322-.24 1.746-.854.28z",
    id: "heat-3",
  },
  {
    id: "mainland heat-2",
    d: "M526.703 501.94l3.777-1.45 1.34.803-.147 3.354-3.482 9.923-18.853 20.19-2.187-1.503-.147-8.52 2.835-3.26 6.018-1.858 8.824-9.32 2.31-2.057.647-3.008-.934-3.294z",
  },

  {
    id: "mainland heat-2",
    d: "M512.674 502.797l3.526 2.403 1.046-.052 8.757-3.008.994 3.206-.7 2.706-1.894 1.503-4.73-.302-6.768-4.158-.23-2.298z",
  },

  {
    id: "sr",
    d: "M268.384 516.715l1.763 1.616 2.73-1.693 2.49.078-.32.968-1.045 2.18-.164 5.42-4.97 2.022.242-3.476-3.207-2.992.164-1.538 2.317-2.585z",
    id: "heat-1",
  },
  {
    d: "M421.91 530.554l.994-.502.743.604-.743 1.148-.9-.354-.093-.896zM423.907 527.398l1.496-.25.5.95-.742.805-.742-.104-.51-1.402z",
    id: "heat-0",
  },

  {
    id: "sv",
    d: "M189.308 495.217l4.062 2.022-.06-3.208-2.084-1.27-1.918 2.455z",
    id: "heat-0",
  },

  {
    id: "sy",
    d: "M487.545 437.18l-.302 2.196 2.437 1.02-.104 6.087 2.438-.053 2.438-1.842.916-.155 5.532-4.398 1.114-6.39-11.056 1.125-1.167 2.56-2.245-.15z",
    id: "heat-3",
  },

  {
    id: "sz",
    d: "M482.53 596.983l-2.168.36-.935 2.553 1.66 1.513h2.014l1.703-2.447-2.272-1.98z",
    id: "heat-0",
  },

  {
    id: "td",
    d: "M440.97 494.983l.113-2.552 4.098-3.982 1.1-9.785-2.73-5.22 1.91-.98 18.498 9.64-.113 9.455-3.26 2.775v4.875l2.137 4.132h-3.77l-6.24 6.173-.165 1.867-4.605-.06-.06.845-2.63-.345-1.797-3.397-1.35-.666.173-1.037 1.693-1.297v-6.066l-2.342-.363-2.826-2.102 2.17-1.91z",
    id: "heat-2",
  },

  {
    id: "tg",
    d: "M408.495 516.81l2.316-1.356-.052-8.946-1.504-2.438-.967.812.208 11.928z",
    id: "heat-2",
  },

  {
    id: "th",
    d: "M646.043 472.915l2.8 3.604v4.383l.968.482 4.453-2.144.873.295 5.316 6.138-.19 4.192-1.737-.294-1.548-.978-1.158.097-2.032 3.403.39 1.85 1.642.874-.095 2.05-1.157.587-3.97-2.73v-2.44l-1.642-.094-.674 1.07-.347 10.91 2.567 4.685 4.547 4.383-.19 1.27-2.422-.093-2.22-3.31h-2.326l-2.902-2.346-.874-2.438 1.254-2.05.432-1.85 1.366-2.42-.06-5.566-3.338-4.823-.14-.588 1.082-1.09-.25-3.83-4.442-5.626.52-3.242 5.503-2.323z",
    id: "heat-3",
  },

  {
    id: "tj",
    d: "M559.74 422.234l3.552-4.408h1.34l.467.984-1.643 1.192v.985l1.08.777 5.196.312 1.693-.727.77.153.52 1.66 3.085.312 1.55 3.267-.468.985-.614.053-.612-1.245-1.34-.104-2.316.313-.156 2.18-2.316-.155.104-2.75-1.694-1.658-2.575 2.125.053 1.4-2.265.778h-1.34l.104-4.824-2.174-1.606z",
    id: "heat-1",
  },

  {
    id: "tm",
    d: "M528.328 418.56l-.535 2.274h-3.588v3.078l3.854 2.54-1.192 3.483v1.608l1.6.27 2.126-2.812 4.79-1.07 10.233 3.882.13 2.81 5.713.535 6.38-6.698-.796-2.146-4.253-.935-11.963-7.772-.535-2.81h-4.52l-1.998 3.753h-1.997l-3.45.01z",
    id: "heat-1",
  },

  {
    id: "tn",
    d: "M425.516 435.624l4.78-1.927 1.572 1.02.06 1.244-.733.96.11 1.703.736.396v3.06l-.846 1.418.11.908 3.208 1.132-2.584 4.02-1.012-.06-.173 3.23-1.124.175-.96-.85.225-3.283-3.146-3.06-.398-2.663 1.52-1.192-1.346-6.23z",
    id: "heat-1",
  },

  {
    id: "tr",
    d: "M472.812 421.906l-2.305-1.426-1.27-1.013-2.14.916-1.476 3.74 2.22-.5 1.562-1.188 3.438.938-1.946 1.877-5.175-.25-1.91 2.093v1.02l1.22 1.022v1.123l-.512 1.332.51 1.123 1.626-.812 1.625 1.738-.407 1.228-.604.82.906 1.02 4.46.917 3.14-1.33v-1.938l1.52.303 3.65 2.144 3.947-.614 1.72-1.633 1.115.406v1.842h1.52l1.314-2.55 11.55-1.23 5.04-.612-1.332-1.746-.025-2.36 1.01-1.21-3.68-2.955.196-2.552h-2.02l-3.355-1.643-1.93 2.04-7.087-.208-4.253-2.55-4.082.367-4.544 2.73-3.238-.418z",
    id: "heat-2",
  },

  {
    id: "tt",
    d: "M258.97 502.572l-.917.847-.994.154v1.228l1.832 1.687.76-1.23.458-1.383-.156-1.15-.984-.155z",
    id: "heat-1",
  },

  {
    id: "tw",
    d: "M695.686 453.76l-3.06 2.334-.163 4.494 2.646 3.078.655-.58-.08-9.326z",
    id: "heat-1",
  },

  {
    id: "tz",
    d: "M492.22 560.017l13.797-1.69-3.395-6.57-.182-6.29 1.098-3.01-14.367-9.023-4.5.743-1.565 1.158-.14 2.637-1.01 3.656-1.056 1.253-1.515.142 2.81 9.418 4.815 2.838 4.195.1 1.015 4.64z",
    id: "heat-2",
  },

  {
    id: "ua",
    d: "M460.662 388.79l-2.507 1.41.622 2.663-2.316 4.884.02 2.15 1.09.692 6.983.345 1.954-1.615 2.092.7 2.998 4-2.194 3.943 2.61.76 3.414-3.932 1.954.355 1.815 1.262-1.6 2.11 2.16 3.37h2.3l1.184-2.248 2.44-.495.068-1.823-4.53-.7.14-1.963h4.392l4.737-3.795 2.092-1.824.344-5.756-9.336-.838-3.83-5.402-2.645-.908-3.207.14-1.443 3.568-6.57.087-2.135-.985-3.096-.154z",
    id: "heat-1",
  },

  {
    id: "ug",
    d: "M480.31 532.23l2.62 2.454 1.643-1.045 4.442-.73.762.08.284-1.688 2.51-5.272-2.11-4.392-6.837.044-.043 1.808.917.882-.14 1.807-4.046 6.05z",
    id: "heat-2",
  },
  {
    id: "mainland heat-1",
    d: "M143.59 375.99l-.866 3.474-3.017-1.954h-1.504l-.865 3.69-10.554 23.65 2.8 20.607 3.45 1.737.648 5.645h7.105l6.89 5.203 13.56 1.305 1.505 6.94 2.152 1.522 3.017-3.033 2.37 1.08 2.152 9.976 3.656 2.386 3.017-5.646 9.258-6.726 6.025 2.817 5.17.433.215-3.25 10.762.217 2.152 2.386.432 5.42-1.29 3.035 1.505 5.203h3.233l3.232-4.987-1.288-2.385-1.288-5.204 1.936-5.86 8.826-7.59 6.673-1.952-.865-6.293 9.258-9.983 9.258-1.52-1.503-5.194 9.042-5.205v-6.94l-.866-.433-3.233 1.082-.43 4.252-10.746.13-8.42 5.593-13.216 4.322-2.11-2.587 6-9.076-2.965-2.826-2.014-3.837-4.176-3.354-4.538-.38-8.575-5.853-60.97-10.038z",
  },

  {
    d: "M74.79 285.234l2.992 5.594 1.92-.432v-1.938l-4.91-3.224zM57.926 334.428l-.147 2.602 1.866-.432v-1.158l-1.72-1.012zM55.057 335.586l-3.734 1.885.58 2.023 1.434-1.158 2.87-1.306-1.15-1.444zM39.54 338.042l-2.583-.58-.432 1.16.285 2.168 2.73-2.748zM34.078 337.902l-2.446-1.01-.865 1.59 1.582 1.59 1.728-2.17zM95.485 277.922l-7.252 1.72 1.496 8.17 7.89 2.15.424 1.72-11.73 3.657L79.7 306.3l2.344 11.608 3.838 2.576 2.99-2.793.857 1.722-3.63 4.296-14.083 6.45-8.964 2.15-.216 3.225 20.694-6.016 8.533-2.37 7.892-9.673 8.748-5.8-4.478 7.52 4.91.648 8.324-3.656 1.495 6.017 5.757 1.288 5.973 5.8.423 4.297-.855 1.072 1.063 4.08h1.496l.216-6.882h1.703l.424 16.977 4.27-3.657-2.99-17.625h-4.478l-4.91-6.23 24.108-40.845-23.892-18.696-26.667 5.16-1.063 8.17 5.757 3.438-2.136 5.594-7.67-6.222z",
    id: "heat-1",
  },

  {
    id: "uy",
    d: "M274.633 612.48l-1.773 1.895.735 10.183 5.566 1.615 7.08-7.097-11.607-6.595z",
    id: "heat-1",
  },

  {
    id: "uz",
    d: "M558.643 428.477l2.662.138v-4.556l-2.522-1.47 4.253-5.36h1.73l1.728 2.016 4.52-1.738-6.25-2.144-.24-1.297-1.486.363-1.46 2.54-6.303-.206-4.625-6.543-8.125.804-3.872-3.838-5.358-.906-3.89 1.582 2.256 7.502.025 2.524 1.643.035 2.014-3.84 5.36.07.795 2.946 11.487 7.624 4.442 1.02 1.217 2.733z",
    id: "heat-1",
  },
  {
    d: "M258.823 496.582l-1.063.77.84 1.54 1.373-.77-1.15-1.54zM257.526 499.573l-.994.994.38.612h1.22l.38-1.004-.986-.603z",
    id: "heat-0",
  },

  {
    id: "ve",
    d: "M231.5 503.558l.38 2.24 2.81.89.64-4.123 2.964-3.068 2.965 3.475 6.82 1.86 5.773-1.212 3.933 4.85 2.965 1.857-3.25 4.953 1.09 3.752-1.858 2.3-1.928 1.615-4.175-2.102-.96.97v2.99l3.052 1.45-2.248 2.43-2.248 2.43-2.965-.24-2.98-3.276-.632-12.327-10.183-3.476-1.85-5.42 1.885-2.82z",
    id: "heat-1",
  },

  {
    id: "vn",
    d: "M659.035 502.287l1.027 1.616.19 1.85 2.705.295 3.286-4.383 3.095-.873 1.643-4.478-.77-7.21-3.19-4.383-3.36-2.687-4.28-7.35 3.07-5.134-4.394-5.04-3.517-.154-3.165 1.702.942 4.07 4.22.744 1.132 3.138-1.488.97.096.776 9.896 9.683.388 2.843-.595 8.99-6.932 5.014z",
    id: "heat-0",
  },
  {
    d: "M811.006 582.48l-1.07 1.434.45 1.616.534.362.98-1.262-.894-2.15zM811.542 586.88l.087 1.166 1.157.363.805-.45-.805-1.264-1.245.183zM813.236 597.303l-.536.812.804.897 1.34-.448-1.608-1.26z",
    id: "heat-0",
  },
  {
    id: "mainland heat-5",
    d: "M509.432 489.13l1.244 3.7v3.614l2.99 2.714 21.075-8.584.2-2.36-3.382-6.066-8.48 2.706-4.865 4.787-5.645-3.335-3.136 2.826z",
  },

  {
    d: "M533.315 498.138l1.842 2.06 2.49-1.505.896-.304-1.14-1.106-2.19.647-1.898.208z",
    id: "heat-5",
  },

  {
    id: "za",
    d: "M476.73 588.02l-6.828 6.31-1.625 3.9-5.41-.675-4.504 4.002-2.99-.294.24-5.53-1.062-.373-.742 11.314-5.308-.052-1.6-1.886-2.344-.024 2.137 6.13 3.812 3.603-2.723 3.172 1.764 3.977 4.08 1.558 3.25-2.767 9.31.053.668-.83 4.132-.728 13.978-13.917-.053-4.382-1.494 1.938h-2.238l-2.723-2.282 1.383-3.44 2.378-.482-.217-7.07-5.27-1.224zm-3.275 15.99l1.306-.05 2.12 2.298-.062 2.662-2.48 1.253-.156.883-3.785.043-1.186-2.854 1.082-2.092 3.163-2.143z",
    id: "heat-1",
  },

  {
    id: "zm",
    d: "M459.78 571.656l2.74 3.802 4.243.26 1.504.83 4.443.053 3.83-5.366 10.7-4.79.935-4.218-1.244-6.043-5.583-3.18-3.727.26-1.857 4.113.053 1.876 4.39 2.136.26 4.642-3.774.208-.935-1.564-10.495-4.48-.31 3.44-4.963.156-.21 7.866z",
    id: "heat-0",
  },

  {
    id: "zw",
    d: "M468.52 578.226l7.755 8.757 5.946 1.513 3.985-6.248-.312-8.28-6.465-3.338-2.43 1.098-3.62 5.524-5.015-.053.157 1.026z",
    id: "heat-1",
  },
];
